function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useMutation, useQuery, useLazyQuery } from "@apollo/client";
import classNames from "classnames";
import * as Yup from "yup";
import moment from "moment-timezone";
import React from "react";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Field, Form as FormikForm, Formik } from "formik";
import Form from "react-bootstrap/Form";
import Table from "react-bootstrap/Table";
import FormGroup from "react-bootstrap/FormGroup";
import "react-datepicker/dist/react-datepicker.css";
import { Chart } from "react-google-charts";
import { FilterContext, UserContext, SearchContext } from "../index";
import { randomColor, getBWColor, convertSecToHours, colors, convertSecToHoursAndMinutesWithTextShortForm, isRateLimited, rateLimitMessage } from "../utils";
import { MdPersonOutline } from "react-icons/md";
import { IoMdTime } from "react-icons/io";
import { FiFlag } from "react-icons/fi";
import { GoClock } from "react-icons/go";
import { FiClock } from "react-icons/fi";
import "./ProjectDetails.css";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { ADD_TASK_DETAILS_MUTATION, PROJECT_TASKS_QUERY, UPDATE_TASK_STATUS_MUTATION, PROJECT_DETAILS_SUMMARY_QUERY, PROJECT_EMPLOYEE_WORKED_HOUR_QUERY, TASK_DETAILS_QUERY, TASK_EMPLOYEE_TIMELINE_QUERY, TASK_ACTIVITY_SUMMARY_QUERY, PROJECT_TASKS_EXPORT_QUERY, QUICK_EDIT_TASK_STATUS_MUTATION, QUICK_EDIT_TASK_ESTIMATION_MUTATION, QUICK_EDIT_TASK_DUE_DATE_MUTATION, QUICK_EDIT_TASK_PRIORITY_MUTATION, QUICK_EDIT_TASK_MEMBER_MUTATION, QUICK_DELETE_TASK_MUTATION, UPDATE_PROJECT_ESTIMATED_BUDGET_MUTATION, PROJECT_LISTING_QUERY, PROJECT_EMPLOYEE_WORKED_HOUR_EXPORT_QUERY, RATE_DETAILS_SUMMARY_QUERY, SET_RATE_MUTATION, PROJECT_EMPLOYEE_WISE_EARNING_QUERY, TASK_WISE_COST_ANALYSIS_QUERY, GET_TASK_TRACKER_QUERY, PROJECT_BUDGET_DETAILS_SUMMARY_QUERY, PROJECT_PRIORITY_DETAILS_SUMMARY_QUERY, PROJECT_PERSON_WISE_TASK_STATUS_QUERY, PROJECT_EMPLOYEE_WISE_EARNING_EXPORT_QUERY } from "./query.js";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import SearchBar from "../SearchBar";
import Dropdown from "react-bootstrap/Dropdown";
import { ProjectModal, DeleteProjectModal, ArchiveProjectModal } from "./EditProject";
import { EDIT_PROJECT_AND_DELETE_PROJECT_MUTATION, MY_PROJECTS_QUERY, PROJECT_USER_DETAILS_DATA_QUERY, MY_PROJECT_HEADER_QUERY } from "./../MyProjects/query";
import { ORGANISATION_CURRENCY_SETTING_QUERY } from "./../Employees/query";
import Loader from "./../Loader/Loader";
import { arrayToStringOutput } from "./../SideMenu/Header";
// import { PROJECT_LISTING_QUERY } from "./../SideMenu/query";
import { Helmet } from "react-helmet";
import ProjectSideMenu from "../SideMenu/ProjectSideMenu";
import { GET_MANUAL_LISTING_QUERY, GET_FILTER_TASK_TRACKER_DETAILS_QUERY, TASK_USERS_QUERY, TASK_COUNT_QUERY } from "./../ManualPages/query";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { AddTaskModal } from "./../ManualPages/ProjectAndTaskList.js";
import DatePicker from "react-datepicker";
import Popover from "react-bootstrap/Popover";
import Badge from "react-bootstrap/Badge";
import { HiOutlineDotsVertical } from "react-icons/hi";
import { EDIT_TASK_DETAILS_MUTATION, DELETE_TASK_MUTATION } from "./../TaskDetails/query";
import ControlLabel from "react-bootstrap/FormLabel";
import Accordion from "react-bootstrap/Accordion";
import { MdCheck, MdEdit, MdDelete, MdArchive } from "react-icons/md";
import { VscLoading } from "react-icons/vsc";
import { UPDATE_PROJECT_ESTIMATED_TIME_MUTATION, MY_PROJECT_SUMMARY_QUERY } from "./../MyProjects/query";
import InputGroup from "react-bootstrap/InputGroup";
import FormControl from "react-bootstrap/FormControl";
import { HiLockClosed, HiUpload, HiChartBar, HiDownload } from "react-icons/hi";
import { MdEventAvailable, MdAccessTime, MdTrendingUp, MdFormatListBulleted } from "react-icons/md";
import { PROJECTS_LISTING_QUERY, PROJECTS_LISTING_FOR_FILTER_QUERY } from "./../ManualPages/query";
import { TaskDetailsModal, ManualTaskDetailsModal } from "./TaskDetailsModal.js";
import { Budget } from "./BudgetFinances.js";
import { FiMaximize } from "react-icons/fi";
import Excel from "exceljs/dist/es5/exceljs.browser";
import { saveAs } from "file-saver";
import { read, utils } from "xlsx";
import { ProjectEnableSection } from "./../MyProjects/MyProjects";
import { IoMdArrowBack } from "react-icons/io";
import Select from "react-select";
import { BsUpload, BsKanban } from "react-icons/bs";
import { FiDownload, FiMoreHorizontal, FiCheckSquare, FiUsers, FiTarget, FiCalendar, FiEdit, FiSettings, FiPaperclip, FiDollarSign } from "react-icons/fi";
import ProgressBar from "react-bootstrap/ProgressBar";
import { BiDollar } from "react-icons/bi";
import { RiDeleteBinLine, RiTimerLine, RiFileChartLine } from "react-icons/ri";
import { FaRegChartBar } from "react-icons/fa";
import { MultiSelect } from "react-multi-select-component";
import { TimeFilter } from "./DateFilter";
export var taskStatusList = [{
  value: "active",
  label: "Active"
}, {
  value: "completed",
  label: "Completed"
}];
export var taskStatusProgressList = [{
  value: "in-progress",
  label: "In Progress"
}, {
  value: "completed",
  label: "Completed"
}, {
  value: "hold",
  label: "On Hold"
}];
export var taskStatusToDoList = [{
  value: "todo",
  label: "To Do"
}, {
  value: "completed",
  label: "Completed"
}, {
  value: "hold",
  label: "On Hold"
}];
export var taskStatusOnDueList = [{
  value: "onDue",
  label: "On Due"
}, {
  value: "completed",
  label: "Completed"
}, {
  value: "hold",
  label: "On Hold"
}];
export var taskStatusCompletedList = [{
  value: "To Do",
  label: "To Do"
}, {
  value: "completed",
  label: "Completed"
}, {
  value: "hold",
  label: "On Hold"
}];
export var overWorkedList = [{
  value: "overWorked",
  label: "Over Worked"
}, {
  value: "completed",
  label: "Completed"
}, {
  value: "hold",
  label: "On Hold"
}];
export var taskStatusWithOutCompletedList = [{
  value: "To Do",
  label: "To Do"
}, {
  value: "hold",
  label: "On Hold"
}];
export var taskPriorityList = [{
  value: "low",
  label: "Low"
}, {
  value: "medium",
  label: "Medium"
}, {
  value: "high",
  label: "High"
}];
var taskPriority = [{
  label: "Low",
  value: "low"
}, {
  label: "Medium",
  value: "medium"
}, {
  label: "High",
  value: "high"
}];
var LIMIT = 25;
var offsets = 0;
var TASK_LIMIT = 25;
var TASK_OFFSETS = 0;
var EMPLOYEE_LIMIT = 10;
var TASK_EMP_LIMIT = 10;
var TASK_EMP_OFFSETS = 0;
var clickedIndex = 0;
var QuickEidtEstimationSchema = Yup.object().shape({
  taskTime: Yup.string().trim().required("Required")
});
var ProjectDetails = function ProjectDetails(props) {
  var _props$match, _user$organisations, _organisationDetails$, _summaryData$projectS, _summaryData$projectS2, _summaryData$projectS3, _currenciesData$getOr, _summaryData$projectS4, _summaryData$projectS5, _summaryData$projectS6, _summaryData$projectS7, _summaryData$projectS8, _summaryData$projectS9, _summaryData$projectS10, _summaryData$projectS11, _currenciesData$getOr2, _summaryData$projectS12, _summaryData$projectS13, _summaryData$projectS14, _summaryData$projectS15, _summaryData$projectS16, _summaryData$projectS17, _summaryData$projectS18, _summaryData$projectS19, _summaryData$projectS20, _summaryData$projectS21, _summaryData$projectS22, _summaryData$projectS23, _summaryData$projectS24;
  var Link = props.linkComponent,
    linkProps = props.linkProps,
    location = props.location;
  var _props$match$params = props === null || props === void 0 ? void 0 : (_props$match = props.match) === null || _props$match === void 0 ? void 0 : _props$match.params,
    projectId = _props$match$params.projectId;
  var history = props === null || props === void 0 ? void 0 : props.history;
  var _React$useContext = React.useContext(FilterContext),
    organisationId = _React$useContext.organisationId,
    teamId = _React$useContext.teamId,
    startDate = _React$useContext.startDate,
    endDate = _React$useContext.endDate,
    organisationSettings = _React$useContext.organisationSettings,
    role = _React$useContext.role,
    from = _React$useContext.from,
    organisationBilling = _React$useContext.organisationBilling;

  // React.useEffect(() => {
  //   if (from == "web" && role == "Member") {
  //     props?.history.push("/my-work");
  //   }
  // }, [role]);

  React.useEffect(function () {
    if (role === "Member" && !organisationSettings.projectManagementFeature) {
      props === null || props === void 0 ? void 0 : props.history.push("/my-work");
    }
  }, [role]);
  var _React$useState = React.useState(true),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    projectDetailFetch = _React$useState2[0],
    setProjectDetailFetch = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isQuickEditCheck = _React$useState4[0],
    setIsQuickEditCheck = _React$useState4[1];
  var _React$useState5 = React.useState([]),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    taskActive = _React$useState6[0],
    setTaskActive = _React$useState6[1];
  var _React$useState7 = React.useState(null),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    isQuickEditModal = _React$useState8[0],
    setIsQuickEditModal = _React$useState8[1];
  var _React$useState9 = React.useState(null),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    isQuickEditMemberModal = _React$useState10[0],
    setIsQuickEditMemberModal = _React$useState10[1];
  var _React$useState11 = React.useState([]),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    toDoTaskActive = _React$useState12[0],
    setToDoTaskActive = _React$useState12[1];
  var _React$useState13 = React.useState([]),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    inProgessTaskActive = _React$useState14[0],
    setInProgessTaskActive = _React$useState14[1];
  var _React$useState15 = React.useState([]),
    _React$useState16 = _slicedToArray(_React$useState15, 2),
    overDueTaskActive = _React$useState16[0],
    setOverDueTaskActive = _React$useState16[1];
  var _React$useState17 = React.useState([]),
    _React$useState18 = _slicedToArray(_React$useState17, 2),
    completedTaskActive = _React$useState18[0],
    setCompletedTaskActive = _React$useState18[1];
  var _React$useState19 = React.useState([]),
    _React$useState20 = _slicedToArray(_React$useState19, 2),
    holdTaskActive = _React$useState20[0],
    setHoldTaskActive = _React$useState20[1];
  var _React$useState21 = React.useState("taskList"),
    _React$useState22 = _slicedToArray(_React$useState21, 2),
    quickEditType = _React$useState22[0],
    setQuickEditType = _React$useState22[1];
  var _React$useState23 = React.useState([]),
    _React$useState24 = _slicedToArray(_React$useState23, 2),
    quickEditWorkingStatus = _React$useState24[0],
    setQuickEditWorkingStatus = _React$useState24[1];
  var _React$useState25 = React.useState([]),
    _React$useState26 = _slicedToArray(_React$useState25, 2),
    quickEditToDoWorkingStatus = _React$useState26[0],
    setQuickEditToDoWorkingStatus = _React$useState26[1];
  var _React$useState27 = React.useState([]),
    _React$useState28 = _slicedToArray(_React$useState27, 2),
    quickEditInProgressWorkingStatus = _React$useState28[0],
    setQuickEditInProgressWorkingStatus = _React$useState28[1];
  var _React$useState29 = React.useState([]),
    _React$useState30 = _slicedToArray(_React$useState29, 2),
    quickEditDueWorkingStatus = _React$useState30[0],
    setQuickEditDueWorkingStatus = _React$useState30[1];
  var _React$useState31 = React.useState([]),
    _React$useState32 = _slicedToArray(_React$useState31, 2),
    quickEditCompletedWorkingStatus = _React$useState32[0],
    setQuickEditCompletedWorkingStatus = _React$useState32[1];
  var _React$useState33 = React.useState([]),
    _React$useState34 = _slicedToArray(_React$useState33, 2),
    quickEditHoldWorkingStatus = _React$useState34[0],
    setQuickEditHoldWorkingStatus = _React$useState34[1];
  var _React$useState35 = React.useState("select"),
    _React$useState36 = _slicedToArray(_React$useState35, 2),
    isQuickEditSelect = _React$useState36[0],
    setIsQuickEditSelect = _React$useState36[1];
  var _React$useState37 = React.useState("select"),
    _React$useState38 = _slicedToArray(_React$useState37, 2),
    isQuickEditToDoSelect = _React$useState38[0],
    setIsQuickEditToDoSelect = _React$useState38[1];
  var _React$useState39 = React.useState("select"),
    _React$useState40 = _slicedToArray(_React$useState39, 2),
    isQuickEditInProgressSelect = _React$useState40[0],
    setIsQuickEditInProgressSelect = _React$useState40[1];
  var _React$useState41 = React.useState("select"),
    _React$useState42 = _slicedToArray(_React$useState41, 2),
    isQuickEditDueSelect = _React$useState42[0],
    setIsQuickEditDueSelect = _React$useState42[1];
  var _React$useState43 = React.useState("select"),
    _React$useState44 = _slicedToArray(_React$useState43, 2),
    isQuickEditCompletedSelect = _React$useState44[0],
    setIsQuickEditCompletedSelect = _React$useState44[1];
  var _React$useState45 = React.useState("select"),
    _React$useState46 = _slicedToArray(_React$useState45, 2),
    isQuickEditHoldSelect = _React$useState46[0],
    setIsQuickEditHoldSelect = _React$useState46[1];
  var _React$useState47 = React.useState("listView"),
    _React$useState48 = _slicedToArray(_React$useState47, 2),
    activeTab = _React$useState48[0],
    setActiveTab = _React$useState48[1];
  var _React$useState49 = React.useState("task"),
    _React$useState50 = _slicedToArray(_React$useState49, 2),
    tableAndBudgetView = _React$useState50[0],
    setTableAndBudgetView = _React$useState50[1];
  var _React$useContext2 = React.useContext(UserContext),
    user = _React$useContext2.user;
  var _React$useState51 = React.useState(null),
    _React$useState52 = _slicedToArray(_React$useState51, 2),
    addTaskShow = _React$useState52[0],
    setAddTaskShow = _React$useState52[1];
  //const { search, setSearch } = React.useContext(SearchContext);
  var _React$useContext3 = React.useContext(SearchContext),
    projectSearch = _React$useContext3.search,
    setSearch = _React$useContext3.setSearch;
  var organisationDetails = (user === null || user === void 0 ? void 0 : (_user$organisations = user.organisations) === null || _user$organisations === void 0 ? void 0 : _user$organisations.find(function (organisation) {
    return organisation.id === organisationId;
  })) || {};
  var teamDetails = (organisationDetails === null || organisationDetails === void 0 ? void 0 : (_organisationDetails$ = organisationDetails.teams) === null || _organisationDetails$ === void 0 ? void 0 : _organisationDetails$.find(function (team) {
    return team.id === teamId;
  })) || {};
  //const role = teamDetails?.role?.roleName;

  var _useQuery = useQuery(PROJECT_LISTING_QUERY, {
      variables: {
        organisationId: organisationId,
        url: user === null || user === void 0 ? void 0 : user.uniqueUrl,
        role: role
      },
      skip: !organisationId
    }),
    projectTabsData = _useQuery.data,
    projectTabsError = _useQuery.error,
    projectTabsLoading = _useQuery.loading;
  var _useQuery2 = useQuery(ORGANISATION_CURRENCY_SETTING_QUERY, {
      variables: {
        organisationId: organisationId
      },
      skip: !organisationId
    }),
    currenciesData = _useQuery2.data,
    currenciesError = _useQuery2.error,
    currenciesLoading = _useQuery2.loading,
    currenciesRefetch = _useQuery2.refetch;
  var _useQuery3 = useQuery(PROJECT_DETAILS_SUMMARY_QUERY, {
      variables: {
        projectId: projectId,
        organisationId: organisationId,
        teamId: teamId,
        startDate: moment(startDate).format("YYYY-MM-DD"),
        endDate: moment(endDate !== null && endDate !== void 0 ? endDate : startDate).format("YYYY-MM-DD"),
        timezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
        role: role,
        userUrl: user === null || user === void 0 ? void 0 : user.uniqueUrl
      }
    }),
    summaryData = _useQuery3.data,
    summaryError = _useQuery3.error,
    summaryLoading = _useQuery3.loading,
    projectSummaryRefetch = _useQuery3.refetch;
  var _useQuery4 = useQuery(PROJECT_USER_DETAILS_DATA_QUERY, {
      variables: {
        organisationId: organisationId,
        projectId: projectId
      },
      skip: !organisationId
    }),
    projectUsersData = _useQuery4.data,
    projectUsersError = _useQuery4.error,
    projectUsersLoading = _useQuery4.loading;

  // const [getProjectDetails, { data, error, loading }] = useLazyQuery(PROJECT_DETAILS_QUERY, {
  //   variables: {
  //     projectId,
  //     organisationId,
  //     teamId,
  //     startDate: moment(chartStartDate).format("YYYY-MM-DD"),
  //     endDate: moment(chartEndDate ?? chartStartDate).format("YYYY-MM-DD"),
  //     timezone: organisationSettings?.organisationTimezone,
  //   },
  //   fetchPolicy: "network-only",
  //   skip: !teamId && !organisationId,
  // });

  var _useLazyQuery = useLazyQuery(PROJECT_EMPLOYEE_WORKED_HOUR_QUERY, {
      variables: {
        projectId: projectId,
        organisationId: organisationId
      },
      fetchPolicy: "network-only",
      skip: !organisationId
    }),
    _useLazyQuery2 = _slicedToArray(_useLazyQuery, 2),
    getEmployeeDetails = _useLazyQuery2[0],
    _useLazyQuery2$ = _useLazyQuery2[1],
    employeesData = _useLazyQuery2$.data,
    employeesError = _useLazyQuery2$.error,
    employeesLoading = _useLazyQuery2$.loading;
  React.useEffect(function () {
    if (summaryLoading || summaryError) return;
    if (!summaryData) return;
    if (!summaryLoading && summaryData !== null && summaryData !== void 0 && summaryData.projectSummaryDetails && projectDetailFetch) {
      //getProjectDetails();
      getEmployeeDetails();
    }
  }, [summaryData === null || summaryData === void 0 ? void 0 : summaryData.projectSummaryDetails]);
  React.useEffect(function () {
    projectSummaryRefetch === null || projectSummaryRefetch === void 0 ? void 0 : projectSummaryRefetch();
    setProjectDetailFetch(true);
    setTaskActive([]);
    setToDoTaskActive([]);
    setInProgessTaskActive([]);
    setOverDueTaskActive([]);
    setCompletedTaskActive([]);
    setHoldTaskActive([]);
    setActiveTab("listView");
    currenciesRefetch === null || currenciesRefetch === void 0 ? void 0 : currenciesRefetch();
    setTableAndBudgetView("task");
  }, [props.location.key]);
  if (summaryLoading) {
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  if (summaryError) {
    z;
    return /*#__PURE__*/React.createElement("div", {
      className: "common-err-refresh-text"
    }, "Something went wrong, please refresh the page.");
  }
  var handleWholeTabSelect = function handleWholeTabSelect(key) {
    setTableAndBudgetView(key);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "project-details-root"
  }, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("title", null, "Workfolio | Project Details | ".concat(summaryData === null || summaryData === void 0 ? void 0 : (_summaryData$projectS = summaryData.projectSummaryDetails) === null || _summaryData$projectS === void 0 ? void 0 : (_summaryData$projectS2 = _summaryData$projectS.projectDetailsSummary) === null || _summaryData$projectS2 === void 0 ? void 0 : _summaryData$projectS2.projectName))), !organisationSettings.projectManagementFeature ? /*#__PURE__*/React.createElement(ProjectEnableSection, {
    user: user,
    organisationId: organisationId,
    organisationSettings: organisationSettings,
    filterId: null,
    role: role,
    pageName: "project-details",
    isTaskViewCheck: null,
    teamId: teamId,
    projectIds: null,
    taskIds: null,
    planName: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName,
    last14Days: null,
    from: null,
    propsUserId: null,
    userIds: null,
    userActive: null,
    projectActive: null,
    taskActive: null,
    startDate: moment(startDate).format("YYYY-MM-DD"),
    endDate: moment(endDate !== null && endDate !== void 0 ? endDate : startDate).format("YYYY-MM-DD"),
    projectId: projectId,
    userUrl: user === null || user === void 0 ? void 0 : user.uniqueUrl
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ProjectHeaderMenu, {
    allowEmployeesToManageTheirTasks: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.allowEmployeesToManageTheirTasks,
    role: role,
    projectTabsData: projectTabsData,
    projectTabsLoading: projectTabsLoading,
    projectTabsError: projectTabsError,
    projectId: projectId,
    history: props === null || props === void 0 ? void 0 : props.history,
    summaryData: summaryData === null || summaryData === void 0 ? void 0 : (_summaryData$projectS3 = summaryData.projectSummaryDetails) === null || _summaryData$projectS3 === void 0 ? void 0 : _summaryData$projectS3.projectDetailsSummary,
    currenciesData: currenciesData === null || currenciesData === void 0 ? void 0 : (_currenciesData$getOr = currenciesData.getOrganisationCurrencies) === null || _currenciesData$getOr === void 0 ? void 0 : _currenciesData$getOr.currencies,
    organisationId: organisationId,
    user: user,
    organisationSettings: organisationSettings,
    startDate: startDate,
    endDate: endDate,
    teamId: teamId,
    projectUsersData: projectUsersData,
    projectUsersLoading: projectUsersLoading,
    projectSelectedHeadList: summaryData === null || summaryData === void 0 ? void 0 : (_summaryData$projectS4 = summaryData.projectSummaryDetails) === null || _summaryData$projectS4 === void 0 ? void 0 : _summaryData$projectS4.projectSelectedHeadList,
    selectedTeam: summaryData === null || summaryData === void 0 ? void 0 : (_summaryData$projectS5 = summaryData.projectSummaryDetails) === null || _summaryData$projectS5 === void 0 ? void 0 : _summaryData$projectS5.projectTeamIds,
    organisationBilling: organisationBilling
  }), /*#__PURE__*/React.createElement("div", null, role != "Member" ? /*#__PURE__*/React.createElement(Tabs, {
    className: "task-header-menu-whole-div-content-whole-filter-content-div-table-view-whole",
    defaultActiveKey: "task",
    onSelect: function onSelect(e) {
      handleWholeTabSelect(e);
    }
  }, /*#__PURE__*/React.createElement(Tab, {
    eventKey: "task",
    title: /*#__PURE__*/React.createElement("span", null, "Tasks")
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Task, {
    projectSearch: projectSearch,
    setSearch: setSearch,
    activeTab: activeTab,
    setActiveTab: setActiveTab,
    allowEmployeesToManageTheirTasks: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.allowEmployeesToManageTheirTasks,
    role: role,
    organisationId: organisationId,
    teamId: teamId,
    user: user,
    projectId: projectId,
    startDate: startDate,
    endDate: endDate !== null && endDate !== void 0 ? endDate : startDate,
    timezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
    allowEmployeesToMarkTheirTasksAsCompleted: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.allowEmployeesToMarkTheirTasksAsCompleted,
    history: history,
    getEmployeeDetails: getEmployeeDetails,
    organisationBilling: organisationBilling,
    projectName: summaryData === null || summaryData === void 0 ? void 0 : (_summaryData$projectS6 = summaryData.projectSummaryDetails) === null || _summaryData$projectS6 === void 0 ? void 0 : (_summaryData$projectS7 = _summaryData$projectS6.projectDetailsSummary) === null || _summaryData$projectS7 === void 0 ? void 0 : _summaryData$projectS7.projectName,
    location: location,
    isQuickEditCheck: isQuickEditCheck,
    setIsQuickEditCheck: setIsQuickEditCheck,
    isQuickEditModal: isQuickEditModal,
    setIsQuickEditModal: setIsQuickEditModal,
    isQuickEditMemberModal: isQuickEditMemberModal,
    setIsQuickEditMemberModal: setIsQuickEditMemberModal,
    taskActive: taskActive,
    toDoTaskActive: toDoTaskActive,
    inProgessTaskActive: inProgessTaskActive,
    overDueTaskActive: overDueTaskActive,
    completedTaskActive: completedTaskActive,
    holdTaskActive: holdTaskActive,
    quickEditType: quickEditType,
    setQuickEditType: setQuickEditType,
    setTaskActive: setTaskActive,
    setToDoTaskActive: setToDoTaskActive,
    setInProgessTaskActive: setInProgessTaskActive,
    setOverDueTaskActive: setOverDueTaskActive,
    setCompletedTaskActive: setCompletedTaskActive,
    setHoldTaskActive: setHoldTaskActive,
    quickEditWorkingStatus: quickEditWorkingStatus,
    setQuickEditWorkingStatus: setQuickEditWorkingStatus,
    quickEditToDoWorkingStatus: quickEditToDoWorkingStatus,
    setQuickEditToDoWorkingStatus: setQuickEditToDoWorkingStatus,
    quickEditInProgressWorkingStatus: quickEditInProgressWorkingStatus,
    setQuickEditInProgressWorkingStatus: setQuickEditInProgressWorkingStatus,
    quickEditDueWorkingStatus: quickEditDueWorkingStatus,
    setQuickEditDueWorkingStatus: setQuickEditDueWorkingStatus,
    quickEditCompletedWorkingStatus: quickEditCompletedWorkingStatus,
    setQuickEditCompletedWorkingStatus: setQuickEditCompletedWorkingStatus,
    quickEditHoldWorkingStatus: quickEditHoldWorkingStatus,
    setQuickEditHoldWorkingStatus: setQuickEditHoldWorkingStatus,
    isQuickEditSelect: isQuickEditSelect,
    setIsQuickEditSelect: setIsQuickEditSelect,
    isQuickEditToDoSelect: isQuickEditToDoSelect,
    setIsQuickEditToDoSelect: setIsQuickEditToDoSelect,
    isQuickEditInProgressSelect: isQuickEditInProgressSelect,
    setIsQuickEditInProgressSelect: setIsQuickEditInProgressSelect,
    isQuickEditDueSelect: isQuickEditDueSelect,
    setIsQuickEditDueSelect: setIsQuickEditDueSelect,
    isQuickEditCompletedSelect: isQuickEditCompletedSelect,
    setIsQuickEditCompletedSelect: setIsQuickEditCompletedSelect,
    isQuickEditHoldSelect: isQuickEditHoldSelect,
    setIsQuickEditHoldSelect: setIsQuickEditHoldSelect
  }), role != "Member" ? /*#__PURE__*/React.createElement(Employee, {
    employeesData: employeesData,
    employeesError: employeesError,
    employeesLoading: employeesLoading,
    organisationBilling: organisationBilling,
    projectId: projectId,
    organisationId: organisationId,
    projectName: summaryData === null || summaryData === void 0 ? void 0 : (_summaryData$projectS8 = summaryData.projectSummaryDetails) === null || _summaryData$projectS8 === void 0 ? void 0 : (_summaryData$projectS9 = _summaryData$projectS8.projectDetailsSummary) === null || _summaryData$projectS9 === void 0 ? void 0 : _summaryData$projectS9.projectName
  }) : null)), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "budget",
    title: /*#__PURE__*/React.createElement("span", null, "Budget and Finance")
  }, /*#__PURE__*/React.createElement(Budget, {
    role: role,
    organisationId: organisationId,
    teamId: teamId,
    user: user,
    projectId: projectId,
    timezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
    budget: summaryData === null || summaryData === void 0 ? void 0 : (_summaryData$projectS10 = summaryData.projectSummaryDetails) === null || _summaryData$projectS10 === void 0 ? void 0 : (_summaryData$projectS11 = _summaryData$projectS10.projectDetailsSummary) === null || _summaryData$projectS11 === void 0 ? void 0 : _summaryData$projectS11.budget,
    currenciesData: currenciesData === null || currenciesData === void 0 ? void 0 : (_currenciesData$getOr2 = currenciesData.getOrganisationCurrencies) === null || _currenciesData$getOr2 === void 0 ? void 0 : _currenciesData$getOr2.currencies,
    totalWorkedSec: summaryData === null || summaryData === void 0 ? void 0 : (_summaryData$projectS12 = summaryData.projectSummaryDetails) === null || _summaryData$projectS12 === void 0 ? void 0 : (_summaryData$projectS13 = _summaryData$projectS12.projectDetailsSummary) === null || _summaryData$projectS13 === void 0 ? void 0 : _summaryData$projectS13.totalWorkedSec,
    summaryData: summaryData === null || summaryData === void 0 ? void 0 : (_summaryData$projectS14 = summaryData.projectSummaryDetails) === null || _summaryData$projectS14 === void 0 ? void 0 : _summaryData$projectS14.projectDetailsSummary,
    projectStartDate: summaryData === null || summaryData === void 0 ? void 0 : (_summaryData$projectS15 = summaryData.projectSummaryDetails) === null || _summaryData$projectS15 === void 0 ? void 0 : (_summaryData$projectS16 = _summaryData$projectS15.projectDetailsSummary) === null || _summaryData$projectS16 === void 0 ? void 0 : _summaryData$projectS16.projectStartDate,
    projectDeadline: summaryData === null || summaryData === void 0 ? void 0 : (_summaryData$projectS17 = summaryData.projectSummaryDetails) === null || _summaryData$projectS17 === void 0 ? void 0 : (_summaryData$projectS18 = _summaryData$projectS17.projectDetailsSummary) === null || _summaryData$projectS18 === void 0 ? void 0 : _summaryData$projectS18.projectDeadline,
    activeTab: tableAndBudgetView,
    location: props.location.key,
    organisationBilling: organisationBilling,
    organisationSettings: organisationSettings,
    projectName: summaryData === null || summaryData === void 0 ? void 0 : (_summaryData$projectS19 = summaryData.projectSummaryDetails) === null || _summaryData$projectS19 === void 0 ? void 0 : (_summaryData$projectS20 = _summaryData$projectS19.projectDetailsSummary) === null || _summaryData$projectS20 === void 0 ? void 0 : _summaryData$projectS20.projectName,
    startDates: startDate,
    endDates: endDate
  })), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "reports",
    title: /*#__PURE__*/React.createElement("span", null, "Reports")
  }, /*#__PURE__*/React.createElement(Reports, {
    role: role,
    organisationId: organisationId,
    teamId: teamId,
    user: user,
    projectId: projectId,
    timezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
    activeTab: tableAndBudgetView
  }))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Task, {
    projectSearch: projectSearch,
    setSearch: setSearch,
    activeTab: activeTab,
    setActiveTab: setActiveTab,
    allowEmployeesToManageTheirTasks: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.allowEmployeesToManageTheirTasks,
    role: role,
    organisationId: organisationId,
    teamId: teamId,
    user: user,
    projectId: projectId,
    startDate: startDate,
    endDate: endDate !== null && endDate !== void 0 ? endDate : startDate,
    timezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
    allowEmployeesToMarkTheirTasksAsCompleted: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.allowEmployeesToMarkTheirTasksAsCompleted,
    history: history,
    getEmployeeDetails: getEmployeeDetails,
    organisationBilling: organisationBilling,
    projectName: summaryData === null || summaryData === void 0 ? void 0 : (_summaryData$projectS21 = summaryData.projectSummaryDetails) === null || _summaryData$projectS21 === void 0 ? void 0 : (_summaryData$projectS22 = _summaryData$projectS21.projectDetailsSummary) === null || _summaryData$projectS22 === void 0 ? void 0 : _summaryData$projectS22.projectName,
    location: location,
    isQuickEditCheck: isQuickEditCheck,
    setIsQuickEditCheck: setIsQuickEditCheck,
    isQuickEditModal: isQuickEditModal,
    setIsQuickEditModal: setIsQuickEditModal,
    isQuickEditMemberModal: isQuickEditMemberModal,
    setIsQuickEditMemberModal: setIsQuickEditMemberModal,
    taskActive: taskActive,
    toDoTaskActive: toDoTaskActive,
    inProgessTaskActive: inProgessTaskActive,
    overDueTaskActive: overDueTaskActive,
    completedTaskActive: completedTaskActive,
    holdTaskActive: holdTaskActive,
    quickEditType: quickEditType,
    setQuickEditType: setQuickEditType,
    setTaskActive: setTaskActive,
    setToDoTaskActive: setToDoTaskActive,
    setInProgessTaskActive: setInProgessTaskActive,
    setOverDueTaskActive: setOverDueTaskActive,
    setCompletedTaskActive: setCompletedTaskActive,
    setHoldTaskActive: setHoldTaskActive,
    quickEditWorkingStatus: quickEditWorkingStatus,
    setQuickEditWorkingStatus: setQuickEditWorkingStatus,
    quickEditToDoWorkingStatus: quickEditToDoWorkingStatus,
    setQuickEditToDoWorkingStatus: setQuickEditToDoWorkingStatus,
    quickEditInProgressWorkingStatus: quickEditInProgressWorkingStatus,
    setQuickEditInProgressWorkingStatus: setQuickEditInProgressWorkingStatus,
    quickEditDueWorkingStatus: quickEditDueWorkingStatus,
    setQuickEditDueWorkingStatus: setQuickEditDueWorkingStatus,
    quickEditCompletedWorkingStatus: quickEditCompletedWorkingStatus,
    setQuickEditCompletedWorkingStatus: setQuickEditCompletedWorkingStatus,
    quickEditHoldWorkingStatus: quickEditHoldWorkingStatus,
    setQuickEditHoldWorkingStatus: setQuickEditHoldWorkingStatus,
    isQuickEditSelect: isQuickEditSelect,
    setIsQuickEditSelect: setIsQuickEditSelect,
    isQuickEditToDoSelect: isQuickEditToDoSelect,
    setIsQuickEditToDoSelect: setIsQuickEditToDoSelect,
    isQuickEditInProgressSelect: isQuickEditInProgressSelect,
    setIsQuickEditInProgressSelect: setIsQuickEditInProgressSelect,
    isQuickEditDueSelect: isQuickEditDueSelect,
    setIsQuickEditDueSelect: setIsQuickEditDueSelect,
    isQuickEditCompletedSelect: isQuickEditCompletedSelect,
    setIsQuickEditCompletedSelect: setIsQuickEditCompletedSelect,
    isQuickEditHoldSelect: isQuickEditHoldSelect,
    setIsQuickEditHoldSelect: setIsQuickEditHoldSelect
  }), role != "Member" ? /*#__PURE__*/React.createElement(Employee, {
    employeesData: employeesData,
    employeesError: employeesError,
    employeesLoading: employeesLoading,
    organisationBilling: organisationBilling,
    projectId: projectId,
    organisationId: organisationId,
    projectName: summaryData === null || summaryData === void 0 ? void 0 : (_summaryData$projectS23 = summaryData.projectSummaryDetails) === null || _summaryData$projectS23 === void 0 ? void 0 : (_summaryData$projectS24 = _summaryData$projectS23.projectDetailsSummary) === null || _summaryData$projectS24 === void 0 ? void 0 : _summaryData$projectS24.projectName
  }) : null))));
};
var ProjectHeaderMenu = function ProjectHeaderMenu(props) {
  var _user$organisations2, _organisationDetails$2, _summaryData$projectD, _summaryData$projectS25;
  var allowEmployeesToManageTheirTasks = props.allowEmployeesToManageTheirTasks,
    role = props.role,
    projectTabsData = props.projectTabsData,
    projectTabsLoading = props.projectTabsLoading,
    projectTabsError = props.projectTabsError,
    projectId = props.projectId,
    history = props.history,
    summaryData = props.summaryData,
    currenciesData = props.currenciesData,
    organisationId = props.organisationId,
    user = props.user,
    organisationSettings = props.organisationSettings,
    endDate = props.endDate,
    startDate = props.startDate,
    teamId = props.teamId,
    projectUsersData = props.projectUsersData,
    projectUsersLoading = props.projectUsersLoading,
    projectSelectedHeadList = props.projectSelectedHeadList,
    selectedTeam = props.selectedTeam,
    organisationBilling = props.organisationBilling;
  var organisationDetails = (user === null || user === void 0 ? void 0 : (_user$organisations2 = user.organisations) === null || _user$organisations2 === void 0 ? void 0 : _user$organisations2.find(function (organisation) {
    return organisation.id === organisationId;
  })) || {};
  var teamDetails = (organisationDetails === null || organisationDetails === void 0 ? void 0 : (_organisationDetails$2 = organisationDetails.teams) === null || _organisationDetails$2 === void 0 ? void 0 : _organisationDetails$2.find(function (team) {
    return team.id === teamId;
  })) || {};
  var _React$useState53 = React.useState([]),
    _React$useState54 = _slicedToArray(_React$useState53, 2),
    selectFilter = _React$useState54[0],
    setSelectFilter = _React$useState54[1];
  var _React$useState55 = React.useState(null),
    _React$useState56 = _slicedToArray(_React$useState55, 2),
    isEstimationBudgetHover = _React$useState56[0],
    setEstimationBudgetHover = _React$useState56[1];
  var _React$useState57 = React.useState(""),
    _React$useState58 = _slicedToArray(_React$useState57, 2),
    projectEstimationBudget = _React$useState58[0],
    addProjectEstimationBudget = _React$useState58[1];

  // archive
  var _React$useState59 = React.useState(null),
    _React$useState60 = _slicedToArray(_React$useState59, 2),
    showArchiveModal = _React$useState60[0],
    setShowArchiveModal = _React$useState60[1];
  var _React$useState61 = React.useState(null),
    _React$useState62 = _slicedToArray(_React$useState61, 2),
    projectArchiveStatus = _React$useState62[0],
    setProjectArchiveStatus = _React$useState62[1];
  // edit
  var _React$useState63 = React.useState(null),
    _React$useState64 = _slicedToArray(_React$useState63, 2),
    projectModalShow = _React$useState64[0],
    setShow = _React$useState64[1];
  var _React$useState65 = React.useState(selectedTeam),
    _React$useState66 = _slicedToArray(_React$useState65, 2),
    teamActive = _React$useState66[0],
    setTeamActive = _React$useState66[1];
  var _React$useState67 = React.useState(""),
    _React$useState68 = _slicedToArray(_React$useState67, 2),
    searchTeam = _React$useState68[0],
    setSearchTeam = _React$useState68[1];
  var _React$useState69 = React.useState(true),
    _React$useState70 = _slicedToArray(_React$useState69, 2),
    isTeamSelected = _React$useState70[0],
    setTeamSelected = _React$useState70[1];
  var _React$useState71 = React.useState(null),
    _React$useState72 = _slicedToArray(_React$useState71, 2),
    keyData = _React$useState72[0],
    setKeyData = _React$useState72[1];
  var _React$useState73 = React.useState(false),
    _React$useState74 = _slicedToArray(_React$useState73, 2),
    isCheck = _React$useState74[0],
    setIsCheck = _React$useState74[1];
  var _React$useState75 = React.useState([]),
    _React$useState76 = _slicedToArray(_React$useState75, 2),
    userAdminIds = _React$useState76[0],
    setUserAdminIds = _React$useState76[1];
  var _React$useState77 = React.useState((_summaryData$projectD = summaryData.projectDeadline) !== null && _summaryData$projectD !== void 0 ? _summaryData$projectD : null),
    _React$useState78 = _slicedToArray(_React$useState77, 2),
    manualStartDate = _React$useState78[0],
    setManualStartDate = _React$useState78[1];
  var _React$useState79 = React.useState((_summaryData$projectS25 = summaryData.projectStartDate) !== null && _summaryData$projectS25 !== void 0 ? _summaryData$projectS25 : null),
    _React$useState80 = _slicedToArray(_React$useState79, 2),
    manualDate = _React$useState80[0],
    setManualDate = _React$useState80[1];
  var _React$useState81 = React.useState(""),
    _React$useState82 = _slicedToArray(_React$useState81, 2),
    dateError = _React$useState82[0],
    setDateError = _React$useState82[1];
  var _React$useState83 = React.useState(false),
    _React$useState84 = _slicedToArray(_React$useState83, 2),
    isManualDatePickerOpen = _React$useState84[0],
    setIsManualDatePickerOpen = _React$useState84[1];
  // delete
  var _React$useState85 = React.useState(null),
    _React$useState86 = _slicedToArray(_React$useState85, 2),
    showDeleteModal = _React$useState86[0],
    setShowDeleteModal = _React$useState86[1];
  var _React$useState87 = React.useState(null),
    _React$useState88 = _slicedToArray(_React$useState87, 2),
    projectDeleteStatus = _React$useState88[0],
    setProjectDeleteStatus = _React$useState88[1];

  //
  var _React$useState89 = React.useState(null),
    _React$useState90 = _slicedToArray(_React$useState89, 2),
    showRateModal = _React$useState90[0],
    setShowRateModal = _React$useState90[1];
  var _useMutation = useMutation(UPDATE_PROJECT_ESTIMATED_BUDGET_MUTATION),
    _useMutation2 = _slicedToArray(_useMutation, 2),
    updateProjectEstimateBudget = _useMutation2[0],
    updateProjectEstimateBudgetLoading = _useMutation2[1].loading;
  var _useMutation3 = useMutation(EDIT_PROJECT_AND_DELETE_PROJECT_MUTATION),
    _useMutation4 = _slicedToArray(_useMutation3, 2),
    editProjectAndDeleteProject = _useMutation4[0],
    editProjectAndDeleteProjectLoading = _useMutation4[1].loading;
  React.useEffect(function () {
    if (projectTabsData !== null && projectTabsData !== void 0 && projectTabsData.projectListNew.length && selectFilter.length == 0) {
      var selectedIds = (projectTabsData === null || projectTabsData === void 0 ? void 0 : projectTabsData.projectListNew.find(function (p) {
        return p.value === projectId;
      })) || {};
      setSelectFilter([selectedIds]);
    }
  }, [projectTabsData]);
  React.useEffect(function () {
    var _projectUsersData$get, _projectUsersData$get2, _projectUsersData$get3, _projectUsersData$get4;
    var userArray = projectUsersData === null || projectUsersData === void 0 ? void 0 : (_projectUsersData$get = projectUsersData.getProjectUserDetails) === null || _projectUsersData$get === void 0 ? void 0 : (_projectUsersData$get2 = _projectUsersData$get.teamSelectedUserList) === null || _projectUsersData$get2 === void 0 ? void 0 : _projectUsersData$get2.map(function (team) {
      return team.userId;
    });
    setTeamActive(userArray);
    projectUsersData === null || projectUsersData === void 0 ? void 0 : (_projectUsersData$get3 = projectUsersData.getProjectUserDetails) === null || _projectUsersData$get3 === void 0 ? void 0 : (_projectUsersData$get4 = _projectUsersData$get3.teamUserList) === null || _projectUsersData$get4 === void 0 ? void 0 : _projectUsersData$get4.map(function (user, index) {
      if (user.roleId == "24e4b513-da16-44e8-92ff-d28fcdc0d17f") {
        setUserAdminIds(function (oldArray) {
          return [].concat(_toConsumableArray(oldArray), [user.userId]);
        });
      }
    });
  }, [projectUsersData]);
  var projectList = projectTabsData === null || projectTabsData === void 0 ? void 0 : projectTabsData.projectListNew;

  // archive
  var handleArchiveClose = function handleArchiveClose() {
    return setShowArchiveModal(null);
  };
  var handleArchiveProjectShow = function handleArchiveProjectShow(projectName, projectId, organisationId, teamDetails, teamId) {
    var temp = {
      projectName: projectName,
      projectId: projectId,
      organisationId: organisationId,
      teamDetails: teamDetails,
      teamId: teamId,
      startDate: startDate,
      endDate: endDate
    };
    setShowArchiveModal(temp);
  };
  //edit
  var handleClose = function handleClose() {
    return setShow(null);
  };
  var handleEditProjectShow = function handleEditProjectShow(organisationId, projectName, teamDetails, projectId, selectedTeam, teamId, startDate, endDate, projectTimeInSec, budget, projectDeadline) {
    var temp = {
      modalType: "editProject",
      teamDetails: [teamDetails],
      organisationId: organisationId,
      projectName: summaryData.projectName,
      projectId: projectId,
      selectedTeam: selectedTeam,
      teamId: teamId,
      startDate: startDate,
      endDate: endDate,
      projectTimeInSec: projectTimeInSec,
      budget: budget,
      projectDeadline: projectDeadline
    };
    setShow(temp);
  };
  //delete
  var handleDeleteClose = function handleDeleteClose() {
    return setShowDeleteModal(null);
  };
  var handleDeleteShow = function handleDeleteShow(projectName, projectId, organisationId, teamDetails, teamId) {
    var temp = {
      projectName: projectName,
      projectId: projectId,
      organisationId: organisationId,
      teamDetails: teamDetails,
      teamId: teamId,
      startDate: startDate,
      endDate: endDate
    };
    setShowDeleteModal(temp);
  };

  //set rate
  var handleRateClose = function handleRateClose() {
    return setShowRateModal(null);
  };
  var handleRateShow = function handleRateShow(projectId, organisationId) {
    var temp = {
      projectId: projectId,
      organisationId: organisationId
    };
    setShowRateModal(temp);
  };

  // add budget
  var handleEstimatedBudgetSubmit = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var variables, response;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!(!isEstimationBudgetHover || projectEstimationBudget == "" || projectEstimationBudget == null)) {
            _context.next = 4;
            break;
          }
          setEstimationBudgetHover(null);
          addProjectEstimationBudget("");
          return _context.abrupt("return", null);
        case 4:
          variables = {
            projectId: projectId,
            projectBudget: projectEstimationBudget ? Number(projectEstimationBudget) : 0,
            //teamId: teamActive,
            organisationId: organisationId
          };
          _context.prev = 5;
          _context.next = 8;
          return updateProjectEstimateBudget({
            variables: variables,
            awaitRefetchQueries: true,
            refetchQueries: [{
              query: MY_PROJECTS_QUERY,
              variables: {
                organisationId: organisationId,
                // teamId,
                url: user === null || user === void 0 ? void 0 : user.uniqueUrl,
                // startDate: Number(moment(startDate).format("x")),
                // endDate: Number(moment(endDate ?? startDate).format("x")),
                timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
                limit: LIMIT,
                offset: 0,
                filter: "all",
                role: role,
                search: ""
              }
            },
            // {
            //   query: PROJECT_DETAILS_QUERY,
            //   variables: {
            //     projectId,
            //     organisationId,
            //     teamId,
            //     startDate: moment(startDate).format("YYYY-MM-DD"),
            //     endDate: moment(endDate ?? startDate).format("YYYY-MM-DD"),
            //     timezone: organisationSettings?.organisationTimezone,
            //   },
            // },
            {
              query: PROJECT_DETAILS_SUMMARY_QUERY,
              variables: {
                projectId: projectId,
                organisationId: organisationId,
                teamId: teamId,
                startDate: moment(startDate).format("YYYY-MM-DD"),
                endDate: moment(endDate !== null && endDate !== void 0 ? endDate : startDate).format("YYYY-MM-DD"),
                timezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
                role: role,
                userUrl: user === null || user === void 0 ? void 0 : user.uniqueUrl
              }
            }]
          });
        case 8:
          response = _context.sent;
          if (!(!response || !response.data || response.data.updateProjectEstimatedBudget == null)) {
            _context.next = 13;
            break;
          }
          throw new Error("error");
        case 13:
          toast.success("Estimated Budget added successfully!");
          setEstimationBudgetHover(null);
          addProjectEstimationBudget("");
        case 16:
          _context.next = 22;
          break;
        case 18:
          _context.prev = 18;
          _context.t0 = _context["catch"](5);
          console.log(_context.t0);
          toast.success("Error Occured, Try again latter!");
        case 22:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[5, 18]]);
  })), [updateProjectEstimateBudget, updateProjectEstimateBudgetLoading, projectEstimationBudget, isEstimationBudgetHover]);

  // archive
  var handleArchiveProject = React.useCallback(function (status, projectId) {
    return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var response;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!editProjectAndDeleteProjectLoading) {
              _context2.next = 2;
              break;
            }
            return _context2.abrupt("return");
          case 2:
            _context2.next = 4;
            return editProjectAndDeleteProject({
              variables: {
                projectName: null,
                budget: null,
                projectId: projectId,
                // teamId: null,
                status: status,
                organisationId: organisationId,
                projectTime: null,
                // headIds: [],
                projectUsers: []
              },
              awaitRefetchQueries: true,
              refetchQueries: [{
                query: MY_PROJECTS_QUERY,
                variables: {
                  organisationId: organisationId,
                  url: user === null || user === void 0 ? void 0 : user.uniqueUrl,
                  timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
                  limit: 21,
                  offset: 0,
                  filter: "all",
                  role: role,
                  search: ""
                }
              }, {
                query: PROJECT_LISTING_QUERY,
                variables: {
                  organisationId: organisationId,
                  url: user === null || user === void 0 ? void 0 : user.uniqueUrl,
                  role: role
                }
              }, {
                query: MY_PROJECT_SUMMARY_QUERY,
                variables: {
                  organisationId: organisationId,
                  timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
                  role: role
                }
              }, {
                query: PROJECT_DETAILS_SUMMARY_QUERY,
                variables: {
                  projectId: projectId,
                  organisationId: organisationId,
                  teamId: teamId,
                  startDate: moment(startDate).format("YYYY-MM-DD"),
                  endDate: moment(endDate !== null && endDate !== void 0 ? endDate : startDate).format("YYYY-MM-DD"),
                  timezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
                  role: role,
                  userUrl: user === null || user === void 0 ? void 0 : user.uniqueUrl
                }
              }]
            })["catch"](function (error) {
              if (!isRateLimited(error)) {
                throw error;
              }
              toast.error(rateLimitMessage(error));
              return null;
            });
          case 4:
            response = _context2.sent;
            if (!response || !response.data || !response.data.editProjectAndDeleteProject) {
              setProjectArchiveStatus("error");
            } else {
              setProjectArchiveStatus(true);
              handleArchiveClose();
              toast.success("Project archived successfully!");
              //history.push("/my-projects");
            }
          case 6:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
  }, [editProjectAndDeleteProject, editProjectAndDeleteProjectLoading]);
  //edit
  var handleEditProject = React.useCallback( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(values) {
      var _values$projectTime$t, _values$projectTime, _response$data;
      var updatedTeamActive, response;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (!editProjectAndDeleteProjectLoading) {
              _context3.next = 2;
              break;
            }
            return _context3.abrupt("return");
          case 2:
            // Create a fresh array (don’t mutate state directly)
            updatedTeamActive = _toConsumableArray(teamActive);
            if (!updatedTeamActive.includes(user.userId)) {
              updatedTeamActive = [].concat(_toConsumableArray(updatedTeamActive), [user.userId]);
            }
            if (updatedTeamActive.length) {
              _context3.next = 7;
              break;
            }
            setTeamSelected(false);
            return _context3.abrupt("return");
          case 7:
            setTeamActive(updatedTeamActive);
            setTeamSelected(true);
            _context3.next = 11;
            return editProjectAndDeleteProject({
              variables: {
                projectName: values.projectName,
                projectId: projectId,
                status: null,
                organisationId: organisationId,
                projectTime: (_values$projectTime$t = (_values$projectTime = values.projectTime) === null || _values$projectTime === void 0 ? void 0 : _values$projectTime.toString()) !== null && _values$projectTime$t !== void 0 ? _values$projectTime$t : "",
                projectUsers: updatedTeamActive,
                budget: values.budget ? values.budget : 0,
                deadline: moment(manualStartDate),
                projectStartDate: moment(manualDate)
              },
              awaitRefetchQueries: true,
              refetchQueries: [{
                query: PROJECT_DETAILS_SUMMARY_QUERY,
                variables: {
                  projectId: projectId,
                  organisationId: organisationId,
                  teamId: teamId,
                  startDate: moment(startDate).format("YYYY-MM-DD"),
                  endDate: moment(endDate !== null && endDate !== void 0 ? endDate : startDate).format("YYYY-MM-DD"),
                  timezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
                  role: role,
                  userUrl: user === null || user === void 0 ? void 0 : user.uniqueUrl,
                  search: ""
                }
              }, {
                query: PROJECT_LISTING_QUERY,
                variables: {
                  organisationId: organisationId,
                  url: user === null || user === void 0 ? void 0 : user.uniqueUrl,
                  role: role
                }
              }, {
                query: PROJECT_USER_DETAILS_DATA_QUERY,
                variables: {
                  organisationId: organisationId,
                  projectId: projectId
                }
              }, {
                query: MY_PROJECT_SUMMARY_QUERY,
                variables: {
                  organisationId: organisationId,
                  timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
                  role: role
                }
              }, {
                query: TASK_USERS_QUERY,
                variables: {
                  organisationId: organisationId,
                  projectId: projectId
                }
              }]
            })["catch"](function (error) {
              if (!isRateLimited(error)) {
                throw error;
              }
              toast.error(rateLimitMessage(error));
              return null;
            });
          case 11:
            response = _context3.sent;
            if (response !== null && response !== void 0 && (_response$data = response.data) !== null && _response$data !== void 0 && _response$data.editProjectAndDeleteProject) {
              _context3.next = 16;
              break;
            }
            throw new Error("error");
          case 16:
            handleClose();
            setSelectFilter([{
              label: values.projectName,
              value: projectId
            }]);
            toast.success("Project updated successfully!");
          case 19:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }(), [editProjectAndDeleteProject, editProjectAndDeleteProjectLoading, teamActive, manualStartDate, manualDate]);
  //delete
  var handleDeleteProject = React.useCallback(function (status, projectId) {
    return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      var response;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            if (!editProjectAndDeleteProjectLoading) {
              _context4.next = 2;
              break;
            }
            return _context4.abrupt("return");
          case 2:
            _context4.next = 4;
            return editProjectAndDeleteProject({
              variables: {
                projectName: null,
                budget: null,
                projectId: projectId,
                // teamId: null,
                status: "inactive",
                organisationId: organisationId,
                projectTime: null,
                // headIds: [],
                projectUsers: []
              },
              awaitRefetchQueries: true,
              refetchQueries: [{
                query: MY_PROJECTS_QUERY,
                variables: {
                  organisationId: organisationId,
                  url: user === null || user === void 0 ? void 0 : user.uniqueUrl,
                  timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
                  limit: 21,
                  offset: 0,
                  filter: "all",
                  role: role,
                  search: ""
                }
              }, {
                query: PROJECT_LISTING_QUERY,
                variables: {
                  organisationId: organisationId,
                  url: user === null || user === void 0 ? void 0 : user.uniqueUrl,
                  role: role
                }
              }, {
                query: MY_PROJECT_SUMMARY_QUERY,
                variables: {
                  organisationId: organisationId,
                  timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
                  role: role
                }
              }]
            })["catch"](function (error) {
              if (!isRateLimited(error)) {
                throw error;
              }
              toast.error(rateLimitMessage(error));
              return null;
            });
          case 4:
            response = _context4.sent;
            if (!response || !response.data || !response.data.editProjectAndDeleteProject) {
              setProjectDeleteStatus("error");
            } else {
              setProjectDeleteStatus(true);
              handleDeleteClose();
              toast.success("Project deleted successfully!");
              history.push("/my-projects");
            }
          case 6:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
  }, [editProjectAndDeleteProject, editProjectAndDeleteProjectLoading]);

  // calculate percentage
  var percentage = summaryData.totalTaskCount > 0 ? Math.round(summaryData.completedTaskCount / summaryData.totalTaskCount * 100) : 0;
  console.log({
    currenciesData: currenciesData
  });
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "project-header-menu-whole-div"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-header-menu-whole-div-1"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    className: "project-header-menu-whole-div-1-back-button",
    onClick: function onClick(e) {
      history.push("/my-projects");
    }
  }, /*#__PURE__*/React.createElement(IoMdArrowBack, {
    className: "project-header-menu-whole-div-1-back-button-svg"
  }), " Back to Projects"), /*#__PURE__*/React.createElement("div", {
    className: "project-header-menu-whole-div-1-back-buttons-div-menu"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-header-menu-whole-div-1-back-buttons-div-menu-project-filter"
  }, projectTabsLoading ? /*#__PURE__*/React.createElement("div", null, "Loading...") : projectTabsError ? /*#__PURE__*/React.createElement("div", null, "Error") : /*#__PURE__*/React.createElement(Select, {
    value: selectFilter,
    onChange: function onChange(e) {
      setSelectFilter(e);
      history.push("/project-details/".concat(e.value));
    },
    options: projectList,
    className: "task-overview-my-task-user-select"
    //styles={customStyles}
    ,
    classNamePrefix: "Filter By User"
    //isMulti
  })), /*#__PURE__*/React.createElement("div", {
    className: "project-header-menu-whole-div-1-back-buttons-div-menu-project-name"
  }, summaryData.projectName))), /*#__PURE__*/React.createElement("div", {
    className: "project-header-menu-whole-div-2"
  }, role != "Member" ? /*#__PURE__*/React.createElement(EditMenuIcon, {
    summaryData: summaryData,
    projectId: projectId,
    organisationId: organisationId,
    teamDetails: teamDetails,
    teamId: teamId,
    handleArchiveProjectShow: handleArchiveProjectShow,
    archiveStatus: summaryData === null || summaryData === void 0 ? void 0 : summaryData.projectArchiveStatus,
    organisationBilling: organisationBilling,
    handleEditProjectShow: handleEditProjectShow,
    selectedTeam: selectedTeam,
    startDate: startDate,
    endDate: endDate,
    handleDeleteShow: handleDeleteShow,
    role: role
  }) : null)), /*#__PURE__*/React.createElement("div", {
    className: "project-summary-cards-whole-div"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-summary-cards-whole-div-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-summary-cards-whole-div-card-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-summary-cards-whole-div-card-header-text"
  }, "Total Worked Hours"), /*#__PURE__*/React.createElement(MdAccessTime, {
    className: "project-summary-cards-whole-div-card-header-icon"
  })), /*#__PURE__*/React.createElement("div", {
    className: "project-summary-cards-whole-div-card-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-summary-cards-whole-div-card-content-hours"
  }, summaryData.totalWorkedSec), /*#__PURE__*/React.createElement("div", {
    className: classNames("project-summary-cards-whole-div-card-content-hours-graph", {
      "project-summary-cards-whole-div-card-content-hours-graph-green": summaryData.laskWeekWorkedhours !== "00h 00m"
    })
  }, summaryData.laskWeekWorkedhours !== "00h 00m" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MdTrendingUp, {
    className: "project-summary-cards-whole-div-card-content-hours-graph-icon"
  }), summaryData.laskWeekWorkedhours, " form last 7 days") : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MdTrendingUp, {
    className: "project-summary-cards-whole-div-card-content-hours-graph-icon"
  }), summaryData.laskWeekWorkedhours, " form last 7 days")))), role != "Member" ? Number(summaryData.budget) == 0 ? isEstimationBudgetHover ? /*#__PURE__*/React.createElement("div", {
    className: "project-details-card project-details-card-estimated-time-root"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-details-card-footer-add-estimation-time-input"
  }, /*#__PURE__*/React.createElement(InputGroup, {
    className: "project-details-card-footer-add-estimation-time-input-group"
  }, /*#__PURE__*/React.createElement(FormControl, {
    placeholder: "Add Budget(".concat(currenciesData == "EUR" ? "€" : currenciesData == "GBP" ? "£" : currenciesData == "INR" ? "₹" : currenciesData == "BRL" ? "R$" : currenciesData == "ZAR" ? "R " : currenciesData == "SEK" ? "kr " : currenciesData == "NGN" ? "₦" : currenciesData == "PHP" ? "₱" : currenciesData == "MYR" ? "RM " : currenciesData == "SGD" ? "S$" : currenciesData == "LKR" ? "Rs " : "$", ")"),
    className: "project-details-card-footer-add-estimation-time-input-type",
    type: "number",
    min: "0",
    value: projectEstimationBudget,
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    onChange: function onChange(e) {
      addProjectEstimationBudget(e.target.value);
    },
    onKeyPress: function onKeyPress(event) {
      if (!/[0-9]/.test(event.key)) {
        event.preventDefault();
      }
      if (event.key === "Enter") {
        addProjectEstimationBudget(e.target.value);
      }
    },
    autoFocus: true,
    disabled: updateProjectEstimateBudgetLoading
  }), /*#__PURE__*/React.createElement(Button, {
    variant: "info",
    className: "project-details-card-footer-add-estimation-time-button",
    onClick: function onClick(e) {
      handleEstimatedBudgetSubmit();
    },
    disabled: updateProjectEstimateBudgetLoading
  }, updateProjectEstimateBudgetLoading ? /*#__PURE__*/React.createElement(VscLoading, {
    className: "project-details-card-footer-add-estimation-time-button-loader"
  }) : /*#__PURE__*/React.createElement(MdCheck, {
    className: "project-details-card-footer-add-estimation-time-button-icon"
  }))))) : /*#__PURE__*/React.createElement("div", {
    className: "project-details-card project-details-card-estimat-hours-span"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-details-budject-span-text",
    onClick: function onClick(e) {
      e.stopPropagation();
      setEstimationBudgetHover(true);
    }
  }, "Add Estimated Budget in", " ", currenciesData == "EUR" ? "€" : currenciesData == "GBP" ? "£" : currenciesData == "INR" ? "₹" : currenciesData == "BRL" ? "R$" : currenciesData == "ZAR" ? "R " : currenciesData == "SEK" ? "kr " : currenciesData == "NGN" ? "₦" : currenciesData == "PHP" ? "₱" : currenciesData == "MYR" ? "RM " : currenciesData == "SGD" ? "S$" : currenciesData == "LKR" ? "Rs " : "$", " "), /*#__PURE__*/React.createElement("div", {
    className: "project-summary-cards-whole-div-card-content-set-rate"
  }, /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("div", {
    className: "project-summary-cards-whole-div-card-content-set-rate-whole-div",
    onClick: function onClick(e) {
      handleRateShow(projectId, organisationId);
    }
  }, "Set Billable Rate for Members"))) : /*#__PURE__*/React.createElement("div", {
    className: "project-summary-cards-whole-div-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-summary-cards-whole-div-card-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-summary-cards-whole-div-card-header-text"
  }, "Budget"), /*#__PURE__*/React.createElement("div", {
    className: "project-summary-cards-whole-div-card-header-icon project-summary-cards-whole-div-card-header-icon-dollar"
  }, currenciesData == "EUR" ? "€" : currenciesData == "GBP" ? "£" : currenciesData == "INR" ? "₹" : currenciesData == "BRL" ? "R$" : currenciesData == "ZAR" ? "R " : currenciesData == "SEK" ? "kr " : currenciesData == "NGN" ? "₦" : currenciesData == "PHP" ? "₱" : currenciesData == "MYR" ? "RM " : currenciesData == "SGD" ? "S$" : currenciesData == "LKR" ? "Rs " : "$")), /*#__PURE__*/React.createElement("div", {
    className: "project-summary-cards-whole-div-card-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-summary-cards-whole-div-card-content-hours"
  }, currenciesData == "EUR" ? "€" : currenciesData == "GBP" ? "£" : currenciesData == "INR" ? "₹" : currenciesData == "BRL" ? "R$" : currenciesData == "ZAR" ? "R " : currenciesData == "SEK" ? "kr " : currenciesData == "NGN" ? "₦" : currenciesData == "PHP" ? "₱" : currenciesData == "MYR" ? "RM " : currenciesData == "SGD" ? "S$" : currenciesData == "LKR" ? "Rs " : "$", Number(summaryData.budget).toLocaleString("en-IN")), /*#__PURE__*/React.createElement("div", {
    className: "project-summary-cards-whole-div-card-content-set-rate"
  }, /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("div", {
    className: "project-summary-cards-whole-div-card-content-set-rate-whole-div",
    onClick: function onClick(e) {
      handleRateShow(projectId, organisationId);
    }
  }, "Set Billable Rate for Members")))) : /*#__PURE__*/React.createElement("div", {
    className: "project-summary-cards-whole-div-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-summary-cards-whole-div-card-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-summary-cards-whole-div-card-header-text"
  }, "My Worked Hours"), /*#__PURE__*/React.createElement(MdAccessTime, {
    className: "project-summary-cards-whole-div-card-header-icon"
  })), /*#__PURE__*/React.createElement("div", {
    className: "project-summary-cards-whole-div-card-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-summary-cards-whole-div-card-content-hours"
  }, summaryData.userTotalWorkedHours))), /*#__PURE__*/React.createElement("div", {
    className: "project-summary-cards-whole-div-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-summary-cards-whole-div-card-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-summary-cards-whole-div-card-header-text"
  }, "Tasks Progress"), /*#__PURE__*/React.createElement(FiCheckSquare, {
    className: "project-summary-cards-whole-div-card-header-icon"
  })), /*#__PURE__*/React.createElement("div", {
    className: "project-summary-cards-whole-div-card-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-summary-cards-whole-div-card-content-hours"
  }, summaryData.completedTaskCount, "/", summaryData.totalTaskCount), /*#__PURE__*/React.createElement("div", {
    className: "project-summary-cards-whole-div-card-content-hours-graph-progress-div"
  }, /*#__PURE__*/React.createElement(ProgressBar, {
    now: percentage,
    className: "project-summary-cards-whole-div-card-content-hours-graph-progress"
  }), /*#__PURE__*/React.createElement("div", {
    className: "project-summary-cards-whole-div-card-content-hours-graph-progress-text"
  }, percentage, "% complete", " ")))), /*#__PURE__*/React.createElement("div", {
    className: "project-summary-cards-whole-div-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-summary-cards-whole-div-card-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-summary-cards-whole-div-card-header-text"
  }, "Overdue Tasks"), /*#__PURE__*/React.createElement(FiTarget, {
    className: "project-summary-cards-whole-div-card-header-icon"
  })), /*#__PURE__*/React.createElement("div", {
    className: "project-summary-cards-whole-div-card-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames("project-summary-cards-whole-div-card-content-hours", {
      "project-summary-cards-whole-div-card-content-hours-red": Number(summaryData.onDueTaskCount) !== 0
    })
  }, summaryData.onDueTaskCount), /*#__PURE__*/React.createElement("div", {
    className: "project-summary-cards-whole-div-card-content-hours-graph"
  }, "Requires immediate attention")))), /*#__PURE__*/React.createElement("div", {
    className: "project-detailss-cards-whole-div"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-detailss-cards-whole-div-summary"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-detailss-cards-whole-div-summary-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-detailss-cards-whole-div-summary-header-text"
  }, /*#__PURE__*/React.createElement(FiTarget, {
    className: "project-detailss-cards-whole-div-summary-header-icon"
  }), "Project Overview")), /*#__PURE__*/React.createElement("div", {
    className: "project-detailss-cards-whole-div-summary-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-detailss-cards-whole-div-summary-content-description"
  }, "A comprehensive project management solution with advanced tracking capabilities"), /*#__PURE__*/React.createElement("div", {
    className: "project-detailss-cards-whole-div-summary-content-grid"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-detailss-cards-whole-div-summary-content-grid-data"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-detailss-cards-whole-div-summary-content-grid-data-header"
  }, "Status"), /*#__PURE__*/React.createElement(Badge, {
    pill: true,
    variant: "success",
    className: classNames({
      "project-detailss-cards-whole-div-summary-content-grid-data-content-badge": summaryData.projectStatus == "active"
    }, {
      "project-detailss-cards-whole-div-summary-content-grid-data-content-badge-completed-status": summaryData.projectStatus == "completed"
    }, {
      "project-detailss-cards-whole-div-summary-content-grid-data-content-badge-overdue-status": summaryData.projectStatus == "overdue"
    })
  }, summaryData.projectStatus)), /*#__PURE__*/React.createElement("div", {
    className: "project-detailss-cards-whole-div-summary-content-grid-data"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-detailss-cards-whole-div-summary-content-grid-data-header"
  }, "Start Date"), /*#__PURE__*/React.createElement("div", {
    className: classNames("project-detailss-cards-whole-div-summary-content-grid-data-content")
  }, summaryData.projectStartDate ? /*#__PURE__*/React.createElement("div", {
    className: "project-detailss-cards-whole-div-summary-content-grid-data-content-text-calender"
  }, /*#__PURE__*/React.createElement(FiCalendar, {
    className: "project-detailss-cards-whole-div-summary-content-grid-data-content-text-icon"
  }), moment.unix(summaryData.projectStartDate / 1000).format("MMM DD, YYYY")) : /*#__PURE__*/React.createElement("div", {
    className: "project-detailss-cards-whole-div-summary-content-grid-data-content-text-calender-no"
  }, "No start date added"))), /*#__PURE__*/React.createElement("div", {
    className: "project-detailss-cards-whole-div-summary-content-grid-data"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-detailss-cards-whole-div-summary-content-grid-data-header"
  }, "Estimated Time"), /*#__PURE__*/React.createElement("div", {
    className: classNames("project-detailss-cards-whole-div-summary-content-grid-data-content")
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-detailss-cards-whole-div-summary-content-grid-data-content-text-calender"
  }, Number(summaryData.estimatedWorkedSec) == 0 ? /*#__PURE__*/React.createElement("div", {
    className: "project-detailss-cards-whole-div-summary-content-grid-data-content-text-calender-no"
  }, "No estimated time added") : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MdAccessTime, {
    className: "project-detailss-cards-whole-div-summary-content-grid-data-content-text-icon"
  }), "".concat(Math.round(Number(summaryData.estimatedWorkedSec) / 3600), " ").concat(Math.round(Number(summaryData.estimatedWorkedSec) / 3600) === 1 ? "hour" : "hours"))))), /*#__PURE__*/React.createElement("div", {
    className: "project-detailss-cards-whole-div-summary-content-grid-data"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-detailss-cards-whole-div-summary-content-grid-data-header"
  }, "Deadline"), /*#__PURE__*/React.createElement("div", {
    className: classNames("project-detailss-cards-whole-div-summary-content-grid-data-content")
  }, summaryData.projectDeadline ? /*#__PURE__*/React.createElement("div", {
    className: "project-detailss-cards-whole-div-summary-content-grid-data-content-text-calender"
  }, /*#__PURE__*/React.createElement(FiCalendar, {
    className: "project-detailss-cards-whole-div-summary-content-grid-data-content-text-icon"
  }), moment.unix(summaryData.projectDeadline / 1000).format("MMM DD, YYYY")) : /*#__PURE__*/React.createElement("div", {
    className: "project-detailss-cards-whole-div-summary-content-grid-data-content-text-calender-no"
  }, "No due date added")))))), /*#__PURE__*/React.createElement("div", {
    className: "project-detailss-cards-whole-div-member"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-detailss-cards-whole-div-summary-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-detailss-cards-whole-div-summary-header-text"
  }, "Team ", summaryData.projectUserWithAdminUserId.length <= 1 ? "Member" : "Members", " (", summaryData.projectUserWithAdminUserId.length, ")")), /*#__PURE__*/React.createElement("div", {
    className: "project-detailss-cards-whole-div-summary-content-member"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-detailss-cards-whole-div-member-content"
  }, summaryData.projectUserWithAdminUserId.map(function (data, key) {
    return /*#__PURE__*/React.createElement("div", {
      className: "project-detailss-cards-whole-div-member-content-list"
    }, data.profileUrl ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "employee-card-avatar-profile"
    }, /*#__PURE__*/React.createElement("img", {
      alt: "Workfolio",
      src: data.profileUrl,
      className: "team-card-avatar-profile-img"
    }))) : /*#__PURE__*/React.createElement("div", {
      className: "project-detailss-cards-whole-div-member-content-list-profile"
    }, data.displayName.trim().charAt(0)), /*#__PURE__*/React.createElement("div", {
      className: "project-detailss-cards-whole-div-member-content-list-body"
    }, data.displayName));
  }))))), /*#__PURE__*/React.createElement(ProjectModal, {
    projectModalShow: projectModalShow,
    handleClose: handleClose,
    timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
    teamActive: teamActive,
    setTeamActive: setTeamActive,
    searchTeam: searchTeam,
    setSearchTeam: setSearchTeam,
    isTeamSelected: isTeamSelected,
    setTeamSelected: setTeamSelected,
    editProjectAndDeleteProject: editProjectAndDeleteProject,
    editProjectAndDeleteProjectLoading: editProjectAndDeleteProjectLoading,
    handleEditProject: handleEditProject,
    keyData: keyData,
    setKeyData: setKeyData,
    isCheck: isCheck,
    setIsCheck: setIsCheck,
    user: user,
    tasksOptionsLoading: projectUsersLoading,
    projectSelectedHeadList: projectSelectedHeadList,
    tasksOptionsData: projectUsersData,
    userAdminIds: userAdminIds,
    setUserAdminIds: setUserAdminIds,
    currenciesData: currenciesData,
    manualStartDate: manualStartDate,
    setManualStartDate: setManualStartDate,
    isManualDatePickerOpen: isManualDatePickerOpen,
    setIsManualDatePickerOpen: setIsManualDatePickerOpen,
    manualDate: manualDate,
    setManualDate: setManualDate,
    dateError: dateError,
    setDateError: setDateError
  }), /*#__PURE__*/React.createElement(ArchiveProjectModal, {
    showArchiveModal: showArchiveModal,
    handleArchiveClose: handleArchiveClose,
    editProjectAndDeleteProject: editProjectAndDeleteProject,
    editProjectAndDeleteProjectLoading: editProjectAndDeleteProjectLoading,
    handleArchiveProject: handleArchiveProject,
    projectArchiveStatus: projectArchiveStatus,
    archiveStatus: summaryData === null || summaryData === void 0 ? void 0 : summaryData.projectArchiveStatus,
    projectType: summaryData === null || summaryData === void 0 ? void 0 : summaryData.projectType
  }), /*#__PURE__*/React.createElement(DeleteProjectModal, {
    showDeleteModal: showDeleteModal,
    handleDeleteClose: handleDeleteClose,
    editProjectAndDeleteProject: editProjectAndDeleteProject,
    editProjectAndDeleteProjectLoading: editProjectAndDeleteProjectLoading,
    handleDeleteProject: handleDeleteProject,
    projectDeleteStatus: projectDeleteStatus,
    projectType: summaryData === null || summaryData === void 0 ? void 0 : summaryData.projectType
  }), /*#__PURE__*/React.createElement(SetRateModal, {
    showRateModal: showRateModal,
    handleRateClose: handleRateClose,
    handleDeleteProject: handleDeleteProject,
    projectDeleteStatus: projectDeleteStatus,
    projectType: summaryData === null || summaryData === void 0 ? void 0 : summaryData.projectType,
    currenciesData: currenciesData
  }));
};
var Task = function Task(props) {
  var _taskCountData$taskCo, _taskCountData$taskCo2, _taskCountData$taskCo3, _taskCountData$taskCo4, _taskCountData$taskCo5, _taskCountData$taskCo6, _taskCountData$taskCo7, _taskCountData$taskCo8, _taskCountData$taskCo9, _taskCountData$taskCo10, _taskCountData$taskCo11, _taskCountData$taskCo12;
  var projectSearch = props.projectSearch,
    setSearch = props.setSearch,
    activeTab = props.activeTab,
    setActiveTab = props.setActiveTab,
    allowEmployeesToManageTheirTasks = props.allowEmployeesToManageTheirTasks,
    role = props.role,
    organisationId = props.organisationId,
    teamId = props.teamId,
    user = props.user,
    projectId = props.projectId,
    startDate = props.startDate,
    endDate = props.endDate,
    timezone = props.timezone,
    allowEmployeesToMarkTheirTasksAsCompleted = props.allowEmployeesToMarkTheirTasksAsCompleted,
    history = props.history,
    getEmployeeDetails = props.getEmployeeDetails,
    organisationBilling = props.organisationBilling,
    projectName = props.projectName,
    location = props.location,
    isQuickEditCheck = props.isQuickEditCheck,
    setIsQuickEditCheck = props.setIsQuickEditCheck,
    isQuickEditModal = props.isQuickEditModal,
    setIsQuickEditModal = props.setIsQuickEditModal,
    isQuickEditMemberModal = props.isQuickEditMemberModal,
    setIsQuickEditMemberModal = props.setIsQuickEditMemberModal,
    taskActive = props.taskActive,
    inProgessTaskActive = props.inProgessTaskActive,
    overDueTaskActive = props.overDueTaskActive,
    completedTaskActive = props.completedTaskActive,
    holdTaskActive = props.holdTaskActive,
    quickEditType = props.quickEditType,
    setQuickEditType = props.setQuickEditType,
    setTaskActive = props.setTaskActive,
    setToDoTaskActive = props.setToDoTaskActive,
    setInProgessTaskActive = props.setInProgessTaskActive,
    setOverDueTaskActive = props.setOverDueTaskActive,
    setCompletedTaskActive = props.setCompletedTaskActive,
    setHoldTaskActive = props.setHoldTaskActive,
    toDoTaskActive = props.toDoTaskActive,
    quickEditWorkingStatus = props.quickEditWorkingStatus,
    setQuickEditWorkingStatus = props.setQuickEditWorkingStatus,
    quickEditToDoWorkingStatus = props.quickEditToDoWorkingStatus,
    setQuickEditToDoWorkingStatus = props.setQuickEditToDoWorkingStatus,
    quickEditInProgressWorkingStatus = props.quickEditInProgressWorkingStatus,
    setQuickEditInProgressWorkingStatus = props.setQuickEditInProgressWorkingStatus,
    quickEditDueWorkingStatus = props.quickEditDueWorkingStatus,
    setQuickEditDueWorkingStatus = props.setQuickEditDueWorkingStatus,
    quickEditCompletedWorkingStatus = props.quickEditCompletedWorkingStatus,
    setQuickEditCompletedWorkingStatus = props.setQuickEditCompletedWorkingStatus,
    quickEditHoldWorkingStatus = props.quickEditHoldWorkingStatus,
    setQuickEditHoldWorkingStatus = props.setQuickEditHoldWorkingStatus,
    isQuickEditSelect = props.isQuickEditSelect,
    setIsQuickEditSelect = props.setIsQuickEditSelect,
    isQuickEditToDoSelect = props.isQuickEditToDoSelect,
    setIsQuickEditToDoSelect = props.setIsQuickEditToDoSelect,
    isQuickEditInProgressSelect = props.isQuickEditInProgressSelect,
    setIsQuickEditInProgressSelect = props.setIsQuickEditInProgressSelect,
    isQuickEditDueSelect = props.isQuickEditDueSelect,
    setIsQuickEditDueSelect = props.setIsQuickEditDueSelect,
    isQuickEditCompletedSelect = props.isQuickEditCompletedSelect,
    setIsQuickEditCompletedSelect = props.setIsQuickEditCompletedSelect,
    isQuickEditHoldSelect = props.isQuickEditHoldSelect,
    setIsQuickEditHoldSelect = props.setIsQuickEditHoldSelect;
  var _React$useState91 = React.useState({
      label: "All Status",
      value: ""
    }),
    _React$useState92 = _slicedToArray(_React$useState91, 2),
    statusCheck = _React$useState92[0],
    setStatusCheck = _React$useState92[1];
  var _React$useState93 = React.useState({
      label: "All Priority",
      value: ""
    }),
    _React$useState94 = _slicedToArray(_React$useState93, 2),
    priorityCheck = _React$useState94[0],
    setPriorityCheck = _React$useState94[1];
  var _React$useState95 = React.useState({
      label: "All Assignees",
      value: ""
    }),
    _React$useState96 = _slicedToArray(_React$useState95, 2),
    userCheck = _React$useState96[0],
    setUserCheck = _React$useState96[1];
  var _React$useState97 = React.useState("taskList"),
    _React$useState98 = _slicedToArray(_React$useState97, 2),
    tableView = _React$useState98[0],
    setTableView = _React$useState98[1];
  var _React$useState99 = React.useState(null),
    _React$useState100 = _slicedToArray(_React$useState99, 2),
    taskStatus = _React$useState100[0],
    setTaskStatus = _React$useState100[1];
  var _React$useState101 = React.useState(null),
    _React$useState102 = _slicedToArray(_React$useState101, 2),
    filterTask = _React$useState102[0],
    setSearchTask = _React$useState102[1]; // SEARCH SETTINGS
  var _React$useState103 = React.useState(null),
    _React$useState104 = _slicedToArray(_React$useState103, 2),
    addTaskShow = _React$useState104[0],
    setAddTaskShow = _React$useState104[1];
  //edit task
  var _React$useState105 = React.useState(false),
    _React$useState106 = _slicedToArray(_React$useState105, 2),
    taskDetails = _React$useState106[0],
    setShowNewTaskModal = _React$useState106[1];
  //delete task
  var _React$useState107 = React.useState(false),
    _React$useState108 = _slicedToArray(_React$useState107, 2),
    showTaskDeleteModal = _React$useState108[0],
    setShowDeleteTaskModal = _React$useState108[1];
  // export
  var _React$useState109 = React.useState(false),
    _React$useState110 = _slicedToArray(_React$useState109, 2),
    exportButton = _React$useState110[0],
    setExportButton = _React$useState110[1];
  //import
  var _React$useState111 = React.useState(null),
    _React$useState112 = _slicedToArray(_React$useState111, 2),
    importTaskShow = _React$useState112[0],
    setImportButton = _React$useState112[1];

  // view task
  var _React$useState113 = React.useState(null),
    _React$useState114 = _slicedToArray(_React$useState113, 2),
    showTaskModal = _React$useState114[0],
    setShowTaskModal = _React$useState114[1];
  var _React$useState115 = React.useState("task-details"),
    _React$useState116 = _slicedToArray(_React$useState115, 2),
    taskDetailsActiveTab = _React$useState116[0],
    setTaskDetailsActiveTab = _React$useState116[1];

  //filterPriority
  var _React$useState117 = React.useState(""),
    _React$useState118 = _slicedToArray(_React$useState117, 2),
    filterPriority = _React$useState118[0],
    setFilterPriority = _React$useState118[1];
  var _React$useState119 = React.useState({
      label: "All Priority",
      value: ""
    }),
    _React$useState120 = _slicedToArray(_React$useState119, 2),
    selectFilter = _React$useState120[0],
    setSelectFilter = _React$useState120[1];

  // mark as completed
  var _React$useState121 = React.useState(null),
    _React$useState122 = _slicedToArray(_React$useState121, 2),
    showcompletedModal = _React$useState122[0],
    setShowcompletedModal = _React$useState122[1];
  var _React$useState123 = React.useState(null),
    _React$useState124 = _slicedToArray(_React$useState123, 2),
    completedTask = _React$useState124[0],
    setCompletedTask = _React$useState124[1];
  var _React$useState125 = React.useState(null),
    _React$useState126 = _slicedToArray(_React$useState125, 2),
    completedTaskList = _React$useState126[0],
    setCompletedTaskList = _React$useState126[1];
  // undo
  var _React$useState127 = React.useState(null),
    _React$useState128 = _slicedToArray(_React$useState127, 2),
    showUndocompletedModal = _React$useState128[0],
    setShowUndocompletedModal = _React$useState128[1];
  var _React$useState129 = React.useState(null),
    _React$useState130 = _slicedToArray(_React$useState129, 2),
    undoCompletedTask = _React$useState130[0],
    setUndoCompletedTask = _React$useState130[1];
  var _React$useState131 = React.useState(null),
    _React$useState132 = _slicedToArray(_React$useState131, 2),
    undoCompletedTaskList = _React$useState132[0],
    setUndoCompletedTaskList = _React$useState132[1];

  //hold
  var _React$useState133 = React.useState(null),
    _React$useState134 = _slicedToArray(_React$useState133, 2),
    showHoldModal = _React$useState134[0],
    setShowHoldModal = _React$useState134[1];
  var _React$useState135 = React.useState(null),
    _React$useState136 = _slicedToArray(_React$useState135, 2),
    holdTask = _React$useState136[0],
    setHoldTask = _React$useState136[1];
  var _React$useState137 = React.useState(null),
    _React$useState138 = _slicedToArray(_React$useState137, 2),
    holdTaskList = _React$useState138[0],
    setHoldTaskList = _React$useState138[1];

  // column select
  var _React$useState139 = React.useState(
    //   [
    //   { label: "Assigned", value: "assignedTo", summary: "assignedTo" },
    //   { label: "My Time", value: "totalMyWorkedTime", summary: "totalMyWorkedTime" },
    // ]
    JSON.parse(localStorage.getItem("tasksParameter")) || []),
    _React$useState140 = _slicedToArray(_React$useState139, 2),
    parameterCheck = _React$useState140[0],
    setParameterCheck = _React$useState140[1];
  if (!localStorage.getItem("tasksParameter")) {
    var param = [];
    if (role == "Admin" || role == "Head") {
      param = [{
        label: "Assigned",
        value: "assignedTo",
        summary: "assignedTo"
      }, {
        label: "Priority",
        value: "priority",
        summary: "priority"
      }];
    } else {
      param = [{
        label: "Assigned",
        value: "assignedTo",
        summary: "assignedTo"
      }, {
        label: "My Time",
        value: "totalMyWorkedTime",
        summary: "totalMyWorkedTime"
      }];
    }
    localStorage.setItem("tasksParameter", JSON.stringify(param));
    setParameterCheck(JSON.parse(localStorage.getItem("tasksParameter")));
  }
  var _useLazyQuery3 = useLazyQuery(PROJECT_TASKS_EXPORT_QUERY, {
      onError: function onError() {
        setExportButton(false);
      },
      fetchPolicy: "network-only" // always hit server
    }),
    _useLazyQuery4 = _slicedToArray(_useLazyQuery3, 2),
    getExport = _useLazyQuery4[0],
    _useLazyQuery4$ = _useLazyQuery4[1],
    exportLoading = _useLazyQuery4$.loading,
    exportData = _useLazyQuery4$.data;
  var _useQuery5 = useQuery(TASK_COUNT_QUERY, {
      variables: {
        organisationId: organisationId,
        teamId: teamId,
        userId: role == "Member" ? user === null || user === void 0 ? void 0 : user.userId : null,
        projectId: [projectId],
        taskId: null,
        role: role
      },
      fetchPolicy: "network-only",
      skip: !teamId || !organisationId
    }),
    taskCountData = _useQuery5.data,
    taskCountError = _useQuery5.error,
    taskCountLoading = _useQuery5.loading,
    taskCountRefetch = _useQuery5.refetch;
  var _useQuery6 = useQuery(PROJECT_TASKS_QUERY, {
      variables: {
        projectId: projectId,
        organisationId: organisationId,
        teamId: teamId,
        startDate: startDate,
        endDate: endDate,
        taskStatus: taskStatus,
        search: projectSearch,
        limit: TASK_LIMIT,
        offset: 0,
        timezone: timezone,
        role: role,
        url: user === null || user === void 0 ? void 0 : user.uniqueUrl,
        filterPriority: filterPriority
      },
      fetchPolicy: "network-only",
      skip: !teamId || !organisationId
    }),
    taskListData = _useQuery6.data,
    taskListError = _useQuery6.error,
    taskListLoading = _useQuery6.loading,
    taskFetchMore = _useQuery6.fetchMore,
    taskRefetch1 = _useQuery6.refetch;
  var _useLazyQuery5 = useLazyQuery(GET_FILTER_TASK_TRACKER_DETAILS_QUERY, {
      variables: {
        organisationId: organisationId,
        teamId: teamId,
        userId: role == "Member" ? user === null || user === void 0 ? void 0 : user.userId : null,
        projectId: [projectId],
        taskId: null,
        limit: LIMIT,
        offset: 0,
        filterType: tableView,
        timezone: timezone,
        role: role,
        search: projectSearch
      },
      fetchPolicy: "network-only"
    }),
    _useLazyQuery6 = _slicedToArray(_useLazyQuery5, 2),
    getFilterTaskTrackerDetails = _useLazyQuery6[0],
    _useLazyQuery6$ = _useLazyQuery6[1],
    filterTaskLoading = _useLazyQuery6$.loading,
    filterTaskData = _useLazyQuery6$.data,
    filterTaskError = _useLazyQuery6$.error,
    filterTaskFetchMore = _useLazyQuery6$.fetchMore;
  React.useEffect(function () {
    getFilterTaskTrackerDetails();
  }, []);

  // task modal view
  var _useLazyQuery7 = useLazyQuery(TASK_DETAILS_QUERY, {
      fetchPolicy: "network-only"
    }),
    _useLazyQuery8 = _slicedToArray(_useLazyQuery7, 2),
    getTaskDetails = _useLazyQuery8[0],
    _useLazyQuery8$ = _useLazyQuery8[1],
    taskDetailsData = _useLazyQuery8$.data,
    taskDetailsError = _useLazyQuery8$.error,
    taskDetailsLoading = _useLazyQuery8$.loading,
    taskDetailsFetchMore = _useLazyQuery8$.fetchMore;
  var _useLazyQuery9 = useLazyQuery(TASK_EMPLOYEE_TIMELINE_QUERY),
    _useLazyQuery10 = _slicedToArray(_useLazyQuery9, 2),
    getTaskEmployeeTimeline = _useLazyQuery10[0],
    _useLazyQuery10$ = _useLazyQuery10[1],
    taskTimelineData = _useLazyQuery10$.data,
    taskTimelineError = _useLazyQuery10$.error,
    taskTimelineLoading = _useLazyQuery10$.loading,
    taskTimelineFetchMore = _useLazyQuery10$.fetchMore;
  var _useLazyQuery11 = useLazyQuery(TASK_ACTIVITY_SUMMARY_QUERY),
    _useLazyQuery12 = _slicedToArray(_useLazyQuery11, 2),
    getTaskActivitySummary = _useLazyQuery12[0],
    _useLazyQuery12$ = _useLazyQuery12[1],
    taskActivitySummaryData = _useLazyQuery12$.data,
    taskActivitySummaryError = _useLazyQuery12$.error,
    taskActivitySummaryLoading = _useLazyQuery12$.loading,
    taskActivitySummaryFetchMore = _useLazyQuery12$.fetchMore;
  React.useEffect(function () {
    if (showTaskModal && showTaskModal.taskId) {
      getTaskDetails({
        variables: {
          projectId: projectId,
          organisationId: organisationId,
          taskId: showTaskModal ? showTaskModal.taskId : null,
          startDate: Number(moment(startDate).format("x")),
          endDate: Number(moment(endDate).format("x")),
          timeZone: timezone,
          limit: TASK_EMP_LIMIT,
          offset: 0,
          role: role,
          userUrl: user.uniqueUrl
        },
        // notifyOnNetworkStatusChange: true,
        // fetchPolicy: "network-only",
        skip: showTaskModal == null && !showTaskModal.taskId
      });
    }
  }, [showTaskModal]);
  var options = [{
    label: "Assigned",
    value: "assignedTo",
    summary: "assignedTo"
  }, {
    label: "My Time",
    value: "totalMyWorkedTime",
    summary: "totalMyWorkedTime"
  }, {
    label: "Priority",
    value: "priority",
    summary: "priority"
  }, {
    label: "Estimated Time",
    value: "estimatedTime",
    summary: "estimatedTime"
  }, {
    label: "Due Date",
    value: "dueDate",
    summary: "dueDate"
  }];
  var priorityOption = [{
    label: "All Priority",
    value: ""
  }, {
    label: "High",
    value: "high"
  }, {
    label: "Medium",
    value: "medium"
  }, {
    label: "Low",
    value: "low"
  }];
  var userList = [{
    label: "All Assignees",
    value: ""
  }, {
    label: "Ragupathi",
    value: "ragu"
  }, {
    label: "Ragul s",
    value: "ragul"
  }];

  //export
  var xlsxData = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
    var dataValues, wb, ws, headers, buf, fileName;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          dataValues = exportData === null || exportData === void 0 ? void 0 : exportData.projectTasksExport;
          if (dataValues) {
            _context5.next = 3;
            break;
          }
          return _context5.abrupt("return", []);
        case 3:
          wb = new Excel.Workbook();
          ws = wb.addWorksheet();
          headers = [{
            header: "Task Title",
            key: "taskName",
            width: 20,
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          },
          // {
          //   header: "Task Priority",
          //   key: "priority",
          //   style: { alignment: { vertical: "middle", horizontal: "left" } },
          // },
          {
            header: "Overdue",
            key: "dueDate",
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Estimated Time",
            key: "estimatedTime",
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Worked Time (hh:mm:ss)",
            key: "totalWorkedTime",
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          },
          // {
          //   header: "Assigned",
          //   key: "assignedToAll",
          //   width: 20,
          //   style: { alignment: { vertical: "middle", horizontal: "left" } },
          // },
          {
            header: "Task Status",
            key: "taskLabelStatus",
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }];
          if (parameterCheck.some(function (t) {
            return t.summary === "assignedTo";
          })) {
            headers.push({
              header: "Assigned",
              key: "assignedToAll",
              style: {
                alignment: {
                  vertical: "middle",
                  horizontal: "left"
                }
              }
            });
          }
          if (parameterCheck.some(function (t) {
            return t.summary === "totalMyWorkedTime";
          })) {
            headers.push({
              header: "My Time",
              key: "totalMyWorkedTime",
              style: {
                alignment: {
                  vertical: "middle",
                  horizontal: "left"
                }
              }
            });
          }
          if (parameterCheck.some(function (t) {
            return t.summary === "priority";
          })) {
            headers.push({
              header: "Task Priority",
              key: "priority",
              style: {
                alignment: {
                  vertical: "middle",
                  horizontal: "left"
                }
              }
            });
          }
          if (parameterCheck.some(function (t) {
            return t.summary === "estimatedTime";
          })) {
            headers.push({
              header: "Estimated Time",
              key: "estimatedTime",
              style: {
                alignment: {
                  vertical: "middle",
                  horizontal: "left"
                }
              }
            });
          }
          if (parameterCheck.some(function (t) {
            return t.summary === "dueDate";
          })) {
            headers.push({
              header: "Due Date",
              key: "dueDate",
              style: {
                alignment: {
                  vertical: "middle",
                  horizontal: "left"
                }
              }
            });
          }
          ws.columns = headers;
          dataValues.map(function (users, index) {
            var taskName = users.taskName,
              totalWorkedTime = users.totalWorkedTime,
              assignedToAll = users.assignedToAll,
              estimatedTime = users.estimatedTime,
              dueDate = users.dueDate,
              taskLabelStatus = users.taskLabelStatus,
              priority = users.priority,
              totalMyWorkedTime = users.totalMyWorkedTime;
            var ts = {
              taskName: taskName,
              // priority: priority ? `${priority.charAt(0).toUpperCase() + priority.slice(1)}` : "-",
              // dueDate: dueDate != null ? moment.unix(Number(dueDate) / 1000).format("DD MMM, YYYY") : "-",
              // estimatedTime:
              //   estimatedTime != null || Number(estimatedTime) != 0
              //     ? `${convertSecToHours(Number(estimatedTime))} hours`
              //     : "-",
              totalWorkedTime: totalWorkedTime,
              // assignedToAll: assignedToAll,
              taskLabelStatus: taskLabelStatus
            };
            if (parameterCheck.some(function (t) {
              return t.summary === "assignedTo";
            })) {
              ts = _objectSpread(_objectSpread({}, ts), {}, {
                assignedToAll: assignedToAll
              });
            }
            if (parameterCheck.some(function (t) {
              return t.summary === "totalMyWorkedTime";
            })) {
              ts = _objectSpread(_objectSpread({}, ts), {}, {
                totalMyWorkedTime: totalMyWorkedTime
              });
            }
            if (parameterCheck.some(function (t) {
              return t.summary === "priority";
            })) {
              var prioritys = priority ? "".concat(priority.charAt(0).toUpperCase() + priority.slice(1)) : "-";
              ts = _objectSpread(_objectSpread({}, ts), {}, {
                priority: prioritys
              });
            }
            if (parameterCheck.some(function (t) {
              return t.summary === "estimatedTime";
            })) {
              var estimatedTimes = estimatedTime != null || Number(estimatedTime) != 0 ? "".concat(convertSecToHours(Number(estimatedTime)), " hours") : "-";
              ts = _objectSpread(_objectSpread({}, ts), {}, {
                estimatedTime: estimatedTimes
              });
            }
            if (parameterCheck.some(function (t) {
              return t.summary === "dueDate";
            })) {
              var dueDates = dueDate != null ? moment.unix(Number(dueDate) / 1000).format("DD MMM, YYYY") : "-";
              ts = _objectSpread(_objectSpread({}, ts), {}, {
                dueDate: dueDates
              });
            }
            ws.addRow(ts);
          });

          // ws.getCell("A1").font = { bold: true };
          // ws.getCell("B1").font = { bold: true };
          // ws.getCell("C1").font = { bold: true };
          // ws.getCell("D1").font = { bold: true };
          // ws.getCell("E1").font = { bold: true };
          // ws.getCell("F1").font = { bold: true };
          // ws.getCell("G1").font = { bold: true };

          ws.getRow(1).font = {
            bold: true
          };
          _context5.next = 16;
          return wb.xlsx.writeBuffer();
        case 16:
          buf = _context5.sent;
          fileName = "".concat(projectName, "-all-tasks.xlsx");
          saveAs(new Blob([buf]), fileName);
          setExportButton(false);
        case 20:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  })), [exportData, parameterCheck]);
  React.useEffect(function () {
    xlsxData();
  }, [exportData]);
  React.useEffect(function () {
    taskRefetch1 === null || taskRefetch1 === void 0 ? void 0 : taskRefetch1();
    taskCountRefetch === null || taskCountRefetch === void 0 ? void 0 : taskCountRefetch();
  }, [location.key]);
  React.useEffect(function () {
    if (tableView == "taskList") {
      taskRefetch1 === null || taskRefetch1 === void 0 ? void 0 : taskRefetch1();
    } else if (tableView != "timeline" && tableView !== "manualTaskHistory" && tableView != "taskList") {
      getFilterTaskTrackerDetails();
    }
  }, [tableView]);
  var handleTabSelect = function handleTabSelect(key) {
    setActiveTab(key);
  };
  var handleTableTabSelect = function handleTableTabSelect(key) {
    setTableView(key);
  };

  //add
  var handleTaskShow = function handleTaskShow(projectId) {
    setAddTaskShow(projectId);
  };
  var handleTaskClose = function handleTaskClose() {
    setAddTaskShow(null);
  };

  //edit
  var handleShow = function handleShow(taskId, taskUser, estimatedTime, dueDate, taskName, taskStatus, taskLabelStatus, priority, taskStartDate, taskProgress, taskProgressUser, taskVisibility, description, allowEmployeesToMarkTheirTasksAsCompleted, userId, taskCreatedBy) {
    var temp = {
      taskId: taskId,
      taskUser: taskUser,
      estimatedTime: estimatedTime,
      dueDate: dueDate,
      taskName: taskName,
      taskStatus: taskStatus,
      taskLabelStatus: taskLabelStatus,
      priority: priority,
      taskStartDate: taskStartDate,
      taskProgress: taskProgress,
      taskProgressUser: taskProgressUser,
      taskVisibility: taskVisibility,
      description: description,
      allowEmployeesToMarkTheirTasksAsCompleted: allowEmployeesToMarkTheirTasksAsCompleted,
      userId: userId,
      taskCreatedBy: taskCreatedBy
    };
    setShowNewTaskModal(temp);
  };
  var handleClose = function handleClose() {
    return setShowNewTaskModal(false);
  };

  //delete
  var handleTaskDeleteClose = function handleTaskDeleteClose() {
    return setShowDeleteTaskModal(false);
  };
  var handleTaskDeleteShow = function handleTaskDeleteShow(taskId, taskProgress, taskProgressUser, type, taskStatus) {
    return setShowDeleteTaskModal({
      taskId: taskId,
      taskProgress: taskProgress,
      taskProgressUser: taskProgressUser,
      type: type,
      taskStatus: taskStatus
    });
  };

  //export
  var getExportData = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            setExportButton(true);
            getExport({
              variables: {
                projectId: projectId,
                organisationId: organisationId,
                teamId: teamId,
                timezone: timezone,
                role: role
              }
            });
          case 2:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    return function getExportData() {
      return _ref6.apply(this, arguments);
    };
  }();

  // import
  var handleImportTaskClose = function handleImportTaskClose() {
    setImportButton(null);
  };
  var handleImportTaskShow = function handleImportTaskShow(projectId) {
    setImportButton(projectId);
  };

  // view task
  var handleShowTaskDetails = function handleShowTaskDetails(list) {
    setShowTaskModal(list);
  };
  var handleCloseTaskDetails = function handleCloseTaskDetails() {
    setShowTaskModal(null);
  };

  //mark as completed
  var handleCompletedClose = function handleCompletedClose() {
    setShowcompletedModal(null);
  };
  var handleCompletedShow = function handleCompletedShow(taskId, projectId, taskProgress, taskProgressUser, taskStatus) {
    setShowcompletedModal({
      taskId: taskId,
      projectId: projectId,
      taskProgress: taskProgress,
      taskProgressUser: taskProgressUser,
      taskStatus: taskStatus
    });
  };
  // undo completed
  var handleUndoCompletedClose = function handleUndoCompletedClose() {
    setShowUndocompletedModal(null);
  };
  var handleUndoCompletedShow = function handleUndoCompletedShow(taskId, projectId, taskStatus) {
    setShowUndocompletedModal({
      taskId: taskId,
      projectId: projectId,
      taskStatus: taskStatus
    });
  };
  // on hold
  var handleHoldShow = function handleHoldShow(taskId, projectId, taskProgress, taskProgressUser, taskStatus) {
    setShowHoldModal({
      taskId: taskId,
      projectId: projectId,
      taskProgress: taskProgress,
      taskProgressUser: taskProgressUser,
      taskStatus: taskStatus
    });
  };
  var handleHoldClose = function handleHoldClose() {
    setShowHoldModal(null);
  };

  // quick edit
  var handleKey = function handleKey() {
    setIsQuickEditCheck(function (prev) {
      return prev === true ? false : true;
    });
  };
  var quickHandleClose = function quickHandleClose() {
    setIsQuickEditModal(null);
  };
  var quickHandleMemberClose = function quickHandleMemberClose() {
    setIsQuickEditMemberModal(null);
  };

  // columns change
  var setParameterChecks = function setParameterChecks(selectedOptions) {
    localStorage.setItem("tasksParameter", JSON.stringify(selectedOptions));
    //setParameterCheck(selectedOptions);
    setParameterCheck(JSON.parse(localStorage.getItem("tasksParameter")));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "task-header-menu-whole-div"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-header-menu-whole-div-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-header-menu-whole-div-header-section"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-header-menu-whole-div-header-section-text"
  }, "Task Management"), /*#__PURE__*/React.createElement("div", {
    className: "task-header-menu-whole-div-header-section-buttons"
  }, activeTab == "listView" ? /*#__PURE__*/React.createElement("div", {
    className: "project-multi-select"
  }, /*#__PURE__*/React.createElement(MultiSelect, {
    options: options,
    value: parameterCheck,
    onChange: function onChange(e) {
      return setParameterChecks(e);
    },
    labelledBy: "Columns",
    overrideStrings: {
      selectSomeItems: "Select Columns",
      allItemsAreSelected: "All Columns Selected",
      selectAll: "Select All"
      // search: "Search",
    },
    hasSelectAll: false
  })) : null, /*#__PURE__*/React.createElement("div", {
    className: "task-header-menu-whole-div-header-section-buttons-search"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-header-menu-whole-div-header-section-buttons-searchbar-div"
  }, /*#__PURE__*/React.createElement(SearchBar, {
    value: projectSearch,
    onChange: setSearch,
    placeholder: "Search tasks...",
    className: "screenshots-card-searchbar"
  }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Tabs, {
    className: "task-header-menu-whole-div-header-section-buttons-view",
    defaultActiveKey: "listView",
    onSelect: function onSelect(e) {
      handleTabSelect(e);
    }
  }, /*#__PURE__*/React.createElement(Tab, {
    eventKey: "listView",
    title: /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(MdFormatListBulleted, {
      className: "task-header-menu-whole-div-header-section-buttons-view-icon"
    }), "List")
  }), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "kanbanView",
    title: /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(BsKanban, {
      className: "task-header-menu-whole-div-header-section-buttons-view-icon"
    }), "Kanban")
  }))), role != "Member" || role == "Member" && allowEmployeesToManageTheirTasks ? /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    className: "project-details-task-card-body-filter-section-buttions-add-button-root-new",
    onClick: function onClick() {
      handleTaskShow(projectId);
    }
  }, "+ Create Task") : null))), /*#__PURE__*/React.createElement("div", {
    className: "task-header-menu-whole-div-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-header-menu-whole-div-content-whole"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-header-menu-whole-div-content-whole-filter-div-whole"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-header-menu-whole-div-content-whole-filter-div"
  }, tableView == "taskList" && activeTab == "listView" ? /*#__PURE__*/React.createElement("div", {
    className: "task-header-menu-whole-div-content-whole-filter-div-user"
  }, /*#__PURE__*/React.createElement(Select, {
    value: selectFilter,
    onChange: function onChange(e) {
      setSelectFilter(e);
      setFilterPriority(e.value);
    },
    options: priorityOption,
    className: "task-overview-my-task-user-select"
    //styles={customStyles}
    ,
    classNamePrefix: "Filter By User"
    //isMulti
  })) : null), /*#__PURE__*/React.createElement("div", {
    className: "d-flex"
  }, activeTab == "listView" && role != "Member" ? /*#__PURE__*/React.createElement("div", {
    className: "project-details-button-section-root-toggle-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "quick-edid-mode-tasks-rule-uparrow toggle-switch",
    onClick: function onClick() {
      return handleKey();
    }
  }, /*#__PURE__*/React.createElement("label", {
    "for": "chkTest"
  }, /*#__PURE__*/React.createElement("span", {
    className: classNames("toggle-track", {
      "toggle-track-nav-right-div": isQuickEditCheck
    })
  }))), /*#__PURE__*/React.createElement("div", {
    className: "quick-edid-mode-tasks-rule-uparrow-text"
  }, "Quick Edit")) : null, role != "Member" || role == "Member" && allowEmployeesToManageTheirTasks ? /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    className: "project-header-menu-whole-div-2-import-button project-header-menu-whole-div-2-import-button-export",
    onClick: function onClick() {
      handleImportTaskShow(projectId);
    }
  }, /*#__PURE__*/React.createElement(BsUpload, {
    className: "project-header-menu-whole-div-2-import-button-icon"
  }), " Import") :
  //   <OverlayTrigger
  //   placement="bottom"
  //   overlay={
  //     <Tooltip id={`tooltip-bottom`} className="count-tooltip-start">
  //       Import is unavailable due to maintenance. It will be back within 24 hours. Sorry for the
  //       inconvenience.
  //     </Tooltip>
  //   }
  // >
  //   <Button variant="outline-secondary" className="project-header-menu-whole-div-2-import-button project-header-menu-whole-div-2-import-button-export">
  //     <BsUpload className="project-header-menu-whole-div-2-import-button-icon" /> Import
  //   </Button>
  // </OverlayTrigger>
  null, (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) != "free" ? !exportButton ? /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    onClick: function onClick() {
      getExportData();
    },
    className: "project-header-menu-whole-div-2-import-button"
  }, /*#__PURE__*/React.createElement(FiDownload, {
    className: "project-header-menu-whole-div-2-import-button-icon"
  }), " Export") : /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    className: "project-header-menu-whole-div-2-import-button"
  }, /*#__PURE__*/React.createElement(FiDownload, {
    className: "project-header-menu-whole-div-2-import-button-icon"
  }), "Downloading") : /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-start"
    }, "Please upgrade your plan to export task")
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    className: "project-header-menu-whole-div-2-import-button"
  }, /*#__PURE__*/React.createElement(FiDownload, {
    className: "project-header-menu-whole-div-2-import-button-icon"
  }), " Export")))), activeTab == "listView" ? /*#__PURE__*/React.createElement("div", {
    className: "task-header-menu-whole-div-content-whole-filter-content-div"
  }, /*#__PURE__*/React.createElement(Tabs, {
    className: "task-header-menu-whole-div-content-whole-filter-content-div-table-view",
    defaultActiveKey: "taskList",
    onSelect: function onSelect(e) {
      handleTableTabSelect(e);
    }
  }, /*#__PURE__*/React.createElement(Tab, {
    eventKey: "taskList",
    title: /*#__PURE__*/React.createElement("span", null, "All ".concat((taskCountData === null || taskCountData === void 0 ? void 0 : (_taskCountData$taskCo = taskCountData.taskCount) === null || _taskCountData$taskCo === void 0 ? void 0 : _taskCountData$taskCo.allTaskCount) != 0 && !taskCountLoading && !taskCountError ? "(".concat(taskCountData === null || taskCountData === void 0 ? void 0 : (_taskCountData$taskCo2 = taskCountData.taskCount) === null || _taskCountData$taskCo2 === void 0 ? void 0 : _taskCountData$taskCo2.allTaskCount, ")") : ""))
  }, /*#__PURE__*/React.createElement(TableData, {
    projectTasksList: taskListData === null || taskListData === void 0 ? void 0 : taskListData.projectTasks,
    taskListError: taskListError,
    taskListLoading: taskListLoading,
    taskFetchMore: taskFetchMore,
    taskStartDate: startDate,
    allowEmployeesToManageTheirTasks: allowEmployeesToManageTheirTasks,
    allowEmployeesToMarkTheirTasksAsCompleted: allowEmployeesToMarkTheirTasksAsCompleted,
    handleShow: handleShow,
    userId: user === null || user === void 0 ? void 0 : user.userId,
    handleTaskDeleteShow: handleTaskDeleteShow,
    tableView: tableView,
    handleShowTaskDetails: handleShowTaskDetails,
    handleTaskShow: handleTaskShow,
    projectId: projectId,
    role: role,
    filterPriority: filterPriority,
    projectSearch: projectSearch,
    handleCompletedShow: handleCompletedShow,
    handleUndoCompletedShow: handleUndoCompletedShow,
    handleHoldShow: handleHoldShow,
    setQuickEditToDoWorkingStatus: setQuickEditToDoWorkingStatus,
    setQuickEditInProgressWorkingStatus: setQuickEditInProgressWorkingStatus,
    setQuickEditDueWorkingStatus: setQuickEditDueWorkingStatus,
    setQuickEditCompletedWorkingStatus: setQuickEditCompletedWorkingStatus,
    setQuickEditHoldWorkingStatus: setQuickEditHoldWorkingStatus,
    taskActive: taskActive,
    setIsQuickEditModal: setIsQuickEditModal,
    setIsQuickEditMemberModal: setIsQuickEditMemberModal,
    quickEditWorkingStatus: quickEditWorkingStatus,
    quickEditType: quickEditType,
    isQuickEditSelect: isQuickEditSelect,
    setIsQuickEditSelect: setIsQuickEditSelect,
    setTaskActive: setTaskActive,
    isQuickEditToDoSelect: isQuickEditToDoSelect,
    setIsQuickEditToDoSelect: setIsQuickEditToDoSelect,
    isQuickEditInProgressSelect: isQuickEditInProgressSelect,
    setIsQuickEditInProgressSelect: setIsQuickEditInProgressSelect,
    isQuickEditDueSelect: isQuickEditDueSelect,
    setIsQuickEditDueSelect: setIsQuickEditDueSelect,
    isQuickEditCompletedSelect: isQuickEditCompletedSelect,
    setIsQuickEditCompletedSelect: setIsQuickEditCompletedSelect,
    isQuickEditHoldSelect: isQuickEditHoldSelect,
    setIsQuickEditHoldSelect: setIsQuickEditHoldSelect,
    setToDoTaskActive: setToDoTaskActive,
    setInProgessTaskActive: setInProgessTaskActive,
    setOverDueTaskActive: setOverDueTaskActive,
    setCompletedTaskActive: setCompletedTaskActive,
    setHoldTaskActive: setHoldTaskActive,
    setQuickEditWorkingStatus: setQuickEditWorkingStatus,
    isQuickEditCheck: isQuickEditCheck,
    parameterCheck: parameterCheck
  })), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "upcomingTasks",
    title: /*#__PURE__*/React.createElement("span", null, "To Do ".concat((taskCountData === null || taskCountData === void 0 ? void 0 : (_taskCountData$taskCo3 = taskCountData.taskCount) === null || _taskCountData$taskCo3 === void 0 ? void 0 : _taskCountData$taskCo3.upcomingTaskCount) != 0 && !taskCountLoading && !taskCountError ? "(".concat(taskCountData === null || taskCountData === void 0 ? void 0 : (_taskCountData$taskCo4 = taskCountData.taskCount) === null || _taskCountData$taskCo4 === void 0 ? void 0 : _taskCountData$taskCo4.upcomingTaskCount, ")") : ""))
  }, /*#__PURE__*/React.createElement(TableData, {
    projectTasksList: filterTaskData === null || filterTaskData === void 0 ? void 0 : filterTaskData.getFilterTaskTrackerDetails,
    taskListError: filterTaskError,
    taskListLoading: filterTaskLoading,
    taskFetchMore: filterTaskFetchMore,
    taskStartDate: startDate,
    allowEmployeesToManageTheirTasks: allowEmployeesToManageTheirTasks,
    allowEmployeesToMarkTheirTasksAsCompleted: allowEmployeesToMarkTheirTasksAsCompleted,
    handleShow: handleShow,
    userId: user === null || user === void 0 ? void 0 : user.userId,
    handleTaskDeleteShow: handleTaskDeleteShow,
    tableView: tableView,
    handleShowTaskDetails: handleShowTaskDetails,
    handleTaskShow: handleTaskShow,
    projectId: projectId,
    role: role,
    filterPriority: filterPriority,
    projectSearch: projectSearch,
    handleCompletedShow: handleCompletedShow,
    handleUndoCompletedShow: handleUndoCompletedShow,
    handleHoldShow: handleHoldShow,
    setQuickEditToDoWorkingStatus: setQuickEditToDoWorkingStatus,
    setQuickEditInProgressWorkingStatus: setQuickEditInProgressWorkingStatus,
    setQuickEditDueWorkingStatus: setQuickEditDueWorkingStatus,
    setQuickEditCompletedWorkingStatus: setQuickEditCompletedWorkingStatus,
    setQuickEditHoldWorkingStatus: setQuickEditHoldWorkingStatus,
    taskActive: taskActive,
    setIsQuickEditModal: setIsQuickEditModal,
    setIsQuickEditMemberModal: setIsQuickEditMemberModal,
    quickEditWorkingStatus: quickEditWorkingStatus,
    quickEditType: quickEditType,
    isQuickEditSelect: isQuickEditSelect,
    setIsQuickEditSelect: setIsQuickEditSelect,
    setTaskActive: setTaskActive,
    isQuickEditToDoSelect: isQuickEditToDoSelect,
    setIsQuickEditToDoSelect: setIsQuickEditToDoSelect,
    isQuickEditInProgressSelect: isQuickEditInProgressSelect,
    setIsQuickEditInProgressSelect: setIsQuickEditInProgressSelect,
    isQuickEditDueSelect: isQuickEditDueSelect,
    setIsQuickEditDueSelect: setIsQuickEditDueSelect,
    isQuickEditCompletedSelect: isQuickEditCompletedSelect,
    setIsQuickEditCompletedSelect: setIsQuickEditCompletedSelect,
    isQuickEditHoldSelect: isQuickEditHoldSelect,
    setIsQuickEditHoldSelect: setIsQuickEditHoldSelect,
    setToDoTaskActive: setToDoTaskActive,
    setInProgessTaskActive: setInProgessTaskActive,
    setOverDueTaskActive: setOverDueTaskActive,
    setCompletedTaskActive: setCompletedTaskActive,
    setHoldTaskActive: setHoldTaskActive,
    setQuickEditWorkingStatus: setQuickEditWorkingStatus,
    isQuickEditCheck: isQuickEditCheck,
    parameterCheck: parameterCheck
  })), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "inProgressTasks",
    title: /*#__PURE__*/React.createElement("span", null, "In Progress ".concat((taskCountData === null || taskCountData === void 0 ? void 0 : (_taskCountData$taskCo5 = taskCountData.taskCount) === null || _taskCountData$taskCo5 === void 0 ? void 0 : _taskCountData$taskCo5.inProgressCount) != 0 && !taskCountLoading && !taskCountError ? "(".concat(taskCountData === null || taskCountData === void 0 ? void 0 : (_taskCountData$taskCo6 = taskCountData.taskCount) === null || _taskCountData$taskCo6 === void 0 ? void 0 : _taskCountData$taskCo6.inProgressCount, ")") : ""))
  }, /*#__PURE__*/React.createElement(TableData, {
    projectTasksList: filterTaskData === null || filterTaskData === void 0 ? void 0 : filterTaskData.getFilterTaskTrackerDetails,
    taskListError: filterTaskError,
    taskListLoading: filterTaskLoading,
    taskFetchMore: filterTaskFetchMore,
    taskStartDate: startDate,
    allowEmployeesToManageTheirTasks: allowEmployeesToManageTheirTasks,
    allowEmployeesToMarkTheirTasksAsCompleted: allowEmployeesToMarkTheirTasksAsCompleted,
    handleShow: handleShow,
    userId: user === null || user === void 0 ? void 0 : user.userId,
    handleTaskDeleteShow: handleTaskDeleteShow,
    tableView: tableView,
    handleShowTaskDetails: handleShowTaskDetails,
    handleTaskShow: handleTaskShow,
    projectId: projectId,
    role: role,
    filterPriority: filterPriority,
    projectSearch: projectSearch,
    handleCompletedShow: handleCompletedShow,
    handleUndoCompletedShow: handleUndoCompletedShow,
    handleHoldShow: handleHoldShow,
    setQuickEditToDoWorkingStatus: setQuickEditToDoWorkingStatus,
    setQuickEditInProgressWorkingStatus: setQuickEditInProgressWorkingStatus,
    setQuickEditDueWorkingStatus: setQuickEditDueWorkingStatus,
    setQuickEditCompletedWorkingStatus: setQuickEditCompletedWorkingStatus,
    setQuickEditHoldWorkingStatus: setQuickEditHoldWorkingStatus,
    taskActive: taskActive,
    setIsQuickEditModal: setIsQuickEditModal,
    setIsQuickEditMemberModal: setIsQuickEditMemberModal,
    quickEditWorkingStatus: quickEditWorkingStatus,
    quickEditType: quickEditType,
    isQuickEditSelect: isQuickEditSelect,
    setIsQuickEditSelect: setIsQuickEditSelect,
    setTaskActive: setTaskActive,
    isQuickEditToDoSelect: isQuickEditToDoSelect,
    setIsQuickEditToDoSelect: setIsQuickEditToDoSelect,
    isQuickEditInProgressSelect: isQuickEditInProgressSelect,
    setIsQuickEditInProgressSelect: setIsQuickEditInProgressSelect,
    isQuickEditDueSelect: isQuickEditDueSelect,
    setIsQuickEditDueSelect: setIsQuickEditDueSelect,
    isQuickEditCompletedSelect: isQuickEditCompletedSelect,
    setIsQuickEditCompletedSelect: setIsQuickEditCompletedSelect,
    isQuickEditHoldSelect: isQuickEditHoldSelect,
    setIsQuickEditHoldSelect: setIsQuickEditHoldSelect,
    setToDoTaskActive: setToDoTaskActive,
    setInProgessTaskActive: setInProgessTaskActive,
    setOverDueTaskActive: setOverDueTaskActive,
    setCompletedTaskActive: setCompletedTaskActive,
    setHoldTaskActive: setHoldTaskActive,
    setQuickEditWorkingStatus: setQuickEditWorkingStatus,
    isQuickEditCheck: isQuickEditCheck,
    parameterCheck: parameterCheck
  })), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "completed",
    title: /*#__PURE__*/React.createElement("span", null, "Completed ".concat((taskCountData === null || taskCountData === void 0 ? void 0 : (_taskCountData$taskCo7 = taskCountData.taskCount) === null || _taskCountData$taskCo7 === void 0 ? void 0 : _taskCountData$taskCo7.completedTaskCount) != 0 && !taskCountLoading && !taskCountError ? "(".concat(taskCountData === null || taskCountData === void 0 ? void 0 : (_taskCountData$taskCo8 = taskCountData.taskCount) === null || _taskCountData$taskCo8 === void 0 ? void 0 : _taskCountData$taskCo8.completedTaskCount, ")") : ""))
  }, /*#__PURE__*/React.createElement(TableData, {
    projectTasksList: filterTaskData === null || filterTaskData === void 0 ? void 0 : filterTaskData.getFilterTaskTrackerDetails,
    taskListError: filterTaskError,
    taskListLoading: filterTaskLoading,
    taskFetchMore: filterTaskFetchMore,
    taskStartDate: startDate,
    allowEmployeesToManageTheirTasks: allowEmployeesToManageTheirTasks,
    allowEmployeesToMarkTheirTasksAsCompleted: allowEmployeesToMarkTheirTasksAsCompleted,
    handleShow: handleShow,
    userId: user === null || user === void 0 ? void 0 : user.userId,
    handleTaskDeleteShow: handleTaskDeleteShow,
    tableView: tableView,
    handleShowTaskDetails: handleShowTaskDetails,
    handleTaskShow: handleTaskShow,
    projectId: projectId,
    role: role,
    filterPriority: filterPriority,
    projectSearch: projectSearch,
    handleCompletedShow: handleCompletedShow,
    handleUndoCompletedShow: handleUndoCompletedShow,
    handleHoldShow: handleHoldShow,
    setQuickEditToDoWorkingStatus: setQuickEditToDoWorkingStatus,
    setQuickEditInProgressWorkingStatus: setQuickEditInProgressWorkingStatus,
    setQuickEditDueWorkingStatus: setQuickEditDueWorkingStatus,
    setQuickEditCompletedWorkingStatus: setQuickEditCompletedWorkingStatus,
    setQuickEditHoldWorkingStatus: setQuickEditHoldWorkingStatus,
    taskActive: taskActive,
    setIsQuickEditModal: setIsQuickEditModal,
    setIsQuickEditMemberModal: setIsQuickEditMemberModal,
    quickEditWorkingStatus: quickEditWorkingStatus,
    quickEditType: quickEditType,
    isQuickEditSelect: isQuickEditSelect,
    setIsQuickEditSelect: setIsQuickEditSelect,
    setTaskActive: setTaskActive,
    isQuickEditToDoSelect: isQuickEditToDoSelect,
    setIsQuickEditToDoSelect: setIsQuickEditToDoSelect,
    isQuickEditInProgressSelect: isQuickEditInProgressSelect,
    setIsQuickEditInProgressSelect: setIsQuickEditInProgressSelect,
    isQuickEditDueSelect: isQuickEditDueSelect,
    setIsQuickEditDueSelect: setIsQuickEditDueSelect,
    isQuickEditCompletedSelect: isQuickEditCompletedSelect,
    setIsQuickEditCompletedSelect: setIsQuickEditCompletedSelect,
    isQuickEditHoldSelect: isQuickEditHoldSelect,
    setIsQuickEditHoldSelect: setIsQuickEditHoldSelect,
    setToDoTaskActive: setToDoTaskActive,
    setInProgessTaskActive: setInProgessTaskActive,
    setOverDueTaskActive: setOverDueTaskActive,
    setCompletedTaskActive: setCompletedTaskActive,
    setHoldTaskActive: setHoldTaskActive,
    setQuickEditWorkingStatus: setQuickEditWorkingStatus,
    isQuickEditCheck: isQuickEditCheck,
    parameterCheck: parameterCheck
  })), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "hold",
    title: /*#__PURE__*/React.createElement("span", null, "On Hold ".concat((taskCountData === null || taskCountData === void 0 ? void 0 : (_taskCountData$taskCo9 = taskCountData.taskCount) === null || _taskCountData$taskCo9 === void 0 ? void 0 : _taskCountData$taskCo9.holdTaskCount) != 0 && !taskCountLoading && !taskCountError ? "(".concat(taskCountData === null || taskCountData === void 0 ? void 0 : (_taskCountData$taskCo10 = taskCountData.taskCount) === null || _taskCountData$taskCo10 === void 0 ? void 0 : _taskCountData$taskCo10.holdTaskCount, ")") : ""))
  }, /*#__PURE__*/React.createElement(TableData, {
    projectTasksList: filterTaskData === null || filterTaskData === void 0 ? void 0 : filterTaskData.getFilterTaskTrackerDetails,
    taskListError: filterTaskError,
    taskListLoading: filterTaskLoading,
    taskFetchMore: filterTaskFetchMore,
    taskStartDate: startDate,
    allowEmployeesToManageTheirTasks: allowEmployeesToManageTheirTasks,
    allowEmployeesToMarkTheirTasksAsCompleted: allowEmployeesToMarkTheirTasksAsCompleted,
    handleShow: handleShow,
    userId: user === null || user === void 0 ? void 0 : user.userId,
    handleTaskDeleteShow: handleTaskDeleteShow,
    tableView: tableView,
    handleShowTaskDetails: handleShowTaskDetails,
    handleTaskShow: handleTaskShow,
    projectId: projectId,
    role: role,
    filterPriority: filterPriority,
    projectSearch: projectSearch,
    handleCompletedShow: handleCompletedShow,
    handleUndoCompletedShow: handleUndoCompletedShow,
    handleHoldShow: handleHoldShow,
    setQuickEditToDoWorkingStatus: setQuickEditToDoWorkingStatus,
    setQuickEditInProgressWorkingStatus: setQuickEditInProgressWorkingStatus,
    setQuickEditDueWorkingStatus: setQuickEditDueWorkingStatus,
    setQuickEditCompletedWorkingStatus: setQuickEditCompletedWorkingStatus,
    setQuickEditHoldWorkingStatus: setQuickEditHoldWorkingStatus,
    taskActive: taskActive,
    setIsQuickEditModal: setIsQuickEditModal,
    setIsQuickEditMemberModal: setIsQuickEditMemberModal,
    quickEditWorkingStatus: quickEditWorkingStatus,
    quickEditType: quickEditType,
    isQuickEditSelect: isQuickEditSelect,
    setIsQuickEditSelect: setIsQuickEditSelect,
    setTaskActive: setTaskActive,
    isQuickEditToDoSelect: isQuickEditToDoSelect,
    setIsQuickEditToDoSelect: setIsQuickEditToDoSelect,
    isQuickEditInProgressSelect: isQuickEditInProgressSelect,
    setIsQuickEditInProgressSelect: setIsQuickEditInProgressSelect,
    isQuickEditDueSelect: isQuickEditDueSelect,
    setIsQuickEditDueSelect: setIsQuickEditDueSelect,
    isQuickEditCompletedSelect: isQuickEditCompletedSelect,
    setIsQuickEditCompletedSelect: setIsQuickEditCompletedSelect,
    isQuickEditHoldSelect: isQuickEditHoldSelect,
    setIsQuickEditHoldSelect: setIsQuickEditHoldSelect,
    setToDoTaskActive: setToDoTaskActive,
    setInProgessTaskActive: setInProgessTaskActive,
    setOverDueTaskActive: setOverDueTaskActive,
    setCompletedTaskActive: setCompletedTaskActive,
    setHoldTaskActive: setHoldTaskActive,
    setQuickEditWorkingStatus: setQuickEditWorkingStatus,
    isQuickEditCheck: isQuickEditCheck,
    parameterCheck: parameterCheck
  })), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "onDue",
    title: /*#__PURE__*/React.createElement("span", null, "Overdue ".concat((taskCountData === null || taskCountData === void 0 ? void 0 : (_taskCountData$taskCo11 = taskCountData.taskCount) === null || _taskCountData$taskCo11 === void 0 ? void 0 : _taskCountData$taskCo11.onDueTaskCount) != 0 && !taskCountLoading && !taskCountError ? "(".concat(taskCountData === null || taskCountData === void 0 ? void 0 : (_taskCountData$taskCo12 = taskCountData.taskCount) === null || _taskCountData$taskCo12 === void 0 ? void 0 : _taskCountData$taskCo12.onDueTaskCount, ")") : ""))
  }, /*#__PURE__*/React.createElement(TableData, {
    projectTasksList: filterTaskData === null || filterTaskData === void 0 ? void 0 : filterTaskData.getFilterTaskTrackerDetails,
    taskListError: filterTaskError,
    taskListLoading: filterTaskLoading,
    taskFetchMore: filterTaskFetchMore,
    taskStartDate: startDate,
    allowEmployeesToManageTheirTasks: allowEmployeesToManageTheirTasks,
    allowEmployeesToMarkTheirTasksAsCompleted: allowEmployeesToMarkTheirTasksAsCompleted,
    handleShow: handleShow,
    userId: user === null || user === void 0 ? void 0 : user.userId,
    handleTaskDeleteShow: handleTaskDeleteShow,
    tableView: tableView,
    handleShowTaskDetails: handleShowTaskDetails,
    handleTaskShow: handleTaskShow,
    projectId: projectId,
    role: role,
    filterPriority: filterPriority,
    projectSearch: projectSearch,
    handleCompletedShow: handleCompletedShow,
    handleUndoCompletedShow: handleUndoCompletedShow,
    handleHoldShow: handleHoldShow,
    setQuickEditToDoWorkingStatus: setQuickEditToDoWorkingStatus,
    setQuickEditInProgressWorkingStatus: setQuickEditInProgressWorkingStatus,
    setQuickEditDueWorkingStatus: setQuickEditDueWorkingStatus,
    setQuickEditCompletedWorkingStatus: setQuickEditCompletedWorkingStatus,
    setQuickEditHoldWorkingStatus: setQuickEditHoldWorkingStatus,
    taskActive: taskActive,
    setIsQuickEditModal: setIsQuickEditModal,
    setIsQuickEditMemberModal: setIsQuickEditMemberModal,
    quickEditWorkingStatus: quickEditWorkingStatus,
    quickEditType: quickEditType,
    isQuickEditSelect: isQuickEditSelect,
    setIsQuickEditSelect: setIsQuickEditSelect,
    setTaskActive: setTaskActive,
    isQuickEditToDoSelect: isQuickEditToDoSelect,
    setIsQuickEditToDoSelect: setIsQuickEditToDoSelect,
    isQuickEditInProgressSelect: isQuickEditInProgressSelect,
    setIsQuickEditInProgressSelect: setIsQuickEditInProgressSelect,
    isQuickEditDueSelect: isQuickEditDueSelect,
    setIsQuickEditDueSelect: setIsQuickEditDueSelect,
    isQuickEditCompletedSelect: isQuickEditCompletedSelect,
    setIsQuickEditCompletedSelect: setIsQuickEditCompletedSelect,
    isQuickEditHoldSelect: isQuickEditHoldSelect,
    setIsQuickEditHoldSelect: setIsQuickEditHoldSelect,
    setToDoTaskActive: setToDoTaskActive,
    setInProgessTaskActive: setInProgessTaskActive,
    setOverDueTaskActive: setOverDueTaskActive,
    setCompletedTaskActive: setCompletedTaskActive,
    setHoldTaskActive: setHoldTaskActive,
    setQuickEditWorkingStatus: setQuickEditWorkingStatus,
    isQuickEditCheck: isQuickEditCheck,
    parameterCheck: parameterCheck
  })))) : /*#__PURE__*/React.createElement("div", {
    className: "task-header-menu-whole-div-content-whole-filter-content-div"
  }, (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planId) == "83844da8-71e8-4e94-b6ac-aaff5d8a858c" || organisationId == "b8a0b6a0-389b-11ed-9b14-ebb2f09d4883" ? /*#__PURE__*/React.createElement("div", {
    className: "task-header-menu-whole-div-content-whole-filter-content-div-canban-view-whole"
  }, /*#__PURE__*/React.createElement(KanbanView, {
    taskCountData: taskCountData,
    taskCountLoading: taskCountLoading,
    taskCountError: taskCountError,
    organisationId: organisationId,
    teamId: teamId,
    role: role,
    user: user,
    projectId: projectId,
    timezone: timezone,
    projectSearch: projectSearch,
    handleShowTaskDetails: handleShowTaskDetails,
    allowEmployeesToManageTheirTasks: allowEmployeesToManageTheirTasks,
    userId: user === null || user === void 0 ? void 0 : user.userId,
    taskStartDate: startDate,
    allowEmployeesToMarkTheirTasksAsCompleted: allowEmployeesToMarkTheirTasksAsCompleted,
    handleShow: handleShow,
    handleTaskDeleteShow: handleTaskDeleteShow,
    handleCompletedShow: handleCompletedShow,
    handleUndoCompletedShow: handleUndoCompletedShow,
    handleHoldShow: handleHoldShow
  })) : /*#__PURE__*/React.createElement("div", {
    className: "task-header-menu-whole-div-content-whole-filter-content-div-canban-view"
  }, "Upgrade to the premium plan to unlock the kanban view"))))), /*#__PURE__*/React.createElement(AddTaskModal, {
    addTaskShow: addTaskShow,
    setAddTaskShow: setAddTaskShow,
    handleTaskClose: handleTaskClose,
    organisationId: organisationId,
    teamId: teamId,
    projectId: projectId,
    timeZone: timezone,
    pageType: "project-details",
    startDate: startDate,
    endDate: endDate,
    projectSearch: projectSearch,
    filterPriority: filterPriority
  }), /*#__PURE__*/React.createElement(TaskModal, {
    taskDetails: taskDetails,
    handleClose: handleClose,
    projectId: projectId,
    organisationId: organisationId,
    startDate: startDate,
    endDate: endDate,
    timezone: timezone,
    activeTab: tableView,
    user: user,
    role: role,
    allowEmployeesToMarkTheirTasksAsCompleted: allowEmployeesToMarkTheirTasksAsCompleted,
    projectSearch: projectSearch,
    filterPriority: filterPriority,
    view: activeTab
  }), /*#__PURE__*/React.createElement(DeleteTaskModal, {
    showTaskDeleteModal: showTaskDeleteModal,
    handleTaskDeleteClose: handleTaskDeleteClose,
    organisationId: organisationId,
    projectId: projectId,
    userId: user === null || user === void 0 ? void 0 : user.userId,
    history: history,
    teamId: teamId,
    startDate: startDate,
    endDate: endDate,
    TASK_LIMIT: TASK_LIMIT,
    timezone: timezone,
    activeTab: tableView,
    user: user,
    role: role,
    getEmployeeDetails: getEmployeeDetails,
    projectSearch: projectSearch,
    filterPriority: filterPriority,
    view: activeTab
  }), /*#__PURE__*/React.createElement(ImportTaskModal, {
    importTaskShow: importTaskShow,
    setImportButton: setImportButton,
    handleImportTaskClose: handleImportTaskClose,
    organisationId: organisationId,
    teamId: teamId,
    projectId: projectId,
    timeZone: timezone,
    startDate: startDate,
    endDate: endDate,
    projectSearch: projectSearch,
    filterPriority: filterPriority
  }), /*#__PURE__*/React.createElement(TaskDetailsModal, {
    showTaskModal: showTaskModal,
    setShowTaskModal: setShowTaskModal,
    handleShowTaskDetails: handleShowTaskDetails,
    handleCloseTaskDetails: handleCloseTaskDetails,
    projectId: projectId,
    organisationId: organisationId,
    startDate: startDate,
    endDate: endDate,
    timezone: timezone,
    projectName: projectName,
    taskDetailsData: taskDetailsData,
    taskDetailsError: taskDetailsError,
    taskDetailsLoading: taskDetailsLoading,
    getTaskDetails: getTaskDetails,
    TASK_EMP_LIMIT: TASK_EMP_LIMIT,
    TASK_EMP_OFFSETS: TASK_EMP_OFFSETS,
    taskDetailsActiveTab: taskDetailsActiveTab,
    setTaskDetailsActiveTab: setTaskDetailsActiveTab,
    getTaskEmployeeTimeline: getTaskEmployeeTimeline,
    taskTimelineData: taskTimelineData,
    taskTimelineError: taskTimelineError,
    taskTimelineLoading: taskTimelineLoading,
    taskTimelineFetchMore: taskTimelineFetchMore,
    getTaskActivitySummary: getTaskActivitySummary,
    taskActivitySummaryData: taskActivitySummaryData,
    taskActivitySummaryError: taskActivitySummaryError,
    taskActivitySummaryLoading: taskActivitySummaryLoading,
    taskActivitySummaryFetchMore: taskActivitySummaryFetchMore,
    taskDetailsFetchMore: taskDetailsFetchMore,
    role: role,
    userId: user.userId,
    userUrl: user.uniqueUrl
  }), /*#__PURE__*/React.createElement(CompletedConfirmationProject, {
    handleCompletedClose: handleCompletedClose,
    showcompletedModal: showcompletedModal,
    setShowcompletedModal: setShowcompletedModal,
    completedTask: completedTask,
    setCompletedTask: setCompletedTask,
    completedTaskList: completedTaskList,
    setCompletedTaskList: setCompletedTaskList,
    organisationId: organisationId,
    startDate: startDate,
    endDate: endDate,
    timezone: timezone,
    role: role,
    user: user,
    projectSearch: projectSearch,
    filterPriority: filterPriority,
    activeTab: tableView,
    view: activeTab
  }), /*#__PURE__*/React.createElement(UndoCompleteConfirmation, {
    handleUndoCompletedClose: handleUndoCompletedClose,
    showUndocompletedModal: showUndocompletedModal,
    setShowUndocompletedModal: setShowUndocompletedModal,
    undoCompletedTask: undoCompletedTask,
    setUndoCompletedTask: setUndoCompletedTask,
    undoCompletedTaskList: undoCompletedTaskList,
    setUndoCompletedTaskList: setUndoCompletedTaskList,
    organisationId: organisationId,
    startDate: startDate,
    endDate: endDate,
    timezone: timezone,
    role: role,
    user: user,
    projectSearch: projectSearch,
    filterPriority: filterPriority,
    activeTab: tableView,
    view: activeTab
  }), /*#__PURE__*/React.createElement(HoldConfirmationProject, {
    handleHoldClose: handleHoldClose,
    showHoldModal: showHoldModal,
    setShowHoldModal: setShowHoldModal,
    holdTask: holdTask,
    setHoldTask: setHoldTask,
    holdTaskList: holdTaskList,
    setHoldTaskList: setHoldTaskList,
    organisationId: organisationId,
    startDate: startDate,
    endDate: endDate,
    timezone: timezone,
    role: role,
    user: user,
    projectSearch: projectSearch,
    filterPriority: filterPriority,
    activeTab: tableView,
    view: activeTab
  }), /*#__PURE__*/React.createElement(QuickEditModal, {
    isQuickEditModal: isQuickEditModal,
    setIsQuickEditModal: setIsQuickEditModal,
    quickHandleClose: quickHandleClose,
    projectId: projectId,
    organisationId: organisationId,
    timezone: timezone,
    taskActive: taskActive,
    teamId: teamId,
    startDate: startDate,
    endDate: endDate,
    toDoTaskActive: toDoTaskActive,
    inProgessTaskActive: inProgessTaskActive,
    overDueTaskActive: overDueTaskActive,
    completedTaskActive: completedTaskActive,
    holdTaskActive: holdTaskActive,
    quickEditType: quickEditType,
    setQuickEditType: setQuickEditType,
    activeTab: tableView,
    setTaskActive: setTaskActive,
    setToDoTaskActive: setToDoTaskActive,
    setInProgessTaskActive: setInProgessTaskActive,
    setOverDueTaskActive: setOverDueTaskActive,
    setCompletedTaskActive: setCompletedTaskActive,
    setHoldTaskActive: setHoldTaskActive,
    projectSearch: projectSearch,
    filterPriority: filterPriority
  }), /*#__PURE__*/React.createElement(QuickEditMemberModal, {
    isQuickEditMemberModal: isQuickEditMemberModal,
    setIsQuickEditMemberModal: setIsQuickEditMemberModal,
    quickHandleMemberClose: quickHandleMemberClose,
    projectId: projectId,
    organisationId: organisationId,
    timezone: timezone,
    taskActive: taskActive,
    teamId: teamId,
    startDate: startDate,
    endDate: endDate,
    toDoTaskActive: toDoTaskActive,
    inProgessTaskActive: inProgessTaskActive,
    overDueTaskActive: overDueTaskActive,
    completedTaskActive: completedTaskActive,
    holdTaskActive: holdTaskActive,
    quickEditType: quickEditType,
    setQuickEditType: setQuickEditType,
    setIsQuickEditModal: setIsQuickEditModal,
    activeTab: tableView,
    projectSearch: projectSearch,
    filterPriority: filterPriority
  }));
};
var Reports = function Reports(props) {
  var _taskCountData$taskCo13, _taskCountData$taskCo14, _taskCountData$taskCo15, _taskCountData$taskCo16, _taskCountData$taskCo17, _taskCountData$taskCo18, _taskCountData$taskCo19, _taskCountData$taskCo20, _taskCountData$taskCo21, _taskCountData$taskCo22, _taskCountData$taskCo23, _taskCountData$taskCo24, _taskCountData$taskCo25, _taskCountData$taskCo26, _taskCountData$taskCo27, _personWiseCountData$, _priorityCountData$ge, _priorityCountData$ge2, _priorityCountData$ge3, _priorityCountData$ge4, _priorityCountData$ge5, _priorityCountData$ge6, _priorityCountData$ge7, _priorityCountData$ge8, _priorityCountData$ge9, _priorityCountData$ge10, _priorityCountData$ge11, _priorityCountData$ge12, _priorityCountData$ge13, _priorityCountData$ge14, _priorityCountData$ge15, _priorityCountData$ge16, _priorityCountData$ge17, _priorityCountData$ge18, _priorityCountData$ge19, _priorityCountData$ge20, _priorityCountData$ge21, _priorityCountData$ge22, _priorityCountData$ge23, _priorityCountData$ge24, _priorityCountData$ge25, _priorityCountData$ge26, _priorityCountData$ge27, _priorityCountData$ge28, _priorityCountData$ge29, _priorityCountData$ge30, _priorityCountData$ge31, _priorityCountData$ge32, _priorityCountData$ge33, _priorityCountData$ge34, _priorityCountData$ge35, _priorityCountData$ge36;
  var role = props.role,
    organisationId = props.organisationId,
    teamId = props.teamId,
    user = props.user,
    projectId = props.projectId,
    timezone = props.timezone,
    activeTab = props.activeTab;
  var shouldFetch = activeTab === "reports"; // or from parent prop

  var colors = ["#519afb", "#2a9d90", "#21c45d", "#f59f0a", "#ef4343"];
  var colorss = ["#ef4343", "#f59f0a", "#21c45d", "#e1e7ef"];
  var width = 564;
  var height = 300;
  var _useQuery7 = useQuery(TASK_COUNT_QUERY, {
      variables: {
        organisationId: organisationId,
        teamId: teamId,
        userId: role == "Member" ? user === null || user === void 0 ? void 0 : user.userId : null,
        projectId: [projectId],
        taskId: null,
        role: role
      },
      fetchPolicy: "network-only",
      skip: !shouldFetch || !organisationId
    }),
    taskCountData = _useQuery7.data,
    taskCountError = _useQuery7.error,
    taskCountLoading = _useQuery7.loading,
    taskCountRefetch = _useQuery7.refetch;
  var _useQuery8 = useQuery(PROJECT_PRIORITY_DETAILS_SUMMARY_QUERY, {
      variables: {
        organisationId: organisationId,
        projectId: projectId
      },
      fetchPolicy: "network-only",
      skip: !shouldFetch || !organisationId
    }),
    priorityCountData = _useQuery8.data,
    priorityCountError = _useQuery8.error,
    priorityCountLoading = _useQuery8.loading,
    priorityCountRefetch = _useQuery8.refetch;
  var _useQuery9 = useQuery(PROJECT_PERSON_WISE_TASK_STATUS_QUERY, {
      variables: {
        organisationId: organisationId,
        projectId: projectId
      },
      fetchPolicy: "network-only",
      skip: !shouldFetch || !organisationId
    }),
    personWiseCountData = _useQuery9.data,
    personWiseCountError = _useQuery9.error,
    personWiseCountLoading = _useQuery9.loading,
    personWiseCountRefetch = _useQuery9.refetch;
  var data = React.useMemo(function () {
    var d = (taskCountData === null || taskCountData === void 0 ? void 0 : taskCountData.taskCount) || {};
    var total = d.allTaskCount || 0;
    var pct = function pct(count) {
      return count && total ? Math.round(count / total * 100) : 0;
    };
    return [["Task Status", "Count", {
      role: "annotation"
    }], ["To Do", d.upcomingTaskCount || 0, "To Do \u2013 ".concat(pct(d.upcomingTaskCount), "%")], ["In Progress", d.inProgressCount || 0, "In Progress \u2013 ".concat(pct(d.inProgressCount), "%")], ["Completed", d.completedTaskCount || 0, "Completed \u2013 ".concat(pct(d.completedTaskCount), "%")], ["On Hold", d.holdTaskCount || 0, "On Hold \u2013 ".concat(pct(d.holdTaskCount), "%")], ["Overdue", d.onDueTaskCount || 0, "Overdue \u2013 ".concat(pct(d.onDueTaskCount), "%")]];
  }, [taskCountData]);
  var dataPriority = React.useMemo(function () {
    var d = (priorityCountData === null || priorityCountData === void 0 ? void 0 : priorityCountData.getPriorityCount) || {};
    var high = Number(d.high || 0);
    var medium = Number(d.medium || 0);
    var low = Number(d.low || 0);
    var notSet = Number(d.notSet || 0);
    var total = high + medium + low + notSet || 1;
    return [["Task Priority", "Count", {
      role: "annotation"
    }], ["High", high, high ? "".concat(Math.round(high / total * 100), "%") : ""], ["Medium", medium, medium ? "".concat(Math.round(medium / total * 100), "%") : ""], ["Low", low, low ? "".concat(Math.round(low / total * 100), "%") : ""], ["Not Set", notSet, notSet ? "".concat(Math.round(notSet / total * 100), "%") : ""]];
  }, [priorityCountData]);
  var chartData = React.useMemo(function () {
    var list = (personWiseCountData === null || personWiseCountData === void 0 ? void 0 : personWiseCountData.personWiseTaskStatus) || [];

    // Build rows
    var rows = list.map(function (u) {
      return [u.displayName || "Unnamed", Number(u.todoTotalTask) || 0, Number(u.inProgressTotalTask) || 0, Number(u.completedTotalTask) || 0, Number(u.holdTotalTask) || 0, Number(u.onDueTotalTask) || 0];
    });
    return [["Person", "To Do", "In Progress", "Completed", "On Hold", "Overdue"]].concat(_toConsumableArray(rows));
  }, [personWiseCountData]);
  return /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs"
  }, /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-header-div"
  }, /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-header-h3"
  }, /*#__PURE__*/React.createElement(FaRegChartBar, {
    className: "reports-tabs-whole-graphs-1-header-h3-icon"
  }), "Overall Task Status Distribution"), /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-header-p"
  }, "Visual breakdown of all tasks by status"))), /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-content"
  }, taskCountLoading ? /*#__PURE__*/React.createElement(Loader, null) : taskCountError ? /*#__PURE__*/React.createElement("p", null, "Something went wrong, please refresh the page.") : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-content-text"
  }, /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-content-text-heading"
  }, "Task Status Summary"), /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-content-text-grid"
  }, /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-content-text-grid-list"
  }, /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-content-text-grid-list-heading"
  }, "To Do"), /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-content-text-grid-list-counts"
  }, /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-content-text-grid-list-count"
  }, taskCountData === null || taskCountData === void 0 ? void 0 : (_taskCountData$taskCo13 = taskCountData.taskCount) === null || _taskCountData$taskCo13 === void 0 ? void 0 : _taskCountData$taskCo13.upcomingTaskCount), /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-content-text-grid-list-percent"
  }, "(", Math.round((taskCountData === null || taskCountData === void 0 ? void 0 : (_taskCountData$taskCo14 = taskCountData.taskCount) === null || _taskCountData$taskCo14 === void 0 ? void 0 : _taskCountData$taskCo14.upcomingTaskCount) / (taskCountData === null || taskCountData === void 0 ? void 0 : (_taskCountData$taskCo15 = taskCountData.taskCount) === null || _taskCountData$taskCo15 === void 0 ? void 0 : _taskCountData$taskCo15.allTaskCount) * 100), "%)"))), /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-content-text-grid-list reports-tabs-whole-graphs-1-content-text-grid-list-in-progress"
  }, /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-content-text-grid-list-heading"
  }, "In Progress"), /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-content-text-grid-list-counts"
  }, /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-content-text-grid-list-count"
  }, taskCountData === null || taskCountData === void 0 ? void 0 : (_taskCountData$taskCo16 = taskCountData.taskCount) === null || _taskCountData$taskCo16 === void 0 ? void 0 : _taskCountData$taskCo16.inProgressCount), /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-content-text-grid-list-percent"
  }, "(", Math.round((taskCountData === null || taskCountData === void 0 ? void 0 : (_taskCountData$taskCo17 = taskCountData.taskCount) === null || _taskCountData$taskCo17 === void 0 ? void 0 : _taskCountData$taskCo17.inProgressCount) / (taskCountData === null || taskCountData === void 0 ? void 0 : (_taskCountData$taskCo18 = taskCountData.taskCount) === null || _taskCountData$taskCo18 === void 0 ? void 0 : _taskCountData$taskCo18.allTaskCount) * 100), "%)"))), /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-content-text-grid-list reports-tabs-whole-graphs-1-content-text-grid-list-completed"
  }, /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-content-text-grid-list-heading"
  }, "Completed"), /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-content-text-grid-list-counts"
  }, /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-content-text-grid-list-count"
  }, taskCountData === null || taskCountData === void 0 ? void 0 : (_taskCountData$taskCo19 = taskCountData.taskCount) === null || _taskCountData$taskCo19 === void 0 ? void 0 : _taskCountData$taskCo19.completedTaskCount), /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-content-text-grid-list-percent"
  }, "(", Math.round((taskCountData === null || taskCountData === void 0 ? void 0 : (_taskCountData$taskCo20 = taskCountData.taskCount) === null || _taskCountData$taskCo20 === void 0 ? void 0 : _taskCountData$taskCo20.completedTaskCount) / (taskCountData === null || taskCountData === void 0 ? void 0 : (_taskCountData$taskCo21 = taskCountData.taskCount) === null || _taskCountData$taskCo21 === void 0 ? void 0 : _taskCountData$taskCo21.allTaskCount) * 100), "%)"))), /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-content-text-grid-list reports-tabs-whole-graphs-1-content-text-grid-list-hold"
  }, /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-content-text-grid-list-heading"
  }, "On Hold"), /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-content-text-grid-list-counts"
  }, /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-content-text-grid-list-count"
  }, taskCountData === null || taskCountData === void 0 ? void 0 : (_taskCountData$taskCo22 = taskCountData.taskCount) === null || _taskCountData$taskCo22 === void 0 ? void 0 : _taskCountData$taskCo22.holdTaskCount), /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-content-text-grid-list-percent"
  }, "(", Math.round((taskCountData === null || taskCountData === void 0 ? void 0 : (_taskCountData$taskCo23 = taskCountData.taskCount) === null || _taskCountData$taskCo23 === void 0 ? void 0 : _taskCountData$taskCo23.holdTaskCount) / (taskCountData === null || taskCountData === void 0 ? void 0 : (_taskCountData$taskCo24 = taskCountData.taskCount) === null || _taskCountData$taskCo24 === void 0 ? void 0 : _taskCountData$taskCo24.allTaskCount) * 100), "%)"))), /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-content-text-grid-list reports-tabs-whole-graphs-1-content-text-grid-list-overdue"
  }, /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-content-text-grid-list-heading"
  }, "Overdue"), /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-content-text-grid-list-counts"
  }, /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-content-text-grid-list-count"
  }, taskCountData === null || taskCountData === void 0 ? void 0 : (_taskCountData$taskCo25 = taskCountData.taskCount) === null || _taskCountData$taskCo25 === void 0 ? void 0 : _taskCountData$taskCo25.onDueTaskCount), /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-content-text-grid-list-percent"
  }, "(", Math.round((taskCountData === null || taskCountData === void 0 ? void 0 : (_taskCountData$taskCo26 = taskCountData.taskCount) === null || _taskCountData$taskCo26 === void 0 ? void 0 : _taskCountData$taskCo26.onDueTaskCount) / (taskCountData === null || taskCountData === void 0 ? void 0 : (_taskCountData$taskCo27 = taskCountData.taskCount) === null || _taskCountData$taskCo27 === void 0 ? void 0 : _taskCountData$taskCo27.allTaskCount) * 100), "%)"))))), /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-content-graph"
  }, taskCountLoading ? /*#__PURE__*/React.createElement(Loader, null) : taskCountError ? /*#__PURE__*/React.createElement("p", null, "Something went wrong") : taskCountData ? /*#__PURE__*/React.createElement(Chart, {
    chartType: "PieChart",
    width: "".concat(width, "px"),
    height: "".concat(height, "px"),
    data: data,
    options: {
      colors: colors,
      backgroundColor: "transparent",
      chartArea: {
        top: 10,
        bottom: 10,
        left: 10,
        right: 10
      },
      pieSliceText: "label",
      // hide default text
      legend: {
        position: "right",
        alignment: "center"
      },
      annotations: {
        textStyle: {
          fontSize: 12,
          bold: true
        }
      }
    }
  }) : null)))), /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-header-div"
  }, /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-header-h3"
  }, /*#__PURE__*/React.createElement(FiTarget, {
    className: "reports-tabs-whole-graphs-1-header-h3-icon"
  }), "Person-wise Task Status"), /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-header-p"
  }, "Task distribution and status for each team member"))), /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-content-tables"
  }, /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-content-table-whole"
  }, personWiseCountLoading ? /*#__PURE__*/React.createElement(Loader, null) : personWiseCountError ? /*#__PURE__*/React.createElement("p", null, "Something went wrong") : personWiseCountData !== null && personWiseCountData !== void 0 && personWiseCountData.personWiseTaskStatus ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Chart, {
    chartType: "ColumnChart",
    width: "100%",
    height: "350px",
    data: chartData,
    options: {
      isStacked: true,
      legend: {
        position: "bottom"
      },
      chartArea: {
        width: "80%",
        height: "60%"
      },
      hAxis: {
        textStyle: {
          fontSize: 12
        }
      },
      vAxis: {
        minValue: 0,
        textStyle: {
          fontSize: 12
        }
      },
      colors: ["#8AB7FF", "#6ED6A1", "#7EEA97", "#FFD866", "#FF8A80"]
    }
  })) : null, /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-content-text-heading-new"
  }, "Detailed Team Member Statistics"), /*#__PURE__*/React.createElement("div", {
    "class": "team-stats-container-1"
  }, /*#__PURE__*/React.createElement(Table, {
    responsive: true,
    bordered: false,
    className: "team-table-1"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Team Member"), /*#__PURE__*/React.createElement("th", null, "Total Tasks"), /*#__PURE__*/React.createElement("th", null, "To Do"), /*#__PURE__*/React.createElement("th", null, "In Progress"), /*#__PURE__*/React.createElement("th", null, "Completed"), /*#__PURE__*/React.createElement("th", null, "On Hold"), /*#__PURE__*/React.createElement("th", null, "Overdue"), /*#__PURE__*/React.createElement("th", null, "Completion Rate"))), personWiseCountLoading ? /*#__PURE__*/React.createElement(Loader, null) : personWiseCountError ? /*#__PURE__*/React.createElement("p", null, "Something went wrong") : personWiseCountData !== null && personWiseCountData !== void 0 && personWiseCountData.personWiseTaskStatus ? /*#__PURE__*/React.createElement("tbody", null, personWiseCountData === null || personWiseCountData === void 0 ? void 0 : (_personWiseCountData$ = personWiseCountData.personWiseTaskStatus) === null || _personWiseCountData$ === void 0 ? void 0 : _personWiseCountData$.map(function (log, index) {
    var userId = log.userId,
      displayName = log.displayName,
      profileUrl = log.profileUrl,
      allTotalTask = log.allTotalTask,
      todoTotalTask = log.todoTotalTask,
      inProgressTotalTask = log.inProgressTotalTask,
      completedTotalTask = log.completedTotalTask,
      holdTotalTask = log.holdTotalTask,
      onDueTotalTask = log.onDueTotalTask,
      completionRate = log.completionRate;
    return /*#__PURE__*/React.createElement("tr", {
      key: index
    }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
      className: "member-info-1"
    }, /*#__PURE__*/React.createElement("div", {
      className: "avatar-1"
    }, displayName === null || displayName === void 0 ? void 0 : displayName.charAt(0)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
      className: "name-1"
    }, displayName), /*#__PURE__*/React.createElement("p", {
      className: "role-1"
    }, "Lead Developer")))), /*#__PURE__*/React.createElement("td", null, allTotalTask ? /*#__PURE__*/React.createElement("span", {
      className: "pill-1 light-1"
    }, allTotalTask) : "-"), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("span", {
      className: "pill-1 light-1"
    }, todoTotalTask)), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("span", {
      className: "pill-1 blue-1"
    }, inProgressTotalTask)), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("span", {
      className: "pill-1 green-1"
    }, completedTotalTask)), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("span", {
      className: "pill-1 yellow-1"
    }, holdTotalTask)), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("span", {
      className: "pill-1 red-1"
    }, onDueTotalTask)), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
      className: "budget-bar"
    }, /*#__PURE__*/React.createElement(ProgressBar, {
      now: completionRate
    }), /*#__PURE__*/React.createElement("span", {
      className: "budget-percent"
    }, completionRate, "%"))));
  })) : null))))), /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-header-div"
  }, /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-header-h3"
  }, /*#__PURE__*/React.createElement(FiTarget, {
    className: "reports-tabs-whole-graphs-1-header-h3-icon"
  }), "Task Priority Distribution"), /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-header-p"
  }, "Breakdown of tasks by priority level"))), /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-content-text"
  }, /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-content-text-heading"
  }, "Priority Summary"), /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-content-text-grid-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-content-text-grid-list-1 reports-tabs-whole-graphs-1-content-text-grid-list-overdue"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-content-text-grid-priority-texts"
  }, /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-content-text-grid-priority-text"
  }, "High Priority"), /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-content-text-grid-priority-text-count"
  }, priorityCountData === null || priorityCountData === void 0 ? void 0 : (_priorityCountData$ge = priorityCountData.getPriorityCount) === null || _priorityCountData$ge === void 0 ? void 0 : _priorityCountData$ge.high, " tasks")), /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-content-text-grid-priority-progress project-summary-cards-whole-div-card-content-hours-graph-progress-div"
  }, /*#__PURE__*/React.createElement(ProgressBar, {
    now: priorityCountData !== null && priorityCountData !== void 0 && (_priorityCountData$ge2 = priorityCountData.getPriorityCount) !== null && _priorityCountData$ge2 !== void 0 && _priorityCountData$ge2.high && priorityCountData !== null && priorityCountData !== void 0 && (_priorityCountData$ge3 = priorityCountData.getPriorityCount) !== null && _priorityCountData$ge3 !== void 0 && _priorityCountData$ge3.total ? Math.round((priorityCountData === null || priorityCountData === void 0 ? void 0 : (_priorityCountData$ge4 = priorityCountData.getPriorityCount) === null || _priorityCountData$ge4 === void 0 ? void 0 : _priorityCountData$ge4.high) / (priorityCountData === null || priorityCountData === void 0 ? void 0 : (_priorityCountData$ge5 = priorityCountData.getPriorityCount) === null || _priorityCountData$ge5 === void 0 ? void 0 : _priorityCountData$ge5.total) * 100) : 0,
    className: "project-summary-cards-whole-div-card-content-hours-graph-progress"
  }), /*#__PURE__*/React.createElement("div", {
    className: "project-summary-cards-whole-div-card-content-hours-graph-progress-text-graphs"
  }, priorityCountData !== null && priorityCountData !== void 0 && (_priorityCountData$ge6 = priorityCountData.getPriorityCount) !== null && _priorityCountData$ge6 !== void 0 && _priorityCountData$ge6.high && priorityCountData !== null && priorityCountData !== void 0 && (_priorityCountData$ge7 = priorityCountData.getPriorityCount) !== null && _priorityCountData$ge7 !== void 0 && _priorityCountData$ge7.total ? Math.round((priorityCountData === null || priorityCountData === void 0 ? void 0 : (_priorityCountData$ge8 = priorityCountData.getPriorityCount) === null || _priorityCountData$ge8 === void 0 ? void 0 : _priorityCountData$ge8.high) / (priorityCountData === null || priorityCountData === void 0 ? void 0 : (_priorityCountData$ge9 = priorityCountData.getPriorityCount) === null || _priorityCountData$ge9 === void 0 ? void 0 : _priorityCountData$ge9.total) * 100) : 0, "% of total tasks", " "))), /*#__PURE__*/React.createElement("div", null)), /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-content-text-grid-list-1 reports-tabs-whole-graphs-1-content-text-grid-list-hold"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-content-text-grid-priority-texts"
  }, /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-content-text-grid-priority-text"
  }, "Medium Priority"), /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-content-text-grid-priority-text-count"
  }, priorityCountData === null || priorityCountData === void 0 ? void 0 : (_priorityCountData$ge10 = priorityCountData.getPriorityCount) === null || _priorityCountData$ge10 === void 0 ? void 0 : _priorityCountData$ge10.medium, " tasks")), /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-content-text-grid-priority-progress project-summary-cards-whole-div-card-content-hours-graph-progress-div"
  }, /*#__PURE__*/React.createElement(ProgressBar, {
    now: priorityCountData !== null && priorityCountData !== void 0 && (_priorityCountData$ge11 = priorityCountData.getPriorityCount) !== null && _priorityCountData$ge11 !== void 0 && _priorityCountData$ge11.medium && priorityCountData !== null && priorityCountData !== void 0 && (_priorityCountData$ge12 = priorityCountData.getPriorityCount) !== null && _priorityCountData$ge12 !== void 0 && _priorityCountData$ge12.total ? Math.round((priorityCountData === null || priorityCountData === void 0 ? void 0 : (_priorityCountData$ge13 = priorityCountData.getPriorityCount) === null || _priorityCountData$ge13 === void 0 ? void 0 : _priorityCountData$ge13.medium) / (priorityCountData === null || priorityCountData === void 0 ? void 0 : (_priorityCountData$ge14 = priorityCountData.getPriorityCount) === null || _priorityCountData$ge14 === void 0 ? void 0 : _priorityCountData$ge14.total) * 100) : 0,
    className: "project-summary-cards-whole-div-card-content-hours-graph-progress"
  }), /*#__PURE__*/React.createElement("div", {
    className: "project-summary-cards-whole-div-card-content-hours-graph-progress-text-graphs"
  }, priorityCountData !== null && priorityCountData !== void 0 && (_priorityCountData$ge15 = priorityCountData.getPriorityCount) !== null && _priorityCountData$ge15 !== void 0 && _priorityCountData$ge15.medium && priorityCountData !== null && priorityCountData !== void 0 && (_priorityCountData$ge16 = priorityCountData.getPriorityCount) !== null && _priorityCountData$ge16 !== void 0 && _priorityCountData$ge16.total ? Math.round((priorityCountData === null || priorityCountData === void 0 ? void 0 : (_priorityCountData$ge17 = priorityCountData.getPriorityCount) === null || _priorityCountData$ge17 === void 0 ? void 0 : _priorityCountData$ge17.medium) / (priorityCountData === null || priorityCountData === void 0 ? void 0 : (_priorityCountData$ge18 = priorityCountData.getPriorityCount) === null || _priorityCountData$ge18 === void 0 ? void 0 : _priorityCountData$ge18.total) * 100) : 0, "% of total tasks", " "))), /*#__PURE__*/React.createElement("div", null)), /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-content-text-grid-list-1 reports-tabs-whole-graphs-1-content-text-grid-list-completed"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-content-text-grid-priority-texts"
  }, /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-content-text-grid-priority-text"
  }, "Low Priority"), /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-content-text-grid-priority-text-count"
  }, priorityCountData === null || priorityCountData === void 0 ? void 0 : (_priorityCountData$ge19 = priorityCountData.getPriorityCount) === null || _priorityCountData$ge19 === void 0 ? void 0 : _priorityCountData$ge19.low, " tasks")), /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-content-text-grid-priority-progress project-summary-cards-whole-div-card-content-hours-graph-progress-div"
  }, /*#__PURE__*/React.createElement(ProgressBar, {
    now: priorityCountData !== null && priorityCountData !== void 0 && (_priorityCountData$ge20 = priorityCountData.getPriorityCount) !== null && _priorityCountData$ge20 !== void 0 && _priorityCountData$ge20.low && priorityCountData !== null && priorityCountData !== void 0 && (_priorityCountData$ge21 = priorityCountData.getPriorityCount) !== null && _priorityCountData$ge21 !== void 0 && _priorityCountData$ge21.total ? Math.round((priorityCountData === null || priorityCountData === void 0 ? void 0 : (_priorityCountData$ge22 = priorityCountData.getPriorityCount) === null || _priorityCountData$ge22 === void 0 ? void 0 : _priorityCountData$ge22.low) / (priorityCountData === null || priorityCountData === void 0 ? void 0 : (_priorityCountData$ge23 = priorityCountData.getPriorityCount) === null || _priorityCountData$ge23 === void 0 ? void 0 : _priorityCountData$ge23.total) * 100) : 0,
    className: "project-summary-cards-whole-div-card-content-hours-graph-progress"
  }), /*#__PURE__*/React.createElement("div", {
    className: "project-summary-cards-whole-div-card-content-hours-graph-progress-text-graphs"
  }, priorityCountData !== null && priorityCountData !== void 0 && (_priorityCountData$ge24 = priorityCountData.getPriorityCount) !== null && _priorityCountData$ge24 !== void 0 && _priorityCountData$ge24.low && priorityCountData !== null && priorityCountData !== void 0 && (_priorityCountData$ge25 = priorityCountData.getPriorityCount) !== null && _priorityCountData$ge25 !== void 0 && _priorityCountData$ge25.total ? Math.round((priorityCountData === null || priorityCountData === void 0 ? void 0 : (_priorityCountData$ge26 = priorityCountData.getPriorityCount) === null || _priorityCountData$ge26 === void 0 ? void 0 : _priorityCountData$ge26.low) / (priorityCountData === null || priorityCountData === void 0 ? void 0 : (_priorityCountData$ge27 = priorityCountData.getPriorityCount) === null || _priorityCountData$ge27 === void 0 ? void 0 : _priorityCountData$ge27.total) * 100) : 0, "% of total tasks", " "))), /*#__PURE__*/React.createElement("div", null)), /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-content-text-grid-list-1 reports-tabs-whole-graphs-1-content-text-grid-list-gray"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-content-text-grid-priority-texts"
  }, /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-content-text-grid-priority-text"
  }, "Not Set Priority"), /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-content-text-grid-priority-text-count"
  }, priorityCountData === null || priorityCountData === void 0 ? void 0 : (_priorityCountData$ge28 = priorityCountData.getPriorityCount) === null || _priorityCountData$ge28 === void 0 ? void 0 : _priorityCountData$ge28.notSet, " tasks")), /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-content-text-grid-priority-progress project-summary-cards-whole-div-card-content-hours-graph-progress-div"
  }, /*#__PURE__*/React.createElement(ProgressBar, {
    now: priorityCountData !== null && priorityCountData !== void 0 && (_priorityCountData$ge29 = priorityCountData.getPriorityCount) !== null && _priorityCountData$ge29 !== void 0 && _priorityCountData$ge29.notSet && priorityCountData !== null && priorityCountData !== void 0 && (_priorityCountData$ge30 = priorityCountData.getPriorityCount) !== null && _priorityCountData$ge30 !== void 0 && _priorityCountData$ge30.total ? Math.round((priorityCountData === null || priorityCountData === void 0 ? void 0 : (_priorityCountData$ge31 = priorityCountData.getPriorityCount) === null || _priorityCountData$ge31 === void 0 ? void 0 : _priorityCountData$ge31.notSet) / (priorityCountData === null || priorityCountData === void 0 ? void 0 : (_priorityCountData$ge32 = priorityCountData.getPriorityCount) === null || _priorityCountData$ge32 === void 0 ? void 0 : _priorityCountData$ge32.total) * 100) : 0,
    className: "project-summary-cards-whole-div-card-content-hours-graph-progress"
  }), /*#__PURE__*/React.createElement("div", {
    className: "project-summary-cards-whole-div-card-content-hours-graph-progress-text-graphs"
  }, priorityCountData !== null && priorityCountData !== void 0 && (_priorityCountData$ge33 = priorityCountData.getPriorityCount) !== null && _priorityCountData$ge33 !== void 0 && _priorityCountData$ge33.notSet && priorityCountData !== null && priorityCountData !== void 0 && (_priorityCountData$ge34 = priorityCountData.getPriorityCount) !== null && _priorityCountData$ge34 !== void 0 && _priorityCountData$ge34.total ? Math.round((priorityCountData === null || priorityCountData === void 0 ? void 0 : (_priorityCountData$ge35 = priorityCountData.getPriorityCount) === null || _priorityCountData$ge35 === void 0 ? void 0 : _priorityCountData$ge35.notSet) / (priorityCountData === null || priorityCountData === void 0 ? void 0 : (_priorityCountData$ge36 = priorityCountData.getPriorityCount) === null || _priorityCountData$ge36 === void 0 ? void 0 : _priorityCountData$ge36.total) * 100) : 0, "% of total tasks", " "))), /*#__PURE__*/React.createElement("div", null)))), /*#__PURE__*/React.createElement("div", {
    className: "reports-tabs-whole-graphs-1-content-graph"
  }, priorityCountLoading ? /*#__PURE__*/React.createElement(Loader, null) : priorityCountError ? /*#__PURE__*/React.createElement("p", null, "Something went wrong") : priorityCountData ? /*#__PURE__*/React.createElement(Chart, {
    chartType: "PieChart",
    width: "".concat(width, "px"),
    height: "".concat(height, "px"),
    data: dataPriority,
    options: {
      colors: colorss,
      backgroundColor: "transparent",
      legend: {
        position: "bottom",
        alignment: "center"
      },
      pieSliceText: "label",
      // cleaner for small slices
      chartArea: {
        left: "5%",
        top: "5%",
        width: "90%",
        height: "80%"
      }
    }
  }) : null))));
};
var KanbanView = function KanbanView(props) {
  var _taskCountData$taskCo28, _taskCountData$taskCo29, _projectTasksList$get, _projectTasksList$get2, _projectTasksList$get3, _projectTasksList$get4, _taskCountData$taskCo30, _taskCountData$taskCo31, _projectTasksList1$ge, _projectTasksList1$ge2, _projectTasksList1$ge3, _projectTasksList1$ge4, _taskCountData$taskCo32, _taskCountData$taskCo33, _projectTasksList2$ge, _projectTasksList2$ge2, _projectTasksList2$ge3, _projectTasksList2$ge4, _taskCountData$taskCo34, _taskCountData$taskCo35, _projectTasksList3$ge, _projectTasksList3$ge2, _projectTasksList3$ge3, _projectTasksList3$ge4, _taskCountData$taskCo36, _taskCountData$taskCo37, _projectTasksList4$ge, _projectTasksList4$ge2, _projectTasksList4$ge3, _projectTasksList4$ge4;
  var taskCountData = props.taskCountData,
    taskCountLoading = props.taskCountLoading,
    taskCountError = props.taskCountError,
    organisationId = props.organisationId,
    teamId = props.teamId,
    role = props.role,
    user = props.user,
    projectId = props.projectId,
    timezone = props.timezone,
    projectSearch = props.projectSearch,
    handleShowTaskDetails = props.handleShowTaskDetails,
    allowEmployeesToManageTheirTasks = props.allowEmployeesToManageTheirTasks,
    userId = props.userId,
    taskStartDate = props.taskStartDate,
    allowEmployeesToMarkTheirTasksAsCompleted = props.allowEmployeesToMarkTheirTasksAsCompleted,
    handleShow = props.handleShow,
    handleTaskDeleteShow = props.handleTaskDeleteShow,
    handleCompletedShow = props.handleCompletedShow,
    handleUndoCompletedShow = props.handleUndoCompletedShow,
    handleHoldShow = props.handleHoldShow;
  var _React$useState141 = React.useState(false),
    _React$useState142 = _slicedToArray(_React$useState141, 2),
    isTaskAllLoaded = _React$useState142[0],
    setTaskIsAllLoaded = _React$useState142[1];
  var _React$useState143 = React.useState(false),
    _React$useState144 = _slicedToArray(_React$useState143, 2),
    isTaskLoadingMore = _React$useState144[0],
    setTaskIsLoadingMore = _React$useState144[1];
  var _React$useState145 = React.useState(false),
    _React$useState146 = _slicedToArray(_React$useState145, 2),
    isTaskAllLoaded1 = _React$useState146[0],
    setTaskIsAllLoaded1 = _React$useState146[1];
  var _React$useState147 = React.useState(false),
    _React$useState148 = _slicedToArray(_React$useState147, 2),
    isTaskLoadingMore1 = _React$useState148[0],
    setTaskIsLoadingMore1 = _React$useState148[1];
  var _React$useState149 = React.useState(false),
    _React$useState150 = _slicedToArray(_React$useState149, 2),
    isTaskAllLoaded2 = _React$useState150[0],
    setTaskIsAllLoaded2 = _React$useState150[1];
  var _React$useState151 = React.useState(false),
    _React$useState152 = _slicedToArray(_React$useState151, 2),
    isTaskLoadingMore2 = _React$useState152[0],
    setTaskIsLoadingMore2 = _React$useState152[1];
  var _React$useState153 = React.useState(false),
    _React$useState154 = _slicedToArray(_React$useState153, 2),
    isTaskAllLoaded3 = _React$useState154[0],
    setTaskIsAllLoaded3 = _React$useState154[1];
  var _React$useState155 = React.useState(false),
    _React$useState156 = _slicedToArray(_React$useState155, 2),
    isTaskLoadingMore3 = _React$useState156[0],
    setTaskIsLoadingMore3 = _React$useState156[1];
  var _React$useState157 = React.useState(false),
    _React$useState158 = _slicedToArray(_React$useState157, 2),
    isTaskAllLoaded4 = _React$useState158[0],
    setTaskIsAllLoaded4 = _React$useState158[1];
  var _React$useState159 = React.useState(false),
    _React$useState160 = _slicedToArray(_React$useState159, 2),
    isTaskLoadingMore4 = _React$useState160[0],
    setTaskIsLoadingMore4 = _React$useState160[1];
  var _useQuery10 = useQuery(GET_FILTER_TASK_TRACKER_DETAILS_QUERY, {
      variables: {
        organisationId: organisationId,
        teamId: teamId,
        userId: role == "Member" ? user === null || user === void 0 ? void 0 : user.userId : null,
        projectId: [projectId],
        taskId: null,
        limit: LIMIT,
        offset: 0,
        filterType: "upcomingTasks",
        timezone: timezone,
        role: role,
        search: projectSearch
      },
      fetchPolicy: "network-only",
      skip: !teamId || !organisationId
    }),
    filterTaskLoading = _useQuery10.loading,
    projectTasksList = _useQuery10.data,
    filterTaskError = _useQuery10.error,
    filterTaskFetchMore = _useQuery10.fetchMore;
  var _useQuery11 = useQuery(GET_FILTER_TASK_TRACKER_DETAILS_QUERY, {
      variables: {
        organisationId: organisationId,
        teamId: teamId,
        userId: role == "Member" ? user === null || user === void 0 ? void 0 : user.userId : null,
        projectId: [projectId],
        taskId: null,
        limit: LIMIT,
        offset: 0,
        filterType: "inProgressTasks",
        timezone: timezone,
        role: role,
        search: projectSearch
      },
      fetchPolicy: "network-only",
      skip: !teamId || !organisationId
    }),
    filterTaskLoading1 = _useQuery11.loading,
    projectTasksList1 = _useQuery11.data,
    filterTaskError1 = _useQuery11.error,
    filterTaskFetchMore1 = _useQuery11.fetchMore;
  var _useQuery12 = useQuery(GET_FILTER_TASK_TRACKER_DETAILS_QUERY, {
      variables: {
        organisationId: organisationId,
        teamId: teamId,
        userId: role == "Member" ? user === null || user === void 0 ? void 0 : user.userId : null,
        projectId: [projectId],
        taskId: null,
        limit: LIMIT,
        offset: 0,
        filterType: "completed",
        timezone: timezone,
        role: role,
        search: projectSearch
      },
      fetchPolicy: "network-only",
      skip: !teamId || !organisationId
    }),
    filterTaskLoading2 = _useQuery12.loading,
    projectTasksList2 = _useQuery12.data,
    filterTaskError2 = _useQuery12.error,
    filterTaskFetchMore2 = _useQuery12.fetchMore;
  var _useQuery13 = useQuery(GET_FILTER_TASK_TRACKER_DETAILS_QUERY, {
      variables: {
        organisationId: organisationId,
        teamId: teamId,
        userId: role == "Member" ? user === null || user === void 0 ? void 0 : user.userId : null,
        projectId: [projectId],
        taskId: null,
        limit: LIMIT,
        offset: 0,
        filterType: "hold",
        timezone: timezone,
        role: role,
        search: projectSearch
      },
      fetchPolicy: "network-only",
      skip: !teamId || !organisationId
    }),
    filterTaskLoading3 = _useQuery13.loading,
    projectTasksList3 = _useQuery13.data,
    filterTaskError3 = _useQuery13.error,
    filterTaskFetchMore3 = _useQuery13.fetchMore;
  var _useQuery14 = useQuery(GET_FILTER_TASK_TRACKER_DETAILS_QUERY, {
      variables: {
        organisationId: organisationId,
        teamId: teamId,
        userId: role == "Member" ? user === null || user === void 0 ? void 0 : user.userId : null,
        projectId: [projectId],
        taskId: null,
        limit: LIMIT,
        offset: 0,
        filterType: "onDue",
        timezone: timezone,
        role: role,
        search: projectSearch
      },
      fetchPolicy: "network-only",
      skip: !teamId || !organisationId
    }),
    filterTaskLoading4 = _useQuery14.loading,
    projectTasksList4 = _useQuery14.data,
    filterTaskError4 = _useQuery14.error,
    filterTaskFetchMore4 = _useQuery14.fetchMore;

  //load more
  function handleTabScroll(e) {
    var element = e.target;
    if (element.scrollHeight - element.scrollTop === element.clientHeight) {
      if (filterTaskLoading) return;
      if (isTaskAllLoaded) return;
      setTaskIsLoadingMore(true);
      filterTaskFetchMore({
        variables: {
          offset: projectTasksList.getFilterTaskTrackerDetails.length
        },
        updateQuery: function updateQuery(prev, _ref7) {
          var fetchMoreResult = _ref7.fetchMoreResult;
          if (!fetchMoreResult) return prev;
          if (fetchMoreResult.getFilterTaskTrackerDetails.length < LIMIT && !isTaskAllLoaded) {
            setTaskIsAllLoaded(true);
          }
          setTaskIsLoadingMore(false);
          var NewFilterData = [];
          fetchMoreResult.getFilterTaskTrackerDetails.forEach(function (newTask) {
            var found = prev.getFilterTaskTrackerDetails.find(function (item) {
              return item.taskId === newTask.taskId;
            });
            if (!found) {
              // If not found, add validation.
              NewFilterData.push(newTask);
            }
          });
          return _objectSpread(_objectSpread({}, prev), {}, {
            getFilterTaskTrackerDetails: [].concat(_toConsumableArray(prev.getFilterTaskTrackerDetails), NewFilterData)
          });
        }
      });
      //setLimits(LIMIT + 20);
    }
  }

  //load more inProgressTasks
  function handleTabScroll1(e) {
    var element = e.target;
    if (element.scrollHeight - element.scrollTop === element.clientHeight) {
      if (filterTaskLoading1) return;
      if (isTaskAllLoaded1) return;
      setTaskIsLoadingMore1(true);
      filterTaskFetchMore1({
        variables: {
          offset: projectTasksList1.getFilterTaskTrackerDetails.length
        },
        updateQuery: function updateQuery(prev, _ref8) {
          var fetchMoreResult = _ref8.fetchMoreResult;
          if (!fetchMoreResult) return prev;
          if (fetchMoreResult.getFilterTaskTrackerDetails.length < LIMIT && !isTaskAllLoaded1) {
            setTaskIsAllLoaded1(true);
          }
          setTaskIsLoadingMore1(false);
          var NewFilterData = [];
          fetchMoreResult.getFilterTaskTrackerDetails.forEach(function (newTask) {
            var found = prev.getFilterTaskTrackerDetails.find(function (item) {
              return item.taskId === newTask.taskId;
            });
            if (!found) {
              // If not found, add validation.
              NewFilterData.push(newTask);
            }
          });
          return _objectSpread(_objectSpread({}, prev), {}, {
            getFilterTaskTrackerDetails: [].concat(_toConsumableArray(prev.getFilterTaskTrackerDetails), NewFilterData)
          });
        }
      });
      //setLimits(LIMIT + 20);
    }
  }

  //load more completed
  function handleTabScroll2(e) {
    var element = e.target;
    if (element.scrollHeight - element.scrollTop === element.clientHeight) {
      if (filterTaskLoading2) return;
      if (isTaskAllLoaded2) return;
      setTaskIsLoadingMore2(true);
      filterTaskFetchMore2({
        variables: {
          offset: projectTasksList2.getFilterTaskTrackerDetails.length
        },
        updateQuery: function updateQuery(prev, _ref9) {
          var fetchMoreResult = _ref9.fetchMoreResult;
          if (!fetchMoreResult) return prev;
          if (fetchMoreResult.getFilterTaskTrackerDetails.length < LIMIT && !isTaskAllLoaded2) {
            setTaskIsAllLoaded2(true);
          }
          setTaskIsLoadingMore2(false);
          var NewFilterData = [];
          fetchMoreResult.getFilterTaskTrackerDetails.forEach(function (newTask) {
            var found = prev.getFilterTaskTrackerDetails.find(function (item) {
              return item.taskId === newTask.taskId;
            });
            if (!found) {
              // If not found, add validation.
              NewFilterData.push(newTask);
            }
          });
          return _objectSpread(_objectSpread({}, prev), {}, {
            getFilterTaskTrackerDetails: [].concat(_toConsumableArray(prev.getFilterTaskTrackerDetails), NewFilterData)
          });
        }
      });
      //setLimits(LIMIT + 20);
    }
  }

  //load more hold
  function handleTabScroll3(e) {
    var element = e.target;
    if (element.scrollHeight - element.scrollTop === element.clientHeight) {
      if (filterTaskLoading3) return;
      if (isTaskAllLoaded3) return;
      setTaskIsLoadingMore3(true);
      filterTaskFetchMore3({
        variables: {
          offset: projectTasksList3.getFilterTaskTrackerDetails.length
        },
        updateQuery: function updateQuery(prev, _ref10) {
          var fetchMoreResult = _ref10.fetchMoreResult;
          if (!fetchMoreResult) return prev;
          if (fetchMoreResult.getFilterTaskTrackerDetails.length < LIMIT && !isTaskAllLoaded3) {
            setTaskIsAllLoaded3(true);
          }
          setTaskIsLoadingMore3(false);
          var NewFilterData = [];
          fetchMoreResult.getFilterTaskTrackerDetails.forEach(function (newTask) {
            var found = prev.getFilterTaskTrackerDetails.find(function (item) {
              return item.taskId === newTask.taskId;
            });
            if (!found) {
              // If not found, add validation.
              NewFilterData.push(newTask);
            }
          });
          return _objectSpread(_objectSpread({}, prev), {}, {
            getFilterTaskTrackerDetails: [].concat(_toConsumableArray(prev.getFilterTaskTrackerDetails), NewFilterData)
          });
        }
      });
      //setLimits(LIMIT + 20);
    }
  }

  //load more due
  function handleTabScroll4(e) {
    var element = e.target;
    if (element.scrollHeight - element.scrollTop === element.clientHeight) {
      if (filterTaskLoading4) return;
      if (isTaskAllLoaded4) return;
      setTaskIsLoadingMore4(true);
      filterTaskFetchMore4({
        variables: {
          offset: projectTasksList4.getFilterTaskTrackerDetails.length
        },
        updateQuery: function updateQuery(prev, _ref11) {
          var fetchMoreResult = _ref11.fetchMoreResult;
          if (!fetchMoreResult) return prev;
          if (fetchMoreResult.getFilterTaskTrackerDetails.length < LIMIT && !isTaskAllLoaded4) {
            setTaskIsAllLoaded4(true);
          }
          setTaskIsLoadingMore4(false);
          var NewFilterData = [];
          fetchMoreResult.getFilterTaskTrackerDetails.forEach(function (newTask) {
            var found = prev.getFilterTaskTrackerDetails.find(function (item) {
              return item.taskId === newTask.taskId;
            });
            if (!found) {
              // If not found, add validation.
              NewFilterData.push(newTask);
            }
          });
          return _objectSpread(_objectSpread({}, prev), {}, {
            getFilterTaskTrackerDetails: [].concat(_toConsumableArray(prev.getFilterTaskTrackerDetails), NewFilterData)
          });
        }
      });
      //setLimits(LIMIT + 20);
    }
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "task-header-menu-whole-div-content-whole-filter-content-div-canban-view-grid"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-header-menu-whole-div-content-whole-filter-content-div-canban-view-grid-part"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-header-menu-whole-div-content-whole-filter-content-div-canban-view-grid-part-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-header-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-header-text"
  }, "To Do"), /*#__PURE__*/React.createElement("div", {
    className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-header-count"
  }, (taskCountData === null || taskCountData === void 0 ? void 0 : (_taskCountData$taskCo28 = taskCountData.taskCount) === null || _taskCountData$taskCo28 === void 0 ? void 0 : _taskCountData$taskCo28.upcomingTaskCount) != 0 && !taskCountLoading && !taskCountError ? "".concat(taskCountData === null || taskCountData === void 0 ? void 0 : (_taskCountData$taskCo29 = taskCountData.taskCount) === null || _taskCountData$taskCo29 === void 0 ? void 0 : _taskCountData$taskCo29.upcomingTaskCount) : "0")))), /*#__PURE__*/React.createElement("div", {
    className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-scroll"
  }, filterTaskLoading ? /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(Loader, null)) : filterTaskError ? /*#__PURE__*/React.createElement("p", null, "Something went wrong, please refresh the page.") : (projectTasksList === null || projectTasksList === void 0 ? void 0 : (_projectTasksList$get = projectTasksList.getFilterTaskTrackerDetails) === null || _projectTasksList$get === void 0 ? void 0 : _projectTasksList$get.length) == 0 ? /*#__PURE__*/React.createElement("div", {
    className: "project-details-task-card-body-filter-no-data-div"
  }, /*#__PURE__*/React.createElement("p", {
    className: "project-details-task-card-body-filter-section-buttions-add-button-nodata"
  }, "No task available")) : /*#__PURE__*/React.createElement(React.Fragment, null, projectTasksList === null || projectTasksList === void 0 ? void 0 : (_projectTasksList$get2 = projectTasksList.getFilterTaskTrackerDetails) === null || _projectTasksList$get2 === void 0 ? void 0 : _projectTasksList$get2.map(function (list, index) {
    var taskId = list.taskId,
      taskName = list.taskName,
      taskStatus = list.taskStatus,
      assignedTo = list.assignedTo,
      totalWorkedTime = list.totalWorkedTime,
      totalMyWorkedTime = list.totalMyWorkedTime,
      assignedToAll = list.assignedToAll,
      taskUser = list.taskUser,
      estimatedTime = list.estimatedTime,
      dueDate = list.dueDate,
      taskLabelStatus = list.taskLabelStatus,
      priority = list.priority,
      startDate = list.startDate,
      taskProgress = list.taskProgress,
      taskProgressUser = list.taskProgressUser,
      taskType = list.taskType,
      taskVisibility = list.taskVisibility,
      description = list.description,
      taskDueStatus = list.taskDueStatus,
      taskCreatedBy = list.taskCreatedBy,
      totalTime = list.totalTime;
    var _assignedTo$split = assignedTo.split(" "),
      _assignedTo$split2 = _slicedToArray(_assignedTo$split, 2),
      label = _assignedTo$split2[0],
      count = _assignedTo$split2[1];
    return /*#__PURE__*/React.createElement("div", {
      className: classNames("task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-whole-list", {
        "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-whole-list-medium": priority == "medium"
      }, {
        "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-whole-list-high": priority == "high"
      }, {
        "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-whole-list-low": priority == "low"
      })
    }, /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list"
    }, /*#__PURE__*/React.createElement("div", {
      onClick: function onClick(e) {
        return handleShowTaskDetails({
          taskId: taskId,
          taskName: taskName
        });
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-header"
    }, /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "project-tooltip-start"
      }, taskName)
    }, /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-header-name"
    }, taskName))), /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-header-content"
      // onClick={(e) => handleShowTaskDetails({ taskId, taskName })}
    }, /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-work-hour-div"
    }, /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-work-hour"
    }, /*#__PURE__*/React.createElement(MdAccessTime, {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-work-hour-icon"
    }), /*#__PURE__*/React.createElement("span", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-work-hour-whole-span"
    }, totalTime)), /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-work-hour"
    }, /*#__PURE__*/React.createElement(RiTimerLine, {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-work-hour-icon-timer"
    }), /*#__PURE__*/React.createElement("span", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-work-hour-span"
    }, "My:", " ", /*#__PURE__*/React.createElement("span", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-work-hour-span-my"
    }, totalMyWorkedTime)))), /*#__PURE__*/React.createElement("div", null, assignedTo ? assignedTo == "Everyone" ? /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-work-hour-div-person"
    }, /*#__PURE__*/React.createElement(FiUsers, {
      className: "project-details-task-card-body-table-assigned-to-icons"
    }), "Public") : assignedTo.includes("Members") ? /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom-name",
        className: "project-tooltip-start"
      }, assignedToAll ? assignedToAll : "-")
    }, /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-work-hour-div-person-member-text"
    }, /*#__PURE__*/React.createElement(FiUsers, {
      className: "project-details-task-card-body-table-assigned-to-icons"
    }), assignedTo ? label : "-")) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom-name",
        className: "project-tooltip-start"
      }, assignedToAll ? assignedToAll : "-")
    }, /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-work-hour-div-person-member-text-1"
    }, assignedTo ? assignedTo.trim().charAt(0) : "-"))) : /*#__PURE__*/React.createElement("div", {
      className: "desktop-home-project-card-table-display-name-not-assigned-kanban-project"
    }, /*#__PURE__*/React.createElement(FiUsers, {
      className: "project-details-task-card-body-table-assigned-to-icons"
    }), "No one")))), /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-footer"
    }, priority == "" || priority == null ? /*#__PURE__*/React.createElement(React.Fragment, null, role != "Member" || role == "Member" && allowEmployeesToManageTheirTasks && taskCreatedBy == userId ? /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-footer-badge",
      onClick: function onClick() {
        handleShow(taskId, taskUser, estimatedTime, dueDate, taskName, taskStatus, taskLabelStatus, priority, taskStartDate, taskProgress, taskProgressUser, taskVisibility, description, allowEmployeesToManageTheirTasks, taskCreatedBy, userId, allowEmployeesToMarkTheirTasksAsCompleted);
      }
    }, "Set Priority") : /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "bottom",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "project-tooltip-start"
      }, "Please contact the admin to edit the task.")
    }, /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-footer-badge"
    }, "Set Priority"))) : /*#__PURE__*/React.createElement("div", {
      className: classNames({
        "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-footer-badge-low": priority == "low"
      }, {
        "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-footer-badge-medium": priority == "medium"
      }, {
        "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-footer-badge-high": priority == "high"
      }),
      onClick: function onClick(e) {
        return handleShowTaskDetails({
          taskId: taskId,
          taskName: taskName
        });
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-footer-badge-span"
    }, priority == "low" ? "🟢" : priority == "medium" ? "🟡" : priority == "high" ? "🔴" : null), priority), /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-header-edit-divs"
    }, role != "Member" || role == "Member" && allowEmployeesToManageTheirTasks && taskCreatedBy == userId ? /*#__PURE__*/React.createElement(FiEdit, {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-header-edit task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-header-edit-new",
      onClick: function onClick() {
        handleShow(taskId, taskUser, estimatedTime, dueDate, taskName, taskStatus, taskLabelStatus, priority, taskStartDate, taskProgress, taskProgressUser, taskVisibility, description, allowEmployeesToManageTheirTasks, taskCreatedBy, userId, allowEmployeesToMarkTheirTasksAsCompleted);
      }
    }) : /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "bottom",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "project-tooltip-start"
      }, "Please contact the admin to edit the task.")
    }, /*#__PURE__*/React.createElement(FiEdit, {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-header-edit task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-header-edit-new"
    })), /*#__PURE__*/React.createElement(EditMenu, {
      taskId: taskId,
      taskProgress: taskProgress,
      taskProgressUser: taskProgressUser,
      taskType: taskType,
      handleTaskDeleteShow: handleTaskDeleteShow,
      handleShowTaskDetails: handleShowTaskDetails,
      taskName: taskName,
      role: role,
      allowEmployeesToManageTheirTasks: allowEmployeesToManageTheirTasks,
      taskCreatedBy: taskCreatedBy,
      userId: userId,
      allowEmployeesToMarkTheirTasksAsCompleted: allowEmployeesToMarkTheirTasksAsCompleted,
      taskUser: taskUser,
      assignedTo: assignedTo,
      taskStatus: taskStatus,
      handleCompletedShow: handleCompletedShow,
      projectId: projectId,
      handleUndoCompletedShow: handleUndoCompletedShow,
      handleHoldShow: handleHoldShow
    })))));
  }), projectTasksList !== null && projectTasksList !== void 0 && (_projectTasksList$get3 = projectTasksList.getFilterTaskTrackerDetails) !== null && _projectTasksList$get3 !== void 0 && _projectTasksList$get3.length ? /*#__PURE__*/React.createElement("div", {
    className: "review-apps-load-more-button"
  }, (projectTasksList === null || projectTasksList === void 0 ? void 0 : (_projectTasksList$get4 = projectTasksList.getFilterTaskTrackerDetails) === null || _projectTasksList$get4 === void 0 ? void 0 : _projectTasksList$get4.length) < LIMIT || isTaskAllLoaded ? /*#__PURE__*/React.createElement("p", {
    className: "project-details-all-task-label"
  }, "You have seen all the task") : /*#__PURE__*/React.createElement(React.Fragment, null, isTaskLoadingMore ? /*#__PURE__*/React.createElement("div", {
    className: "review-apps-load-more-button"
  }, /*#__PURE__*/React.createElement(Loader, null)) : /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    onClick: function onClick(e) {
      handleTabScroll(e);
    }
  }, "Load more"))) : null)))), /*#__PURE__*/React.createElement("div", {
    className: "task-header-menu-whole-div-content-whole-filter-content-div-canban-view-grid-part"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-header-menu-whole-div-content-whole-filter-content-div-canban-view-grid-part-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-header-progress"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-header-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-header-text"
  }, "In Progress"), /*#__PURE__*/React.createElement("div", {
    className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-header-count"
  }, (taskCountData === null || taskCountData === void 0 ? void 0 : (_taskCountData$taskCo30 = taskCountData.taskCount) === null || _taskCountData$taskCo30 === void 0 ? void 0 : _taskCountData$taskCo30.inProgressCount) != 0 && !taskCountLoading && !taskCountError ? "".concat(taskCountData === null || taskCountData === void 0 ? void 0 : (_taskCountData$taskCo31 = taskCountData.taskCount) === null || _taskCountData$taskCo31 === void 0 ? void 0 : _taskCountData$taskCo31.inProgressCount) : "0")))), /*#__PURE__*/React.createElement("div", {
    className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-scroll"
  }, filterTaskLoading1 ? /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(Loader, null)) : filterTaskError1 ? /*#__PURE__*/React.createElement("p", null, "Something went wrong, please refresh the page.") : (projectTasksList1 === null || projectTasksList1 === void 0 ? void 0 : (_projectTasksList1$ge = projectTasksList1.getFilterTaskTrackerDetails) === null || _projectTasksList1$ge === void 0 ? void 0 : _projectTasksList1$ge.length) == 0 ? /*#__PURE__*/React.createElement("div", {
    className: "project-details-task-card-body-filter-no-data-div"
  }, /*#__PURE__*/React.createElement("p", {
    className: "project-details-task-card-body-filter-section-buttions-add-button-nodata"
  }, "No task available")) : /*#__PURE__*/React.createElement(React.Fragment, null, projectTasksList1 === null || projectTasksList1 === void 0 ? void 0 : (_projectTasksList1$ge2 = projectTasksList1.getFilterTaskTrackerDetails) === null || _projectTasksList1$ge2 === void 0 ? void 0 : _projectTasksList1$ge2.map(function (list, index) {
    var taskId = list.taskId,
      taskName = list.taskName,
      taskStatus = list.taskStatus,
      assignedTo = list.assignedTo,
      totalWorkedTime = list.totalWorkedTime,
      totalMyWorkedTime = list.totalMyWorkedTime,
      assignedToAll = list.assignedToAll,
      taskUser = list.taskUser,
      estimatedTime = list.estimatedTime,
      dueDate = list.dueDate,
      taskLabelStatus = list.taskLabelStatus,
      priority = list.priority,
      startDate = list.startDate,
      taskProgress = list.taskProgress,
      taskProgressUser = list.taskProgressUser,
      taskType = list.taskType,
      taskVisibility = list.taskVisibility,
      description = list.description,
      taskDueStatus = list.taskDueStatus,
      taskCreatedBy = list.taskCreatedBy,
      totalTime = list.totalTime;
    var _assignedTo$split3 = assignedTo.split(" "),
      _assignedTo$split4 = _slicedToArray(_assignedTo$split3, 2),
      label = _assignedTo$split4[0],
      count = _assignedTo$split4[1];
    return /*#__PURE__*/React.createElement("div", {
      className: classNames("task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-whole-list", {
        "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-whole-list-medium": priority == "medium"
      }, {
        "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-whole-list-high": priority == "high"
      }, {
        "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-whole-list-low": priority == "low"
      })
    }, /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list"
    }, /*#__PURE__*/React.createElement("div", {
      onClick: function onClick(e) {
        return handleShowTaskDetails({
          taskId: taskId,
          taskName: taskName
        });
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-header"
    }, /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "project-tooltip-start"
      }, taskName)
    }, /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-header-name"
    }, taskName))), /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-header-content"
    }, /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-work-hour-div"
    }, /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-work-hour"
    }, /*#__PURE__*/React.createElement(MdAccessTime, {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-work-hour-icon"
    }), /*#__PURE__*/React.createElement("span", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-work-hour-whole-span"
    }, totalTime)), /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-work-hour"
    }, /*#__PURE__*/React.createElement(RiTimerLine, {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-work-hour-icon-timer"
    }), /*#__PURE__*/React.createElement("span", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-work-hour-span"
    }, "My:", " ", /*#__PURE__*/React.createElement("span", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-work-hour-span-my"
    }, totalMyWorkedTime)))), /*#__PURE__*/React.createElement("div", null, assignedTo ? assignedTo == "Everyone" ? /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-work-hour-div-person"
    }, /*#__PURE__*/React.createElement(FiUsers, {
      className: "project-details-task-card-body-table-assigned-to-icons"
    }), "Public") : assignedTo.includes("Members") ? /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom-name",
        className: "project-tooltip-start"
      }, assignedToAll ? assignedToAll : "-")
    }, /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-work-hour-div-person-member-text"
    }, /*#__PURE__*/React.createElement(FiUsers, {
      className: "project-details-task-card-body-table-assigned-to-icons"
    }), assignedTo ? label : "-")) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom-name",
        className: "project-tooltip-start"
      }, assignedToAll ? assignedToAll : "-")
    }, /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-work-hour-div-person-member-text-1"
    }, assignedTo ? assignedTo.trim().charAt(0) : "-"))) : /*#__PURE__*/React.createElement("div", {
      className: "desktop-home-project-card-table-display-name-not-assigned-kanban-project"
    }, /*#__PURE__*/React.createElement(FiUsers, {
      className: "project-details-task-card-body-table-assigned-to-icons"
    }), "No one")))), /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-footer"
    }, priority == "" || priority == null ? /*#__PURE__*/React.createElement(React.Fragment, null, role != "Member" || role == "Member" && allowEmployeesToManageTheirTasks && taskCreatedBy == userId ? /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-footer-badge",
      onClick: function onClick() {
        handleShow(taskId, taskUser, estimatedTime, dueDate, taskName, taskStatus, "In progress", priority, taskStartDate, taskProgress, taskProgressUser, taskVisibility, description, allowEmployeesToManageTheirTasks, taskCreatedBy, userId, allowEmployeesToMarkTheirTasksAsCompleted);
      }
    }, "Set Priority") : /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "bottom",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "project-tooltip-start"
      }, "Please contact the admin to edit the task.")
    }, /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-footer-badge"
    }, "Set Priority"))) : /*#__PURE__*/React.createElement("div", {
      className: classNames({
        "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-footer-badge-low": priority == "low"
      }, {
        "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-footer-badge-medium": priority == "medium"
      }, {
        "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-footer-badge-high": priority == "high"
      }),
      onClick: function onClick(e) {
        return handleShowTaskDetails({
          taskId: taskId,
          taskName: taskName
        });
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-footer-badge-span"
    }, priority == "low" ? "🟢" : priority == "medium" ? "🟡" : priority == "high" ? "🔴" : null), priority), /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-header-edit-divs"
    }, role != "Member" || role == "Member" && allowEmployeesToManageTheirTasks && taskCreatedBy == userId ? /*#__PURE__*/React.createElement(FiEdit, {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-header-edit task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-header-edit-new",
      onClick: function onClick() {
        handleShow(taskId, taskUser, estimatedTime, dueDate, taskName, taskStatus, "In progress", priority, taskStartDate, taskProgress, taskProgressUser, taskVisibility, description, allowEmployeesToManageTheirTasks, taskCreatedBy, userId, allowEmployeesToMarkTheirTasksAsCompleted);
      }
    }) : /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "bottom",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "project-tooltip-start"
      }, "Please contact the admin to edit the task.")
    }, /*#__PURE__*/React.createElement(FiEdit, {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-header-edit task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-header-edit-new"
    })), /*#__PURE__*/React.createElement(EditMenu, {
      taskId: taskId,
      taskProgress: taskProgress,
      taskProgressUser: taskProgressUser,
      taskType: taskType,
      handleTaskDeleteShow: handleTaskDeleteShow,
      handleShowTaskDetails: handleShowTaskDetails,
      taskName: taskName,
      role: role,
      allowEmployeesToManageTheirTasks: allowEmployeesToManageTheirTasks,
      taskCreatedBy: taskCreatedBy,
      userId: userId,
      allowEmployeesToMarkTheirTasksAsCompleted: allowEmployeesToMarkTheirTasksAsCompleted,
      taskUser: taskUser,
      assignedTo: assignedTo,
      taskStatus: taskStatus,
      handleCompletedShow: handleCompletedShow,
      projectId: projectId,
      handleUndoCompletedShow: handleUndoCompletedShow,
      handleHoldShow: handleHoldShow
    })))));
  }), projectTasksList1 !== null && projectTasksList1 !== void 0 && (_projectTasksList1$ge3 = projectTasksList1.getFilterTaskTrackerDetails) !== null && _projectTasksList1$ge3 !== void 0 && _projectTasksList1$ge3.length ? /*#__PURE__*/React.createElement("div", {
    className: "review-apps-load-more-button"
  }, (projectTasksList1 === null || projectTasksList1 === void 0 ? void 0 : (_projectTasksList1$ge4 = projectTasksList1.getFilterTaskTrackerDetails) === null || _projectTasksList1$ge4 === void 0 ? void 0 : _projectTasksList1$ge4.length) < LIMIT || isTaskAllLoaded1 ? /*#__PURE__*/React.createElement("p", {
    className: "project-details-all-task-label"
  }, "You have seen all the task") : /*#__PURE__*/React.createElement(React.Fragment, null, isTaskLoadingMore1 ? /*#__PURE__*/React.createElement("div", {
    className: "review-apps-load-more-button"
  }, /*#__PURE__*/React.createElement(Loader, null)) : /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    onClick: function onClick(e) {
      handleTabScroll1(e);
    }
  }, "Load more"))) : null)))), /*#__PURE__*/React.createElement("div", {
    className: "task-header-menu-whole-div-content-whole-filter-content-div-canban-view-grid-part"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-header-menu-whole-div-content-whole-filter-content-div-canban-view-grid-part-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-header-completed"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-header-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-header-text"
  }, "Completed"), /*#__PURE__*/React.createElement("div", {
    className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-header-count"
  }, (taskCountData === null || taskCountData === void 0 ? void 0 : (_taskCountData$taskCo32 = taskCountData.taskCount) === null || _taskCountData$taskCo32 === void 0 ? void 0 : _taskCountData$taskCo32.completedTaskCount) != 0 && !taskCountLoading && !taskCountError ? "".concat(taskCountData === null || taskCountData === void 0 ? void 0 : (_taskCountData$taskCo33 = taskCountData.taskCount) === null || _taskCountData$taskCo33 === void 0 ? void 0 : _taskCountData$taskCo33.completedTaskCount) : "0")))), /*#__PURE__*/React.createElement("div", {
    className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-scroll"
  }, filterTaskLoading2 ? /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(Loader, null)) : filterTaskError2 ? /*#__PURE__*/React.createElement("p", null, "Something went wrong, please refresh the page.") : (projectTasksList2 === null || projectTasksList2 === void 0 ? void 0 : (_projectTasksList2$ge = projectTasksList2.getFilterTaskTrackerDetails) === null || _projectTasksList2$ge === void 0 ? void 0 : _projectTasksList2$ge.length) == 0 ? /*#__PURE__*/React.createElement("div", {
    className: "project-details-task-card-body-filter-no-data-div"
  }, /*#__PURE__*/React.createElement("p", {
    className: "project-details-task-card-body-filter-section-buttions-add-button-nodata"
  }, "No task available")) : /*#__PURE__*/React.createElement(React.Fragment, null, projectTasksList2 === null || projectTasksList2 === void 0 ? void 0 : (_projectTasksList2$ge2 = projectTasksList2.getFilterTaskTrackerDetails) === null || _projectTasksList2$ge2 === void 0 ? void 0 : _projectTasksList2$ge2.map(function (list, index) {
    var taskId = list.taskId,
      taskName = list.taskName,
      taskStatus = list.taskStatus,
      assignedTo = list.assignedTo,
      totalWorkedTime = list.totalWorkedTime,
      totalMyWorkedTime = list.totalMyWorkedTime,
      assignedToAll = list.assignedToAll,
      taskUser = list.taskUser,
      estimatedTime = list.estimatedTime,
      dueDate = list.dueDate,
      taskLabelStatus = list.taskLabelStatus,
      priority = list.priority,
      startDate = list.startDate,
      taskProgress = list.taskProgress,
      taskProgressUser = list.taskProgressUser,
      taskType = list.taskType,
      taskVisibility = list.taskVisibility,
      description = list.description,
      taskDueStatus = list.taskDueStatus,
      taskCreatedBy = list.taskCreatedBy,
      totalTime = list.totalTime;
    var _assignedTo$split5 = assignedTo.split(" "),
      _assignedTo$split6 = _slicedToArray(_assignedTo$split5, 2),
      label = _assignedTo$split6[0],
      count = _assignedTo$split6[1];
    return /*#__PURE__*/React.createElement("div", {
      className: classNames("task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-whole-list", {
        "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-whole-list-medium": priority == "medium"
      }, {
        "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-whole-list-high": priority == "high"
      }, {
        "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-whole-list-low": priority == "low"
      })
    }, /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list"
    }, /*#__PURE__*/React.createElement("div", {
      onClick: function onClick(e) {
        return handleShowTaskDetails({
          taskId: taskId,
          taskName: taskName
        });
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-header"
    }, /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "project-tooltip-start"
      }, taskName)
    }, /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-header-name"
    }, taskName))), /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-header-content"
    }, /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-work-hour-div"
    }, /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-work-hour"
    }, /*#__PURE__*/React.createElement(MdAccessTime, {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-work-hour-icon"
    }), /*#__PURE__*/React.createElement("span", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-work-hour-whole-span"
    }, totalTime)), /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-work-hour"
    }, /*#__PURE__*/React.createElement(RiTimerLine, {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-work-hour-icon-timer"
    }), /*#__PURE__*/React.createElement("span", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-work-hour-span"
    }, "My:", " ", /*#__PURE__*/React.createElement("span", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-work-hour-span-my"
    }, totalMyWorkedTime)))), /*#__PURE__*/React.createElement("div", null, assignedTo ? assignedTo == "Everyone" ? /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-work-hour-div-person"
    }, /*#__PURE__*/React.createElement(FiUsers, {
      className: "project-details-task-card-body-table-assigned-to-icons"
    }), "Public") : assignedTo.includes("Members") ? /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom-name",
        className: "project-tooltip-start"
      }, assignedToAll ? label : "-")
    }, /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-work-hour-div-person-member-text"
    }, /*#__PURE__*/React.createElement(FiUsers, {
      className: "project-details-task-card-body-table-assigned-to-icons"
    }), assignedTo ? assignedTo : "-")) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom-name",
        className: "project-tooltip-start"
      }, assignedToAll ? assignedToAll : "-")
    }, /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-work-hour-div-person-member-text-1"
    }, assignedTo ? assignedTo.trim().charAt(0) : "-"))) : /*#__PURE__*/React.createElement("div", {
      className: "desktop-home-project-card-table-display-name-not-assigned-kanban-project"
    }, /*#__PURE__*/React.createElement(FiUsers, {
      className: "project-details-task-card-body-table-assigned-to-icons"
    }), "No one")))), /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-footer"
    }, priority == "" || priority == null ? /*#__PURE__*/React.createElement(React.Fragment, null, role != "Member" || role == "Member" && allowEmployeesToManageTheirTasks && taskCreatedBy == userId ? /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-footer-badge",
      onClick: function onClick() {
        handleShow(taskId, taskUser, estimatedTime, dueDate, taskName, taskStatus, "Completed", priority, taskStartDate, taskProgress, taskProgressUser, taskVisibility, description, allowEmployeesToManageTheirTasks, taskCreatedBy, userId, allowEmployeesToMarkTheirTasksAsCompleted);
      }
    }, "Set Priority") : /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "bottom",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "project-tooltip-start"
      }, "Please contact the admin to edit the task.")
    }, /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-footer-badge"
    }, "Set Priority"))) : /*#__PURE__*/React.createElement("div", {
      className: classNames({
        "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-footer-badge-low": priority == "low"
      }, {
        "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-footer-badge-medium": priority == "medium"
      }, {
        "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-footer-badge-high": priority == "high"
      }),
      onClick: function onClick(e) {
        return handleShowTaskDetails({
          taskId: taskId,
          taskName: taskName
        });
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-footer-badge-span"
    }, priority == "low" ? "🟢" : priority == "medium" ? "🟡" : priority == "high" ? "🔴" : null), priority), /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-header-edit-divs"
    }, role != "Member" || role == "Member" && allowEmployeesToManageTheirTasks && taskCreatedBy == userId ? /*#__PURE__*/React.createElement(FiEdit, {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-header-edit task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-header-edit-new",
      onClick: function onClick() {
        handleShow(taskId, taskUser, estimatedTime, dueDate, taskName, taskStatus, "Completed", priority, taskStartDate, taskProgress, taskProgressUser, taskVisibility, description, allowEmployeesToManageTheirTasks, taskCreatedBy, userId, allowEmployeesToMarkTheirTasksAsCompleted);
      }
    }) : /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "bottom",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "project-tooltip-start"
      }, "Please contact the admin to edit the task.")
    }, /*#__PURE__*/React.createElement(FiEdit, {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-header-edit task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-header-edit-new"
    })), /*#__PURE__*/React.createElement(EditMenu, {
      taskId: taskId,
      taskProgress: taskProgress,
      taskProgressUser: taskProgressUser,
      taskType: taskType,
      handleTaskDeleteShow: handleTaskDeleteShow,
      handleShowTaskDetails: handleShowTaskDetails,
      taskName: taskName,
      role: role,
      allowEmployeesToManageTheirTasks: allowEmployeesToManageTheirTasks,
      taskCreatedBy: taskCreatedBy,
      userId: userId,
      allowEmployeesToMarkTheirTasksAsCompleted: allowEmployeesToMarkTheirTasksAsCompleted,
      taskUser: taskUser,
      assignedTo: assignedTo,
      taskStatus: taskStatus,
      handleCompletedShow: handleCompletedShow,
      projectId: projectId,
      handleUndoCompletedShow: handleUndoCompletedShow,
      handleHoldShow: handleHoldShow
    })))));
  }), projectTasksList2 !== null && projectTasksList2 !== void 0 && (_projectTasksList2$ge3 = projectTasksList2.getFilterTaskTrackerDetails) !== null && _projectTasksList2$ge3 !== void 0 && _projectTasksList2$ge3.length ? /*#__PURE__*/React.createElement("div", {
    className: "review-apps-load-more-button"
  }, (projectTasksList2 === null || projectTasksList2 === void 0 ? void 0 : (_projectTasksList2$ge4 = projectTasksList2.getFilterTaskTrackerDetails) === null || _projectTasksList2$ge4 === void 0 ? void 0 : _projectTasksList2$ge4.length) < LIMIT || isTaskAllLoaded2 ? /*#__PURE__*/React.createElement("p", {
    className: "project-details-all-task-label"
  }, "You have seen all the task") : /*#__PURE__*/React.createElement(React.Fragment, null, isTaskLoadingMore2 ? /*#__PURE__*/React.createElement("div", {
    className: "review-apps-load-more-button"
  }, /*#__PURE__*/React.createElement(Loader, null)) : /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    onClick: function onClick(e) {
      handleTabScroll2(e);
    }
  }, "Load more"))) : null)))), /*#__PURE__*/React.createElement("div", {
    className: "task-header-menu-whole-div-content-whole-filter-content-div-canban-view-grid-part"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-header-menu-whole-div-content-whole-filter-content-div-canban-view-grid-part-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-header-hold"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-header-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-header-text"
  }, "On Hold"), /*#__PURE__*/React.createElement("div", {
    className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-header-count"
  }, (taskCountData === null || taskCountData === void 0 ? void 0 : (_taskCountData$taskCo34 = taskCountData.taskCount) === null || _taskCountData$taskCo34 === void 0 ? void 0 : _taskCountData$taskCo34.holdTaskCount) != 0 && !taskCountLoading && !taskCountError ? "".concat(taskCountData === null || taskCountData === void 0 ? void 0 : (_taskCountData$taskCo35 = taskCountData.taskCount) === null || _taskCountData$taskCo35 === void 0 ? void 0 : _taskCountData$taskCo35.holdTaskCount) : "0")))), /*#__PURE__*/React.createElement("div", {
    className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-scroll"
  }, filterTaskLoading3 ? /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(Loader, null)) : filterTaskError3 ? /*#__PURE__*/React.createElement("p", null, "Something went wrong, please refresh the page.") : (projectTasksList3 === null || projectTasksList3 === void 0 ? void 0 : (_projectTasksList3$ge = projectTasksList3.getFilterTaskTrackerDetails) === null || _projectTasksList3$ge === void 0 ? void 0 : _projectTasksList3$ge.length) == 0 ? /*#__PURE__*/React.createElement("div", {
    className: "project-details-task-card-body-filter-no-data-div"
  }, /*#__PURE__*/React.createElement("p", {
    className: "project-details-task-card-body-filter-section-buttions-add-button-nodata"
  }, "No task available")) : /*#__PURE__*/React.createElement(React.Fragment, null, projectTasksList3 === null || projectTasksList3 === void 0 ? void 0 : (_projectTasksList3$ge2 = projectTasksList3.getFilterTaskTrackerDetails) === null || _projectTasksList3$ge2 === void 0 ? void 0 : _projectTasksList3$ge2.map(function (list, index) {
    var taskId = list.taskId,
      taskName = list.taskName,
      taskStatus = list.taskStatus,
      assignedTo = list.assignedTo,
      totalWorkedTime = list.totalWorkedTime,
      totalMyWorkedTime = list.totalMyWorkedTime,
      assignedToAll = list.assignedToAll,
      taskUser = list.taskUser,
      estimatedTime = list.estimatedTime,
      dueDate = list.dueDate,
      taskLabelStatus = list.taskLabelStatus,
      priority = list.priority,
      startDate = list.startDate,
      taskProgress = list.taskProgress,
      taskProgressUser = list.taskProgressUser,
      taskType = list.taskType,
      taskVisibility = list.taskVisibility,
      description = list.description,
      taskDueStatus = list.taskDueStatus,
      taskCreatedBy = list.taskCreatedBy,
      totalTime = list.totalTime;
    var _assignedTo$split7 = assignedTo.split(" "),
      _assignedTo$split8 = _slicedToArray(_assignedTo$split7, 2),
      label = _assignedTo$split8[0],
      count = _assignedTo$split8[1];
    return /*#__PURE__*/React.createElement("div", {
      className: classNames("task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-whole-list", {
        "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-whole-list-medium": priority == "medium"
      }, {
        "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-whole-list-high": priority == "high"
      }, {
        "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-whole-list-low": priority == "low"
      })
    }, /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list"
    }, /*#__PURE__*/React.createElement("div", {
      onClick: function onClick(e) {
        return handleShowTaskDetails({
          taskId: taskId,
          taskName: taskName
        });
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-header",
      onClick: function onClick(e) {
        return handleShowTaskDetails({
          taskId: taskId,
          taskName: taskName
        });
      }
    }, /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "project-tooltip-start"
      }, taskName)
    }, /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-header-name"
    }, taskName))), /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-header-content",
      onClick: function onClick(e) {
        return handleShowTaskDetails({
          taskId: taskId,
          taskName: taskName
        });
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-work-hour-div"
    }, /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-work-hour"
    }, /*#__PURE__*/React.createElement(MdAccessTime, {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-work-hour-icon"
    }), /*#__PURE__*/React.createElement("span", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-work-hour-whole-span"
    }, totalTime)), /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-work-hour"
    }, /*#__PURE__*/React.createElement(RiTimerLine, {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-work-hour-icon-timer"
    }), /*#__PURE__*/React.createElement("span", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-work-hour-span"
    }, "My:", " ", /*#__PURE__*/React.createElement("span", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-work-hour-span-my"
    }, totalMyWorkedTime)))), /*#__PURE__*/React.createElement("div", null, assignedTo ? assignedTo == "Everyone" ? /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-work-hour-div-person"
    }, /*#__PURE__*/React.createElement(FiUsers, {
      className: "project-details-task-card-body-table-assigned-to-icons"
    }), "Public") : assignedTo.includes("Members") ? /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom-name",
        className: "project-tooltip-start"
      }, assignedToAll ? label : "-")
    }, /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-work-hour-div-person-member-text"
    }, /*#__PURE__*/React.createElement(FiUsers, {
      className: "project-details-task-card-body-table-assigned-to-icons"
    }), assignedTo ? assignedTo : "-")) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom-name",
        className: "project-tooltip-start"
      }, assignedToAll ? assignedToAll : "-")
    }, /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-work-hour-div-person-member-text-1"
    }, assignedTo ? assignedTo.trim().charAt(0) : "-"))) : /*#__PURE__*/React.createElement("div", {
      className: "desktop-home-project-card-table-display-name-not-assigned-kanban-project"
    }, /*#__PURE__*/React.createElement(FiUsers, {
      className: "project-details-task-card-body-table-assigned-to-icons"
    }), "No one")))), /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-footer"
    }, priority == "" || priority == null ? /*#__PURE__*/React.createElement(React.Fragment, null, role != "Member" || role == "Member" && allowEmployeesToManageTheirTasks && taskCreatedBy == userId ? /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-footer-badge",
      onClick: function onClick() {
        handleShow(taskId, taskUser, estimatedTime, dueDate, taskName, taskStatus, "hold", priority, taskStartDate, taskProgress, taskProgressUser, taskVisibility, description, allowEmployeesToManageTheirTasks, taskCreatedBy, userId, allowEmployeesToMarkTheirTasksAsCompleted);
      }
    }, "Set Priority") : /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "bottom",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "project-tooltip-start"
      }, "Please contact the admin to edit the task.")
    }, /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-footer-badge"
    }, "Set Priority"))) : /*#__PURE__*/React.createElement("div", {
      className: classNames({
        "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-footer-badge-low": priority == "low"
      }, {
        "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-footer-badge-medium": priority == "medium"
      }, {
        "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-footer-badge-high": priority == "high"
      }),
      onClick: function onClick(e) {
        return handleShowTaskDetails({
          taskId: taskId,
          taskName: taskName
        });
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-footer-badge-span"
    }, priority == "low" ? "🟢" : priority == "medium" ? "🟡" : priority == "high" ? "🔴" : null), priority), /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-header-edit-divs"
    }, role != "Member" || role == "Member" && allowEmployeesToManageTheirTasks && taskCreatedBy == userId ? /*#__PURE__*/React.createElement(FiEdit, {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-header-edit task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-header-edit-new",
      onClick: function onClick() {
        handleShow(taskId, taskUser, estimatedTime, dueDate, taskName, taskStatus, "hold", priority, taskStartDate, taskProgress, taskProgressUser, taskVisibility, description, allowEmployeesToManageTheirTasks, taskCreatedBy, userId, allowEmployeesToMarkTheirTasksAsCompleted);
      }
    }) : /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "bottom",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "project-tooltip-start"
      }, "Please contact the admin to edit the task.")
    }, /*#__PURE__*/React.createElement(FiEdit, {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-header-edit task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-header-edit-new"
    })), /*#__PURE__*/React.createElement(EditMenu, {
      taskId: taskId,
      taskProgress: taskProgress,
      taskProgressUser: taskProgressUser,
      taskType: taskType,
      handleTaskDeleteShow: handleTaskDeleteShow,
      handleShowTaskDetails: handleShowTaskDetails,
      taskName: taskName,
      role: role,
      allowEmployeesToManageTheirTasks: allowEmployeesToManageTheirTasks,
      taskCreatedBy: taskCreatedBy,
      userId: userId,
      allowEmployeesToMarkTheirTasksAsCompleted: allowEmployeesToMarkTheirTasksAsCompleted,
      taskUser: taskUser,
      assignedTo: assignedTo,
      taskStatus: taskStatus,
      handleCompletedShow: handleCompletedShow,
      projectId: projectId,
      handleUndoCompletedShow: handleUndoCompletedShow,
      handleHoldShow: handleHoldShow
    })))));
  }), projectTasksList3 !== null && projectTasksList3 !== void 0 && (_projectTasksList3$ge3 = projectTasksList3.getFilterTaskTrackerDetails) !== null && _projectTasksList3$ge3 !== void 0 && _projectTasksList3$ge3.length ? /*#__PURE__*/React.createElement("div", {
    className: "review-apps-load-more-button"
  }, (projectTasksList3 === null || projectTasksList3 === void 0 ? void 0 : (_projectTasksList3$ge4 = projectTasksList3.getFilterTaskTrackerDetails) === null || _projectTasksList3$ge4 === void 0 ? void 0 : _projectTasksList3$ge4.length) < LIMIT || isTaskAllLoaded3 ? /*#__PURE__*/React.createElement("p", {
    className: "project-details-all-task-label"
  }, "You have seen all the task") : /*#__PURE__*/React.createElement(React.Fragment, null, isTaskLoadingMore3 ? /*#__PURE__*/React.createElement("div", {
    className: "review-apps-load-more-button"
  }, /*#__PURE__*/React.createElement(Loader, null)) : /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    onClick: function onClick(e) {
      handleTabScroll3(e);
    }
  }, "Load more"))) : null)))), /*#__PURE__*/React.createElement("div", {
    className: "task-header-menu-whole-div-content-whole-filter-content-div-canban-view-grid-part"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-header-menu-whole-div-content-whole-filter-content-div-canban-view-grid-part-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-header-over"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-header-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-header-text"
  }, "Overdue"), /*#__PURE__*/React.createElement("div", {
    className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-header-count"
  }, (taskCountData === null || taskCountData === void 0 ? void 0 : (_taskCountData$taskCo36 = taskCountData.taskCount) === null || _taskCountData$taskCo36 === void 0 ? void 0 : _taskCountData$taskCo36.onDueTaskCount) != 0 && !taskCountLoading && !taskCountError ? "".concat(taskCountData === null || taskCountData === void 0 ? void 0 : (_taskCountData$taskCo37 = taskCountData.taskCount) === null || _taskCountData$taskCo37 === void 0 ? void 0 : _taskCountData$taskCo37.onDueTaskCount) : "0")))), /*#__PURE__*/React.createElement("div", {
    className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-scroll"
  }, filterTaskLoading4 ? /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(Loader, null)) : filterTaskError4 ? /*#__PURE__*/React.createElement("p", null, "Something went wrong, please refresh the page.") : (projectTasksList4 === null || projectTasksList4 === void 0 ? void 0 : (_projectTasksList4$ge = projectTasksList4.getFilterTaskTrackerDetails) === null || _projectTasksList4$ge === void 0 ? void 0 : _projectTasksList4$ge.length) == 0 ? /*#__PURE__*/React.createElement("div", {
    className: "project-details-task-card-body-filter-no-data-div"
  }, /*#__PURE__*/React.createElement("p", {
    className: "project-details-task-card-body-filter-section-buttions-add-button-nodata"
  }, "No task available")) : /*#__PURE__*/React.createElement(React.Fragment, null, projectTasksList4 === null || projectTasksList4 === void 0 ? void 0 : (_projectTasksList4$ge2 = projectTasksList4.getFilterTaskTrackerDetails) === null || _projectTasksList4$ge2 === void 0 ? void 0 : _projectTasksList4$ge2.map(function (list, index) {
    var taskId = list.taskId,
      taskName = list.taskName,
      taskStatus = list.taskStatus,
      assignedTo = list.assignedTo,
      totalWorkedTime = list.totalWorkedTime,
      totalMyWorkedTime = list.totalMyWorkedTime,
      assignedToAll = list.assignedToAll,
      taskUser = list.taskUser,
      estimatedTime = list.estimatedTime,
      dueDate = list.dueDate,
      taskLabelStatus = list.taskLabelStatus,
      priority = list.priority,
      startDate = list.startDate,
      taskProgress = list.taskProgress,
      taskProgressUser = list.taskProgressUser,
      taskType = list.taskType,
      taskVisibility = list.taskVisibility,
      description = list.description,
      taskDueStatus = list.taskDueStatus,
      taskCreatedBy = list.taskCreatedBy,
      totalTime = list.totalTime;
    var _assignedTo$split9 = assignedTo.split(" "),
      _assignedTo$split10 = _slicedToArray(_assignedTo$split9, 2),
      label = _assignedTo$split10[0],
      count = _assignedTo$split10[1];
    return /*#__PURE__*/React.createElement("div", {
      className: classNames("task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-whole-list", {
        "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-whole-list-medium": priority == "medium"
      }, {
        "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-whole-list-high": priority == "high"
      }, {
        "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-whole-list-low": priority == "low"
      })
    }, /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list"
    }, /*#__PURE__*/React.createElement("div", {
      onClick: function onClick(e) {
        return handleShowTaskDetails({
          taskId: taskId,
          taskName: taskName
        });
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-header"
    }, /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "project-tooltip-start"
      }, taskName)
    }, /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-header-name"
    }, taskName))), /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-header-content"
    }, /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-work-hour-div"
    }, /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-work-hour"
    }, /*#__PURE__*/React.createElement(MdAccessTime, {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-work-hour-icon"
    }), /*#__PURE__*/React.createElement("span", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-work-hour-whole-span"
    }, totalTime)), /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-work-hour"
    }, /*#__PURE__*/React.createElement(RiTimerLine, {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-work-hour-icon-timer"
    }), /*#__PURE__*/React.createElement("span", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-work-hour-span"
    }, "My:", " ", /*#__PURE__*/React.createElement("span", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-work-hour-span-my"
    }, totalMyWorkedTime)))), /*#__PURE__*/React.createElement("div", null, assignedTo ? assignedTo == "Everyone" ? /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-work-hour-div-person"
    }, /*#__PURE__*/React.createElement(FiUsers, {
      className: "project-details-task-card-body-table-assigned-to-icons"
    }), "Public") : assignedTo.includes("Members") ? /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom-name",
        className: "project-tooltip-start"
      }, assignedToAll ? label : "-")
    }, /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-work-hour-div-person-member-text"
    }, /*#__PURE__*/React.createElement(FiUsers, {
      className: "project-details-task-card-body-table-assigned-to-icons"
    }), assignedTo ? assignedTo : "-")) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom-name",
        className: "project-tooltip-start"
      }, assignedToAll ? assignedToAll : "-")
    }, /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-work-hour-div-person-member-text-1"
    }, assignedTo ? assignedTo.trim().charAt(0) : "-"))) : /*#__PURE__*/React.createElement("div", {
      className: "desktop-home-project-card-table-display-name-not-assigned-kanban-project"
    }, /*#__PURE__*/React.createElement(FiUsers, {
      className: "project-details-task-card-body-table-assigned-to-icons"
    }), "No one")))), /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-footer"
    }, priority == "" || priority == null ? /*#__PURE__*/React.createElement(React.Fragment, null, role != "Member" || role == "Member" && allowEmployeesToManageTheirTasks && taskCreatedBy == userId ? /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-footer-badge",
      onClick: function onClick() {
        handleShow(taskId, taskUser, estimatedTime, dueDate, taskName, taskStatus, "On due", priority, taskStartDate, taskProgress, taskProgressUser, taskVisibility, description, allowEmployeesToManageTheirTasks, taskCreatedBy, userId, allowEmployeesToMarkTheirTasksAsCompleted);
      }
    }, "Set Priority") : /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "bottom",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "project-tooltip-start"
      }, "Please contact the admin to edit the task.")
    }, /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-footer-badge"
    }, "Set Priority"))) : /*#__PURE__*/React.createElement("div", {
      className: classNames({
        "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-footer-badge-low": priority == "low"
      }, {
        "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-footer-badge-medium": priority == "medium"
      }, {
        "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-footer-badge-high": priority == "high"
      }),
      onClick: function onClick(e) {
        return handleShowTaskDetails({
          taskId: taskId,
          taskName: taskName
        });
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-footer-badge-span"
    }, priority == "low" ? "🟢" : priority == "medium" ? "🟡" : priority == "high" ? "🔴" : null), priority), /*#__PURE__*/React.createElement("div", {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-header-edit-divs"
    }, role != "Member" || role == "Member" && allowEmployeesToManageTheirTasks && taskCreatedBy == userId ? /*#__PURE__*/React.createElement(FiEdit, {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-header-edit task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-header-edit-new",
      onClick: function onClick() {
        handleShow(taskId, taskUser, estimatedTime, dueDate, taskName, taskStatus, "On due", priority, taskStartDate, taskProgress, taskProgressUser, taskVisibility, description, allowEmployeesToManageTheirTasks, taskCreatedBy, userId, allowEmployeesToMarkTheirTasksAsCompleted);
      }
    }) : /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "bottom",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "project-tooltip-start"
      }, "Please contact the admin to edit the task.")
    }, /*#__PURE__*/React.createElement(FiEdit, {
      className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-header-edit task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-header-edit-new"
    })), /*#__PURE__*/React.createElement(EditMenu, {
      taskId: taskId,
      taskProgress: taskProgress,
      taskProgressUser: taskProgressUser,
      taskType: taskType,
      handleTaskDeleteShow: handleTaskDeleteShow,
      handleShowTaskDetails: handleShowTaskDetails,
      taskName: taskName,
      role: role,
      allowEmployeesToManageTheirTasks: allowEmployeesToManageTheirTasks,
      taskCreatedBy: taskCreatedBy,
      userId: userId,
      allowEmployeesToMarkTheirTasksAsCompleted: allowEmployeesToMarkTheirTasksAsCompleted,
      taskUser: taskUser,
      assignedTo: assignedTo,
      taskStatus: taskStatus,
      handleCompletedShow: handleCompletedShow,
      projectId: projectId,
      handleUndoCompletedShow: handleUndoCompletedShow,
      handleHoldShow: handleHoldShow
    })))));
  }), projectTasksList4 !== null && projectTasksList4 !== void 0 && (_projectTasksList4$ge3 = projectTasksList4.getFilterTaskTrackerDetails) !== null && _projectTasksList4$ge3 !== void 0 && _projectTasksList4$ge3.length ? /*#__PURE__*/React.createElement("div", {
    className: "review-apps-load-more-button"
  }, (projectTasksList4 === null || projectTasksList4 === void 0 ? void 0 : (_projectTasksList4$ge4 = projectTasksList4.getFilterTaskTrackerDetails) === null || _projectTasksList4$ge4 === void 0 ? void 0 : _projectTasksList4$ge4.length) < LIMIT || isTaskAllLoaded4 ? /*#__PURE__*/React.createElement("p", {
    className: "project-details-all-task-label"
  }, "You have seen all the task") : /*#__PURE__*/React.createElement(React.Fragment, null, isTaskLoadingMore4 ? /*#__PURE__*/React.createElement("div", {
    className: "review-apps-load-more-button"
  }, /*#__PURE__*/React.createElement(Loader, null)) : /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    onClick: function onClick(e) {
      handleTabScroll4(e);
    }
  }, "Load more"))) : null)))));
};
var EditMenu = function EditMenu(props) {
  var role = props.role,
    allowEmployeesToManageTheirTasks = props.allowEmployeesToManageTheirTasks,
    taskCreatedBy = props.taskCreatedBy,
    userId = props.userId,
    taskId = props.taskId,
    taskProgress = props.taskProgress,
    taskProgressUser = props.taskProgressUser,
    taskType = props.taskType,
    handleTaskDeleteShow = props.handleTaskDeleteShow,
    handleShowTaskDetails = props.handleShowTaskDetails,
    taskName = props.taskName,
    allowEmployeesToMarkTheirTasksAsCompleted = props.allowEmployeesToMarkTheirTasksAsCompleted,
    taskUser = props.taskUser,
    assignedTo = props.assignedTo,
    taskStatus = props.taskStatus,
    handleCompletedShow = props.handleCompletedShow,
    projectId = props.projectId,
    handleUndoCompletedShow = props.handleUndoCompletedShow,
    handleHoldShow = props.handleHoldShow;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Dropdown, {
    className: "manage-teams-edit-menus-project-details-kanban"
  }, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
    variant: "success",
    id: "dropdown-basic"
  }, /*#__PURE__*/React.createElement(FiMoreHorizontal, {
    className: "task-header-menu-whole-div-content-whole-filter-content-div-kanban-view-content-list-header-edit"
  })), /*#__PURE__*/React.createElement(Dropdown.Menu, null, role != "Member" || role == "Member" && allowEmployeesToMarkTheirTasksAsCompleted && taskCreatedBy == userId ? /*#__PURE__*/React.createElement(React.Fragment, null, (role !== "Member" || role === "Member" && allowEmployeesToMarkTheirTasksAsCompleted && (taskUser.some(function (user) {
    return user.userId === userId;
  }) || assignedTo === "Everyone")) && (taskStatus !== "completed" ? /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: function onClick() {
      return handleCompletedShow(taskId, projectId, taskProgress, taskProgressUser, taskStatus);
    }
  }, "Mark as completed") : /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: function onClick() {
      return handleUndoCompletedShow(taskId, projectId, taskStatus);
    }
  }, "Undo Complete")), role === "Member" && allowEmployeesToMarkTheirTasksAsCompleted && taskStatus !== "completed" && (taskUser.some(function (user) {
    return user.userId === userId;
  }) || assignedTo === "Everyone") && taskStatus !== "hold" && /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: function onClick() {
      return handleHoldShow(taskId, projectId, taskProgress, taskProgressUser, taskStatus);
    }
  }, "Mark as hold"), /*#__PURE__*/React.createElement(Dropdown.Divider, null)) : null, role != "Member" || role == "Member" && allowEmployeesToManageTheirTasks && taskCreatedBy == userId ? /*#__PURE__*/React.createElement(Dropdown.Item, {
    className: "manage-teams-edit-menus-delete-icon",
    onClick: function onClick() {
      return handleTaskDeleteShow(taskId, taskProgress, taskProgressUser, taskType, taskStatus);
    }
  }, "Delete") : /*#__PURE__*/React.createElement(OverlayTrigger, {
    rootClose: true,
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "project-tooltip-start"
    }, "Please contact the admin to delete the task.")
  }, /*#__PURE__*/React.createElement(Dropdown.Item, {
    className: "manage-teams-edit-menus-delete-icon"
  }, "Delete")), /*#__PURE__*/React.createElement(Dropdown.Divider, null), /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: function onClick(e) {
      return handleShowTaskDetails({
        taskId: taskId,
        taskName: taskName
      });
    }
  }, "View Task"))));
};
var TableData = function TableData(props) {
  var projectTasksList = props.projectTasksList,
    taskListError = props.taskListError,
    taskListLoading = props.taskListLoading,
    taskFetchMore = props.taskFetchMore,
    taskStartDate = props.taskStartDate,
    allowEmployeesToManageTheirTasks = props.allowEmployeesToManageTheirTasks,
    allowEmployeesToMarkTheirTasksAsCompleted = props.allowEmployeesToMarkTheirTasksAsCompleted,
    handleShow = props.handleShow,
    userId = props.userId,
    handleTaskDeleteShow = props.handleTaskDeleteShow,
    tableView = props.tableView,
    handleShowTaskDetails = props.handleShowTaskDetails,
    handleTaskShow = props.handleTaskShow,
    projectId = props.projectId,
    role = props.role,
    filterPriority = props.filterPriority,
    projectSearch = props.projectSearch,
    handleCompletedShow = props.handleCompletedShow,
    handleUndoCompletedShow = props.handleUndoCompletedShow,
    handleHoldShow = props.handleHoldShow,
    setQuickEditToDoWorkingStatus = props.setQuickEditToDoWorkingStatus,
    setQuickEditInProgressWorkingStatus = props.setQuickEditInProgressWorkingStatus,
    setQuickEditDueWorkingStatus = props.setQuickEditDueWorkingStatus,
    setQuickEditCompletedWorkingStatus = props.setQuickEditCompletedWorkingStatus,
    setQuickEditHoldWorkingStatus = props.setQuickEditHoldWorkingStatus,
    taskActive = props.taskActive,
    setIsQuickEditModal = props.setIsQuickEditModal,
    setIsQuickEditMemberModal = props.setIsQuickEditMemberModal,
    quickEditWorkingStatus = props.quickEditWorkingStatus,
    quickEditType = props.quickEditType,
    isQuickEditSelect = props.isQuickEditSelect,
    setIsQuickEditSelect = props.setIsQuickEditSelect,
    setTaskActive = props.setTaskActive,
    isQuickEditToDoSelect = props.isQuickEditToDoSelect,
    setIsQuickEditToDoSelect = props.setIsQuickEditToDoSelect,
    isQuickEditInProgressSelect = props.isQuickEditInProgressSelect,
    setIsQuickEditInProgressSelect = props.setIsQuickEditInProgressSelect,
    isQuickEditDueSelect = props.isQuickEditDueSelect,
    setIsQuickEditDueSelect = props.setIsQuickEditDueSelect,
    isQuickEditCompletedSelect = props.isQuickEditCompletedSelect,
    setIsQuickEditCompletedSelect = props.setIsQuickEditCompletedSelect,
    isQuickEditHoldSelect = props.isQuickEditHoldSelect,
    setIsQuickEditHoldSelect = props.setIsQuickEditHoldSelect,
    setToDoTaskActive = props.setToDoTaskActive,
    setInProgessTaskActive = props.setInProgessTaskActive,
    setOverDueTaskActive = props.setOverDueTaskActive,
    setCompletedTaskActive = props.setCompletedTaskActive,
    setHoldTaskActive = props.setHoldTaskActive,
    setQuickEditWorkingStatus = props.setQuickEditWorkingStatus,
    isQuickEditCheck = props.isQuickEditCheck,
    parameterCheck = props.parameterCheck;
  var _React$useState161 = React.useState(false),
    _React$useState162 = _slicedToArray(_React$useState161, 2),
    isTaskAllLoaded = _React$useState162[0],
    setTaskIsAllLoaded = _React$useState162[1];
  var _React$useState163 = React.useState(false),
    _React$useState164 = _slicedToArray(_React$useState163, 2),
    isTaskLoadingMore = _React$useState164[0],
    setTaskIsLoadingMore = _React$useState164[1];
  var optionList = [{
    label: "To Do",
    value: "todo"
  }, {
    label: "In Progress",
    value: "inprogress"
  }, {
    label: "On Hold",
    value: "onhold"
  }, {
    label: "Completed",
    value: "completed"
  }];
  var _React$useState165 = React.useState({
      label: "To Do",
      value: "todo"
    }),
    _React$useState166 = _slicedToArray(_React$useState165, 2),
    statusCheck = _React$useState166[0],
    setStatusCheck = _React$useState166[1];

  //load more
  function handleTabScroll(e) {
    var element = e.target;
    if (element.scrollHeight - element.scrollTop === element.clientHeight) {
      if (taskListLoading) return;
      if (isTaskAllLoaded) return;
      setTaskIsLoadingMore(true);
      taskFetchMore({
        variables: {
          offset: projectTasksList.length
        },
        updateQuery: function updateQuery(prev, _ref12) {
          var fetchMoreResult = _ref12.fetchMoreResult;
          if (!fetchMoreResult) return prev;
          if (tableView == "taskList" && fetchMoreResult.projectTasks.length < TASK_LIMIT && !isTaskAllLoaded) {
            setTaskIsAllLoaded(true);
          } else if (tableView !== "taskList" && fetchMoreResult.getFilterTaskTrackerDetails.length < LIMIT && !isTaskAllLoaded) {
            setTaskIsAllLoaded(true);
          }
          setTaskIsLoadingMore(false);
          var NewFilterData = [];
          if (tableView == "taskList") {
            fetchMoreResult.projectTasks.forEach(function (newTask) {
              var found = prev.projectTasks.find(function (item) {
                return item.taskId === newTask.taskId;
              });
              if (!found) {
                // If not found, add validation.
                NewFilterData.push(newTask);
              }
            });
            return _objectSpread(_objectSpread({}, prev), {}, {
              projectTasks: [].concat(_toConsumableArray(prev.projectTasks), NewFilterData)
            });
          } else {
            fetchMoreResult.getFilterTaskTrackerDetails.forEach(function (newTask) {
              var found = prev.getFilterTaskTrackerDetails.find(function (item) {
                return item.taskId === newTask.taskId;
              });
              if (!found) {
                // If not found, add validation.
                NewFilterData.push(newTask);
              }
            });
            return _objectSpread(_objectSpread({}, prev), {}, {
              getFilterTaskTrackerDetails: [].concat(_toConsumableArray(prev.getFilterTaskTrackerDetails), NewFilterData)
            });
          }
        }
      });
      //setLimits(LIMIT + 20);
    }
  }
  return /*#__PURE__*/React.createElement("div", null, taskListLoading ? /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(Loader, null)) : taskListError ? /*#__PURE__*/React.createElement("p", null, "Something went wrong, please refresh the page.") : (projectTasksList === null || projectTasksList === void 0 ? void 0 : projectTasksList.length) == 0 ? /*#__PURE__*/React.createElement("div", {
    className: "project-details-task-card-body-filter-no-data-div"
  }, tableView == "taskList" && projectSearch !== "" && filterPriority !== "" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", null, "Yet to create a first task!"), /*#__PURE__*/React.createElement(Button, {
    variant: "success",
    className: "project-details-task-card-body-filter-section-buttions-add-button",
    onClick: function onClick() {
      handleTaskShow(projectId);
    }
  }, "+ Add New Task")) : /*#__PURE__*/React.createElement("p", {
    className: "project-details-task-card-body-filter-section-buttions-add-button-nodata"
  }, "No tasks available.")) : /*#__PURE__*/React.createElement(React.Fragment, null, isQuickEditCheck && taskActive.length ? /*#__PURE__*/React.createElement(QuickEditTaskButtons, {
    taskActive: taskActive,
    setIsQuickEditModal: setIsQuickEditModal,
    setIsQuickEditMemberModal: setIsQuickEditMemberModal,
    quickEditWorkingStatus: quickEditWorkingStatus,
    quickEditType: quickEditType,
    isQuickEditSelect: isQuickEditSelect,
    setIsQuickEditSelect: setIsQuickEditSelect,
    projectTasks: projectTasksList,
    setTaskActive: setTaskActive,
    isQuickEditToDoSelect: isQuickEditToDoSelect,
    setIsQuickEditToDoSelect: setIsQuickEditToDoSelect,
    isQuickEditInProgressSelect: isQuickEditInProgressSelect,
    setIsQuickEditInProgressSelect: setIsQuickEditInProgressSelect,
    isQuickEditDueSelect: isQuickEditDueSelect,
    setIsQuickEditDueSelect: setIsQuickEditDueSelect,
    isQuickEditCompletedSelect: isQuickEditCompletedSelect,
    setIsQuickEditCompletedSelect: setIsQuickEditCompletedSelect,
    isQuickEditHoldSelect: isQuickEditHoldSelect,
    setIsQuickEditHoldSelect: setIsQuickEditHoldSelect,
    setToDoTaskActive: setToDoTaskActive,
    setInProgessTaskActive: setInProgessTaskActive,
    setOverDueTaskActive: setOverDueTaskActive,
    setCompletedTaskActive: setCompletedTaskActive,
    setHoldTaskActive: setHoldTaskActive,
    setQuickEditWorkingStatus: setQuickEditWorkingStatus,
    setQuickEditToDoWorkingStatus: setQuickEditToDoWorkingStatus,
    setQuickEditInProgressWorkingStatus: setQuickEditInProgressWorkingStatus,
    setQuickEditDueWorkingStatus: setQuickEditDueWorkingStatus,
    setQuickEditCompletedWorkingStatus: setQuickEditCompletedWorkingStatus,
    setQuickEditHoldWorkingStatus: setQuickEditHoldWorkingStatus,
    allowEmployeesToManageTheirTasks: allowEmployeesToManageTheirTasks,
    role: role
  }) : null, /*#__PURE__*/React.createElement("div", {
    className: "task-management-table-scroll"
  }, /*#__PURE__*/React.createElement(Table, {
    className: "task-management-table-data-whole-div"
  }, isQuickEditCheck && taskActive.length ? null : /*#__PURE__*/React.createElement("thead", {
    className: "task-management-table-thead"
  }, /*#__PURE__*/React.createElement("tr", {
    className: "task-management-table-thead-tr"
  }, /*#__PURE__*/React.createElement("th", {
    className: "task-management-table-thead-tr-th",
    key: "task-title"
  }, "Task Title"), parameterCheck === null || parameterCheck === void 0 ? void 0 : parameterCheck.map(function (param) {
    return /*#__PURE__*/React.createElement("th", {
      key: param.value
    }, param.label);
  }), /*#__PURE__*/React.createElement("th", {
    key: "total-time"
  }, "Total Time"), /*#__PURE__*/React.createElement("th", {
    key: "status"
  }, "Status"), /*#__PURE__*/React.createElement("th", {
    key: "action"
  }, "Action"))), /*#__PURE__*/React.createElement("tbody", {
    className: "task-management-table-tbody"
  }, projectTasksList === null || projectTasksList === void 0 ? void 0 : projectTasksList.map(function (list, index) {
    var taskId = list.taskId,
      taskName = list.taskName,
      taskStatus = list.taskStatus,
      assignedTo = list.assignedTo,
      totalWorkedTime = list.totalWorkedTime,
      totalMyWorkedTime = list.totalMyWorkedTime,
      assignedToAll = list.assignedToAll,
      taskUser = list.taskUser,
      estimatedTime = list.estimatedTime,
      dueDate = list.dueDate,
      taskLabelStatus = list.taskLabelStatus,
      priority = list.priority,
      startDate = list.startDate,
      taskProgress = list.taskProgress,
      taskProgressUser = list.taskProgressUser,
      taskType = list.taskType,
      taskVisibility = list.taskVisibility,
      description = list.description,
      taskDueStatus = list.taskDueStatus,
      taskCreatedBy = list.taskCreatedBy,
      totalTime = list.totalTime,
      attachmentCount = list.attachmentCount;
    return /*#__PURE__*/React.createElement("tr", {
      key: index
    }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
      className: "task-management-table-tbody-name-whole-div"
    }, isQuickEditCheck ? /*#__PURE__*/React.createElement("div", {
      className: "quick-edit-project-details-input-div"
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      id: taskId,
      name: "myRadioGroup",
      className: "create-project-team-selection-control-checkbox",
      checked: taskActive.includes(taskId),
      onChange: function onChange() {
        setTaskActive(function (prev) {
          return prev.includes(taskId) ? prev.filter(function (a) {
            return a !== taskId;
          }) : [].concat(_toConsumableArray(prev), [taskId]);
        });
        if (taskProgress == "ongoing") {
          setQuickEditWorkingStatus(function (prev) {
            return prev.includes(taskId) ? prev.filter(function (a) {
              return a !== taskId;
            }) : [].concat(_toConsumableArray(prev), [taskId]);
          });
        }
      },
      disabled: taskType == "automatic" ? true : false
    })) : null, /*#__PURE__*/React.createElement("div", {
      className: "task-management-table-tbody-name-div-line",
      onClick: function onClick(e) {
        return handleShowTaskDetails({
          taskId: taskId,
          taskName: taskName
        });
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "task-management-table-tbody-name-div",
      onClick: function onClick(e) {
        return handleShowTaskDetails({
          taskId: taskId,
          taskName: taskName
        });
      }
    }, /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "project-tooltip-start"
      }, taskName)
    }, /*#__PURE__*/React.createElement("span", {
      className: "task-management-table-tbody-name-div-span"
    }, taskName)), attachmentCount ? /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "bottom",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "project-tooltip-start"
      }, "Attachment")
    }, /*#__PURE__*/React.createElement("div", {
      className: "task-management-table-tbody-name-div-attachment-count-div"
    }, /*#__PURE__*/React.createElement(FiPaperclip, {
      className: "task-management-table-tbody-name-div-attachment-count-div-icon"
    }), " ", attachmentCount)) : null))), parameterCheck === null || parameterCheck === void 0 ? void 0 : parameterCheck.map(function (param) {
      return /*#__PURE__*/React.createElement("td", {
        key: param.value
      }, function () {
        switch (param.value) {
          // ✅ Assigned To Column
          case "assignedTo":
            return /*#__PURE__*/React.createElement("div", {
              className: "task-management-table-tbody-person-name-whole-div"
            }, /*#__PURE__*/React.createElement("div", {
              className: "task-management-table-tbody-person-name-whole-div-full-name"
            }, /*#__PURE__*/React.createElement("span", {
              className: "task-management-table-tbody-person-name-whole-div-full-name-span"
            }, assignedTo === "" ? "-" : assignedTo)));

          // ✅ My Time Column
          case "totalMyWorkedTime":
            return /*#__PURE__*/React.createElement("div", {
              className: "task-management-table-tbody-total-my-time-whole-div"
            }, /*#__PURE__*/React.createElement(RiTimerLine, {
              className: "task-management-table-tbody-total-my-time-whole-div-icon"
            }), totalMyWorkedTime || "-");

          // ✅ Priority Column
          case "priority":
            return priority ? /*#__PURE__*/React.createElement(OverlayTrigger, {
              rootClose: true,
              placement: "bottom",
              overlay: /*#__PURE__*/React.createElement(Tooltip, {
                id: "tooltip-priority-".concat(taskId),
                className: "project-tooltip-start project-tooltip-start-tooltip"
              }, "Priority")
            }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FiFlag, {
              className: "desktop-home-project-card-task-tracker-table-description-priority-icon desktop-home-project-card-task-tracker-table-description-priority-".concat(priority)
            }), /*#__PURE__*/React.createElement("span", {
              className: "project-details-project-card-task-tracker-table-description-priority desktop-home-project-card-task-tracker-table-description-priority-".concat(priority)
            }, priority))) : /*#__PURE__*/React.createElement("div", {
              className: "task-management-table-tbody-person-name-whole-div-full-name-span"
            }, "Not Set");

          // ✅ Estimated Time Column
          case "estimatedTime":
            return estimatedTime ? /*#__PURE__*/React.createElement(OverlayTrigger, {
              rootClose: true,
              placement: "bottom",
              overlay: /*#__PURE__*/React.createElement(Tooltip, {
                id: "tooltip-estimated-".concat(taskId),
                className: "project-tooltip-start project-tooltip-start-tooltip"
              }, "Estimated Time")
            }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FiClock, {
              className: "desktop-home-project-card-task-tracker-table-description-glass-icon-new"
            }), /*#__PURE__*/React.createElement("span", {
              className: "project-details-project-card-task-tracker-table-description-priority"
            }, convertSecToHours(Number(estimatedTime)), " hours"))) : /*#__PURE__*/React.createElement("div", {
              className: "task-management-table-tbody-person-name-whole-div-full-name-span"
            }, "Not Set");

          // ✅ Due Date Column
          case "dueDate":
            return dueDate ? /*#__PURE__*/React.createElement(OverlayTrigger, {
              rootClose: true,
              placement: "bottom",
              overlay: /*#__PURE__*/React.createElement(Tooltip, {
                id: "tooltip-due-".concat(taskId),
                className: "project-tooltip-start project-tooltip-start-tooltip"
              }, "Deadline")
            }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(MdEventAvailable, {
              className: "desktop-home-project-card-task-tracker-table-description-date-icon ".concat(taskDueStatus === "Overdue" ? "my-projects-ondue-selected" : "")
            }), /*#__PURE__*/React.createElement("span", {
              className: "project-details-project-card-task-tracker-table-description-priority ".concat(taskDueStatus === "Overdue" ? "my-projects-ondue-selected" : "")
            }, moment.unix(Number(dueDate) / 1000).format("DD MMM")))) : /*#__PURE__*/React.createElement("div", {
              className: "task-management-table-tbody-person-name-whole-div-full-name-span"
            }, "Not Set");
          default:
            return "-";
        }
      }());
    }), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
      className: "task-management-table-tbody-total-time-whole-div"
    }, /*#__PURE__*/React.createElement(MdAccessTime, {
      className: "task-management-table-tbody-total-time-whole-div-icon"
    }), tableView == "taskList" ? totalWorkedTime : totalTime)), /*#__PURE__*/React.createElement("td", null, role != "Member" || role == "Member" && allowEmployeesToMarkTheirTasksAsCompleted && taskCreatedBy == userId ? /*#__PURE__*/React.createElement("div", {
      className: "task-management-table-tbody-whole-filter-div"
    }, /*#__PURE__*/React.createElement(Dropdown, null, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
      variant: "light",
      size: "sm",
      className: "task-overview-my-task-user-select-project-details"
    }, tableView == "taskList" ? taskLabelStatus : tableView == "upcomingTasks" ? "To Do" : tableView == "inProgressTasks" ? "In Progress" : tableView == "onDue" ? "Overdue" : tableView == "completed" ? "Completed" : "On Hold"), /*#__PURE__*/React.createElement(Dropdown.Menu, null, (role !== "Member" || role === "Member" && allowEmployeesToMarkTheirTasksAsCompleted && (taskUser.some(function (user) {
      return user.userId === userId;
    }) || assignedTo === "Everyone")) && (taskStatus !== "completed" ? /*#__PURE__*/React.createElement(Dropdown.Item, {
      onClick: function onClick() {
        return handleCompletedShow(taskId, projectId, taskProgress, taskProgressUser);
      }
    }, "Mark as completed") : /*#__PURE__*/React.createElement(Dropdown.Item, {
      onClick: function onClick() {
        return handleUndoCompletedShow(taskId, projectId);
      }
    }, "Undo Complete")), role === "Member" && allowEmployeesToMarkTheirTasksAsCompleted && taskStatus !== "completed" && (taskUser.some(function (user) {
      return user.userId === userId;
    }) || assignedTo === "Everyone") && taskStatus !== "hold" && /*#__PURE__*/React.createElement(Dropdown.Item, {
      onClick: function onClick() {
        return handleHoldShow(taskId, projectId, taskProgress, taskProgressUser);
      }
    }, "Mark as hold")))) : /*#__PURE__*/React.createElement("div", {
      className: "task-management-table-tbody-whole-filter-div-extra "
    }, tableView == "taskList" ? taskLabelStatus : tableView == "upcomingTasks" ? "To Do" : tableView == "inProgressTasks" ? "In Progress" : tableView == "onDue" ? "Overdue" : tableView == "completed" ? "Completed" : "On Hold")), /*#__PURE__*/React.createElement("td", null, role != "Member" || role == "Member" && allowEmployeesToManageTheirTasks && taskCreatedBy == userId ? /*#__PURE__*/React.createElement("div", {
      className: "task-management-table-tbody-whole-buttons-div"
    }, /*#__PURE__*/React.createElement(FiEdit, {
      className: "task-management-table-tbody-whole-buttons-div-edit",
      onClick: function onClick() {
        handleShow(taskId, taskUser, estimatedTime, dueDate, taskName, taskStatus, tableView == "taskList" ? taskLabelStatus : tableView == "upcomingTasks" ? "Upcoming" : tableView == "inProgressTasks" ? "In progress" : tableView == "onDue" ? "On due" : tableView == "completed" ? "Completed" : "Hold", priority, taskStartDate, taskProgress, taskProgressUser, taskVisibility, description, allowEmployeesToManageTheirTasks, taskCreatedBy, userId, allowEmployeesToMarkTheirTasksAsCompleted);
      }
    }), /*#__PURE__*/React.createElement(RiDeleteBinLine, {
      className: "task-management-table-tbody-whole-buttons-div-delete",
      onClick: function onClick() {
        return handleTaskDeleteShow(taskId, taskProgress, taskProgressUser, taskType);
      }
    })) : /*#__PURE__*/React.createElement("div", {
      className: "task-management-table-tbody-whole-buttons-div"
    }, /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "bottom",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "project-tooltip-start"
      }, "Please contact the admin to edit the task.")
    }, /*#__PURE__*/React.createElement(FiEdit, {
      className: "task-management-table-tbody-whole-buttons-div-edit"
    })), /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "bottom",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "project-tooltip-start"
      }, "Please contact the admin to delete the task.")
    }, /*#__PURE__*/React.createElement(RiDeleteBinLine, {
      className: "task-management-table-tbody-whole-buttons-div-delete"
    })))));
  }), /*#__PURE__*/React.createElement("tr", {
    className: "project-details-task-management-load-more-tr"
  }, /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", {
    colSpan: 3
  }, projectTasksList !== null && projectTasksList !== void 0 && projectTasksList.length ? /*#__PURE__*/React.createElement("div", {
    className: "review-apps-load-more-button"
  }, (projectTasksList === null || projectTasksList === void 0 ? void 0 : projectTasksList.length) < LIMIT || isTaskAllLoaded ? /*#__PURE__*/React.createElement("p", {
    className: "project-details-all-task-label"
  }, "You have seen all the task") : /*#__PURE__*/React.createElement(React.Fragment, null, isTaskLoadingMore ? /*#__PURE__*/React.createElement("div", {
    className: "review-apps-load-more-button"
  }, /*#__PURE__*/React.createElement(Loader, null)) : /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    onClick: function onClick(e) {
      handleTabScroll(e);
    }
  }, "Load more"))) : null)))))));
};
var EditMenuIcon = function EditMenuIcon(props) {
  var summaryData = props.summaryData,
    projectId = props.projectId,
    organisationId = props.organisationId,
    teamDetails = props.teamDetails,
    teamId = props.teamId,
    handleArchiveProjectShow = props.handleArchiveProjectShow,
    archiveStatus = props.archiveStatus,
    organisationBilling = props.organisationBilling,
    handleEditProjectShow = props.handleEditProjectShow,
    selectedTeam = props.selectedTeam,
    startDate = props.startDate,
    endDate = props.endDate,
    handleDeleteShow = props.handleDeleteShow,
    role = props.role;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Dropdown, {
    className: "manage-teams-edit-menus-project-details"
  }, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
    variant: "success",
    id: "dropdown-basic"
  }, /*#__PURE__*/React.createElement(FiSettings, {
    className: "manage-teams-edit-menus-icon-project"
  }), " ", /*#__PURE__*/React.createElement("span", {
    className: "manage-teams-edit-menus-icon-project-span"
  }, "Settings")), /*#__PURE__*/React.createElement(Dropdown.Menu, null, (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) != "free" ? /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: function onClick() {
      return handleArchiveProjectShow(summaryData.projectName, projectId, organisationId, teamDetails, teamId);
    }
  }, archiveStatus == "archive" ? "Unarchive" : "Archive") : /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-start"
    }, "Please upgrade your preminum plan to archive/unarchive project")
  }, /*#__PURE__*/React.createElement(Dropdown.Item, null, archiveStatus == "archive" ? "Unarchive" : "Archive")), /*#__PURE__*/React.createElement(Dropdown.Divider, null), /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: function onClick() {
      handleEditProjectShow(organisationId, summaryData.projectName, teamDetails, projectId, selectedTeam, teamId, startDate, endDate, summaryData.estimatedWorkedSec, summaryData.budget, summaryData.projectDeadline);
    }
  }, "Edit"), /*#__PURE__*/React.createElement(Dropdown.Divider, null), /*#__PURE__*/React.createElement(Dropdown.Item, {
    className: "manage-teams-edit-menus-delete-icon",
    onClick: function onClick(e) {
      handleDeleteShow(summaryData.projectName, projectId, organisationId, teamDetails, teamId);
    }
  }, "Delete"))));
};
var Employee = function Employee(props) {
  var _employeesData$projec, _employeesData$projec2;
  var employeesData = props.employeesData,
    employeesError = props.employeesError,
    employeesLoading = props.employeesLoading,
    organisationBilling = props.organisationBilling,
    projectId = props.projectId,
    organisationId = props.organisationId,
    projectName = props.projectName;

  // export
  var _React$useState167 = React.useState(false),
    _React$useState168 = _slicedToArray(_React$useState167, 2),
    exportButton = _React$useState168[0],
    setExportButton = _React$useState168[1];
  var _useLazyQuery13 = useLazyQuery(PROJECT_EMPLOYEE_WORKED_HOUR_EXPORT_QUERY, {
      // A rate-limited export (429) never returns data, and this screen's
      // spinner is cleared on data only - without this the export button
      // stays loading until the page is reloaded. The message itself is
      // shown by the errorLink in apollo/apollo-config.js.
      onError: function onError() {
        setExportButton(false);
      }
    }),
    _useLazyQuery14 = _slicedToArray(_useLazyQuery13, 2),
    getExport = _useLazyQuery14[0],
    _useLazyQuery14$ = _useLazyQuery14[1],
    exportLoading = _useLazyQuery14$.loading,
    exportData = _useLazyQuery14$.data;

  //export
  var xlsxData = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
    var dataValues, wb, ws, buf, fileName;
    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          dataValues = exportData === null || exportData === void 0 ? void 0 : exportData.projectEmployeesWorkedHours;
          if (dataValues) {
            _context7.next = 3;
            break;
          }
          return _context7.abrupt("return", []);
        case 3:
          wb = new Excel.Workbook();
          ws = wb.addWorksheet();
          ws.columns = [{
            header: "Member",
            key: "displayName",
            width: 20,
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Total Time",
            key: "workedHours",
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Tasks",
            key: "taskCount",
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Completed",
            key: "taskCompletedCount",
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Contribution",
            key: "contribution",
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }];
          dataValues.map(function (users, index) {
            var displayName = users.displayName,
              taskCount = users.taskCount,
              workedHours = users.workedHours,
              taskCompletedCount = users.taskCompletedCount,
              contribution = users.contribution;
            ws.addRow({
              displayName: displayName,
              workedHours: workedHours,
              taskCount: taskCount,
              taskCompletedCount: taskCompletedCount,
              contribution: "".concat(contribution, " %")
            });
          });
          ws.getCell("A1").font = {
            bold: true
          };
          ws.getCell("B1").font = {
            bold: true
          };
          ws.getCell("C1").font = {
            bold: true
          };
          ws.getCell("D1").font = {
            bold: true
          };
          ws.getCell("E1").font = {
            bold: true
          };
          _context7.next = 14;
          return wb.xlsx.writeBuffer();
        case 14:
          buf = _context7.sent;
          fileName = "".concat(projectName, "-team-performance-report.xlsx");
          saveAs(new Blob([buf]), fileName);
          setExportButton(false);
        case 18:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  })), [exportData]);
  React.useEffect(function () {
    xlsxData();
  }, [exportData]);

  //export
  var getExportData = /*#__PURE__*/function () {
    var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
      return _regeneratorRuntime().wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            setExportButton(true);
            getExport({
              variables: {
                projectId: projectId,
                organisationId: organisationId
              }
            });
          case 2:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }));
    return function getExportData() {
      return _ref14.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement("div", {
    className: "team-performance-whole-div"
  }, /*#__PURE__*/React.createElement("div", {
    className: "team-performance-whole-div-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "team-performance-whole-div-header-name"
  }, /*#__PURE__*/React.createElement(MdTrendingUp, {
    className: "team-performance-whole-div-header-name-icon"
  }), "Team Performance Report"), /*#__PURE__*/React.createElement("div", null, (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) != "free" ? !exportButton ? /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    onClick: function onClick() {
      getExportData();
    },
    className: "project-header-menu-whole-div-2-import-button"
  }, /*#__PURE__*/React.createElement(FiDownload, {
    className: "project-header-menu-whole-div-2-import-button-icon"
  }), " Export") : /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    className: "project-header-menu-whole-div-2-import-button"
  }, /*#__PURE__*/React.createElement(FiDownload, {
    className: "project-header-menu-whole-div-2-import-button-icon"
  }), "Downloading") : /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-start"
    }, "Please upgrade your plan to export task")
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    className: "project-header-menu-whole-div-2-import-button"
  }, /*#__PURE__*/React.createElement(FiDownload, {
    className: "project-header-menu-whole-div-2-import-button-icon"
  }), " Export")))), employeesLoading ? /*#__PURE__*/React.createElement(Loader, null) : employeesError ? /*#__PURE__*/React.createElement("p", null, "Something went wrong, please refresh the page.") : (employeesData === null || employeesData === void 0 ? void 0 : (_employeesData$projec = employeesData.projectEmployeesWorkedHours) === null || _employeesData$projec === void 0 ? void 0 : _employeesData$projec.length) == 0 ? /*#__PURE__*/React.createElement("p", {
    className: "emplyees-data-no"
  }, "No data found.") : /*#__PURE__*/React.createElement(Table, {
    responsive: true,
    className: "team-performance-whole-div-content"
  }, /*#__PURE__*/React.createElement("thead", {
    className: "team-performance-whole-div-content-thead"
  }, /*#__PURE__*/React.createElement("tr", {
    className: "team-performance-whole-div-content-thead-tr"
  }, /*#__PURE__*/React.createElement("th", {
    key: "task-title"
  }, "Member"), /*#__PURE__*/React.createElement("th", {
    key: "total-time"
  }, "Total Time"), /*#__PURE__*/React.createElement("th", {
    key: "my-time"
  }, "Tasks"), /*#__PURE__*/React.createElement("th", {
    key: "status"
  }, "Completed"), /*#__PURE__*/React.createElement("th", {
    key: "action"
  }, "Contribution"))), /*#__PURE__*/React.createElement("tbody", {
    className: "team-performance-whole-div-content-table-tbody"
  }, employeesData === null || employeesData === void 0 ? void 0 : (_employeesData$projec2 = employeesData.projectEmployeesWorkedHours) === null || _employeesData$projec2 === void 0 ? void 0 : _employeesData$projec2.map(function (list, index) {
    var userId = list.userId,
      displayName = list.displayName,
      profileUrl = list.profileUrl,
      workedHours = list.workedHours,
      taskCount = list.taskCount,
      uniqueUrl = list.uniqueUrl,
      billableRate = list.billableRate,
      userLabourCost = list.userLabourCost,
      profit = list.profit,
      taskCompletedCount = list.taskCompletedCount,
      contribution = list.contribution;
    return /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
      className: "team-performance-whole-div-content-table-tbody-members"
    }, /*#__PURE__*/React.createElement("div", {
      className: "team-performance-whole-div-content-table-tbody-members-letters"
    }, displayName === null || displayName === void 0 ? void 0 : displayName.charAt(0)), /*#__PURE__*/React.createElement("div", {
      className: "team-performance-whole-div-content-table-tbody-members-name"
    }, displayName))), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
      className: "team-performance-whole-div-content-table-tbody-total-time"
    }, /*#__PURE__*/React.createElement("div", {
      className: "team-performance-whole-div-content-table-tbody-total-time-count"
    }, workedHours, " "), /*#__PURE__*/React.createElement(ProgressBar, {
      now: contribution,
      className: "team-performance-whole-div-content-table-tbody-total-time-progress"
    }))), /*#__PURE__*/React.createElement("td", null, taskCount), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", null, taskCompletedCount)), /*#__PURE__*/React.createElement("td", null, contribution, "%"));
  }))));
};
export var TaskModal = function TaskModal(props) {
  var taskDetails = props.taskDetails,
    handleClose = props.handleClose,
    projectId = props.projectId,
    organisationId = props.organisationId,
    userId = props.userId,
    startDate = props.startDate,
    endDate = props.endDate,
    timezone = props.timezone,
    activeTab = props.activeTab,
    user = props.user,
    allowEmployeesToMarkTheirTasksAsCompleted = props.allowEmployeesToMarkTheirTasksAsCompleted,
    projectSearch = props.projectSearch,
    filterPriority = props.filterPriority,
    view = props.view;
  if (taskDetails === false) return null;
  var taskId = taskDetails.taskId,
    taskUser = taskDetails.taskUser,
    estimatedTime = taskDetails.estimatedTime,
    dueDate = taskDetails.dueDate,
    taskName = taskDetails.taskName,
    taskStatus = taskDetails.taskStatus,
    taskLabelStatus = taskDetails.taskLabelStatus,
    priority = taskDetails.priority,
    taskStartDate = taskDetails.taskStartDate,
    taskProgress = taskDetails.taskProgress,
    taskProgressUser = taskDetails.taskProgressUser,
    taskVisibility = taskDetails.taskVisibility,
    description = taskDetails.description,
    taskCreatedBy = taskDetails.taskCreatedBy;
  var _useQuery15 = useQuery(TASK_USERS_QUERY, {
      variables: {
        organisationId: organisationId,
        projectId: projectId
      },
      skip: !organisationId
    }),
    usersData = _useQuery15.data,
    usersError = _useQuery15.error,
    usersLoading = _useQuery15.loading;
  var userDetails = !usersLoading && !usersError ? usersData === null || usersData === void 0 ? void 0 : usersData.getTaskUserDetails : null;
  var selectedUserIds = [];
  if (taskUser !== null && taskUser !== void 0 && taskUser.length) {
    selectedUserIds = taskUser.map(function (team) {
      return team.userId;
    });
  }
  var userIds = userDetails === null || userDetails === void 0 ? void 0 : userDetails.map(function (user) {
    return user.userId;
  });
  var _React$useContext4 = React.useContext(FilterContext),
    organisationSettings = _React$useContext4.organisationSettings,
    teamId = _React$useContext4.teamId,
    role = _React$useContext4.role;
  var _React$useState169 = React.useState(selectedUserIds),
    _React$useState170 = _slicedToArray(_React$useState169, 2),
    userActive = _React$useState170[0],
    setUserActive = _React$useState170[1];
  var _React$useState171 = React.useState(""),
    _React$useState172 = _slicedToArray(_React$useState171, 2),
    searchUser = _React$useState172[0],
    setSearchUser = _React$useState172[1];
  var _React$useState173 = React.useState(true),
    _React$useState174 = _slicedToArray(_React$useState173, 2),
    isUserSelected = _React$useState174[0],
    setUserSelected = _React$useState174[1];
  var _React$useState175 = React.useState(dueDate !== null && dueDate !== void 0 ? dueDate : null),
    _React$useState176 = _slicedToArray(_React$useState175, 2),
    manualStartDate = _React$useState176[0],
    setManualStartDate = _React$useState176[1];
  var _React$useState177 = React.useState(false),
    _React$useState178 = _slicedToArray(_React$useState177, 2),
    isManualDatePickerOpen = _React$useState178[0],
    setIsManualDatePickerOpen = _React$useState178[1];
  var _React$useState179 = React.useState(taskStartDate ? Number(taskStartDate) : null),
    _React$useState180 = _slicedToArray(_React$useState179, 2),
    taskStartSelectedDate = _React$useState180[0],
    setTaskStartSelectedDate = _React$useState180[1];
  var _React$useState181 = React.useState(""),
    _React$useState182 = _slicedToArray(_React$useState181, 2),
    employeeSearch = _React$useState182[0],
    setEmployeeSearch = _React$useState182[1];
  var _React$useState183 = React.useState(taskVisibility == "public" ? false : true),
    _React$useState184 = _slicedToArray(_React$useState183, 2),
    isCheck = _React$useState184[0],
    setIsCheck = _React$useState184[1];
  var _React$useState185 = React.useState(userIds),
    _React$useState186 = _slicedToArray(_React$useState185, 2),
    publicActive = _React$useState186[0],
    setPublicActive = _React$useState186[1];
  var _React$useState187 = React.useState([]),
    _React$useState188 = _slicedToArray(_React$useState187, 2),
    adminUserIds = _React$useState188[0],
    setAdminUserIds = _React$useState188[1];
  React.useEffect(function () {
    var _usersData$getTaskUse;
    var userId = usersData === null || usersData === void 0 ? void 0 : (_usersData$getTaskUse = usersData.getTaskUserDetails) === null || _usersData$getTaskUse === void 0 ? void 0 : _usersData$getTaskUse.map(function (user) {
      return user.userId;
    });
    setPublicActive(userId);
    if (role == "Member") {
      var _usersData$getTaskUse2;
      var adminList = usersData === null || usersData === void 0 ? void 0 : (_usersData$getTaskUse2 = usersData.getTaskUserDetails) === null || _usersData$getTaskUse2 === void 0 ? void 0 : _usersData$getTaskUse2.filter(function (user) {
        return user.role === "admin";
      });
      var adminIds = adminList ? adminList.map(function (user) {
        return user.userId;
      }) : [];
      //.map((user) => user.userId)
      setAdminUserIds(adminIds);

      // Merge arrays and remove duplicates
      var mergedIds = Array.from(new Set([].concat(_toConsumableArray(userActive), _toConsumableArray(adminIds))));

      // Update the state
      setUserActive(mergedIds);
    }
  }, [usersData]);
  var _useMutation5 = useMutation(EDIT_TASK_DETAILS_MUTATION),
    _useMutation6 = _slicedToArray(_useMutation5, 2),
    editTaskDetails = _useMutation6[0],
    editTaskDetailsLoading = _useMutation6[1].loading;
  var handleSubmit = React.useCallback( /*#__PURE__*/function () {
    var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(values, actions) {
      var response;
      return _regeneratorRuntime().wrap(function _callee9$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            if (!editTaskDetailsLoading) {
              _context9.next = 2;
              break;
            }
            return _context9.abrupt("return");
          case 2:
            _context9.prev = 2;
            _context9.next = 5;
            return editTaskDetails({
              variables: {
                taskName: values.taskName,
                projectId: projectId,
                organisationId: organisationId,
                taskId: taskId,
                status: values.status,
                taskTime: values.taskTime === null ? null : Number(values.taskTime) * 60 * 60,
                userId: !isCheck ? publicActive : userActive,
                dueDate: moment(manualStartDate),
                timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
                priority: values.priority,
                startDate: moment(taskStartSelectedDate),
                taskVisibility: !isCheck ? "public" : "private",
                taskDescription: values.taskDescription
              },
              refetchQueries: [{
                query: TASK_DETAILS_QUERY,
                variables: {
                  projectId: projectId,
                  organisationId: organisationId,
                  taskId: taskId,
                  startDate: Number(moment(startDate).format("x")),
                  endDate: Number(moment(endDate).format("x")),
                  timeZone: timezone,
                  limit: TASK_EMP_LIMIT,
                  offset: 0,
                  role: role,
                  userUrl: user === null || user === void 0 ? void 0 : user.uniqueUrl
                }
              }, {
                query: PROJECT_DETAILS_SUMMARY_QUERY,
                variables: {
                  projectId: projectId,
                  organisationId: organisationId,
                  teamId: teamId,
                  startDate: moment(startDate).format("YYYY-MM-DD"),
                  endDate: moment(endDate !== null && endDate !== void 0 ? endDate : startDate).format("YYYY-MM-DD"),
                  timezone: timezone,
                  role: role,
                  userUrl: user === null || user === void 0 ? void 0 : user.uniqueUrl
                }
              }, {
                query: PROJECT_TASKS_QUERY,
                variables: {
                  projectId: projectId,
                  organisationId: organisationId,
                  teamId: teamId,
                  startDate: startDate,
                  endDate: endDate,
                  taskStatus: null,
                  search: projectSearch,
                  limit: TASK_LIMIT,
                  offset: 0,
                  timezone: timezone,
                  role: role,
                  url: user === null || user === void 0 ? void 0 : user.uniqueUrl,
                  filterPriority: filterPriority
                }
              },
              // {
              //   query: GET_FILTER_TASK_TRACKER_DETAILS_QUERY,
              //   variables: {
              //     organisationId,
              //     teamId,
              //     userId: null,
              //     projectId: [projectId],
              //     taskId: null,
              //     limit: LIMIT,
              //     offset: 0,
              //     filterType: view == "listView" ? activeTab : taskStatus == "To Do" ? "upcomingTasks" : taskStatus == "In Progress" ? "inProgressTasks" : taskStatus == "completed" ? "completed" : taskStatus == "hold" ? "hold" : "onDue",
              //     timezone: timezone,
              //     role,
              //     search: projectSearch,
              //   },
              // },
              // {
              //   query: GET_FILTER_TASK_TRACKER_DETAILS_QUERY,
              //   variables: {
              //     organisationId,
              //     teamId,
              //     userId: null,
              //     projectId: [projectId],
              //     taskId: null,
              //     limit: LIMIT,
              //     offset: 0,
              //     filterType: view == "listView" ? activeTab : values.status == "To Do" ? "upcomingTasks" : values.status == "in-progress" ? "inProgressTasks" : values.status == "completed" ? "completed" : values.status == "hold" ? "hold" : "onDue",
              //     timezone: timezone,
              //     role,
              //     search: projectSearch,
              //   },
              // },
              {
                query: GET_FILTER_TASK_TRACKER_DETAILS_QUERY,
                variables: {
                  organisationId: organisationId,
                  teamId: teamId,
                  userId: null,
                  projectId: [projectId],
                  taskId: null,
                  limit: LIMIT,
                  offset: 0,
                  filterType: view == "listView" ? activeTab : taskStatus == "To Do" ? "upcomingTasks" : "upcomingTasks",
                  timezone: timezone,
                  role: role,
                  search: projectSearch
                }
              }, {
                query: GET_FILTER_TASK_TRACKER_DETAILS_QUERY,
                variables: {
                  organisationId: organisationId,
                  teamId: teamId,
                  userId: null,
                  projectId: [projectId],
                  taskId: null,
                  limit: LIMIT,
                  offset: 0,
                  filterType: "inProgressTasks",
                  timezone: timezone,
                  role: role,
                  search: projectSearch
                }
              }, {
                query: GET_FILTER_TASK_TRACKER_DETAILS_QUERY,
                variables: {
                  organisationId: organisationId,
                  teamId: teamId,
                  userId: null,
                  projectId: [projectId],
                  taskId: null,
                  limit: LIMIT,
                  offset: 0,
                  filterType: "completed",
                  timezone: timezone,
                  role: role,
                  search: projectSearch
                }
              }, {
                query: GET_FILTER_TASK_TRACKER_DETAILS_QUERY,
                variables: {
                  organisationId: organisationId,
                  teamId: teamId,
                  userId: null,
                  projectId: [projectId],
                  taskId: null,
                  limit: LIMIT,
                  offset: 0,
                  filterType: "hold",
                  timezone: timezone,
                  role: role,
                  search: projectSearch
                }
              }, {
                query: GET_FILTER_TASK_TRACKER_DETAILS_QUERY,
                variables: {
                  organisationId: organisationId,
                  teamId: teamId,
                  userId: null,
                  projectId: [projectId],
                  taskId: null,
                  limit: LIMIT,
                  offset: 0,
                  filterType: "onDue",
                  timezone: timezone,
                  role: role,
                  search: projectSearch
                }
              }, {
                query: TASK_COUNT_QUERY,
                variables: {
                  organisationId: organisationId,
                  teamId: teamId,
                  userId: role == "Member" ? user === null || user === void 0 ? void 0 : user.userId : null,
                  projectId: [projectId],
                  taskId: null,
                  role: role
                }
              }, {
                query: PROJECTS_LISTING_QUERY,
                variables: {
                  organisationId: organisationId,
                  teamId: teamId,
                  from: props !== null && props !== void 0 && props.from ? "desktop" : null,
                  role: role
                }
              }, {
                query: PROJECTS_LISTING_FOR_FILTER_QUERY,
                variables: {
                  organisationId: organisationId,
                  teamId: teamId,
                  from: props !== null && props !== void 0 && props.from ? "desktop" : null,
                  role: role
                }
              }],
              awaitRefetchQueries: true
            });
          case 5:
            response = _context9.sent;
            if (!(!response || !response.data)) {
              _context9.next = 10;
              break;
            }
            throw new Error("error");
          case 10:
            handleClose();
            toast.success("Task updated successfully!");
          case 12:
            _context9.next = 17;
            break;
          case 14:
            _context9.prev = 14;
            _context9.t0 = _context9["catch"](2);
            // editTaskDetails is capped by the work-details limiter in the
            // middleware, so a 429 arrives as an Apollo *network* error and its
            // reason is not in error.message. rateLimitMessage reads the limiter's
            // own text out of the 429 body, so the window stays right if the limit
            // is retuned. This catch was empty, so a rejected edit closed nothing
            // and said nothing - the modal just sat there looking unsaved.
            if (isRateLimited(_context9.t0)) {
              toast.error(rateLimitMessage(_context9.t0));
            } else {
              toast.error("Error occurred, Please try again later!");
            }
          case 17:
          case "end":
            return _context9.stop();
        }
      }, _callee9, null, [[2, 14]]);
    }));
    return function (_x2, _x3) {
      return _ref15.apply(this, arguments);
    };
  }(), [editTaskDetails, editTaskDetailsLoading, userActive, manualStartDate, taskStartSelectedDate, isCheck, publicActive]);
  var userWithSearch = function userWithSearch(userData) {
    if (!searchUser) {
      return userData;
    }
    return userData.filter(function (filterUsersData) {
      var _filterUsersData$disp, _filterUsersData$disp2, _filterUsersData$disp3, _filterUsersData$disp4;
      return filterUsersData === null || filterUsersData === void 0 ? void 0 : (_filterUsersData$disp = filterUsersData.displayName) === null || _filterUsersData$disp === void 0 ? void 0 : (_filterUsersData$disp2 = _filterUsersData$disp.toLowerCase) === null || _filterUsersData$disp2 === void 0 ? void 0 : (_filterUsersData$disp3 = _filterUsersData$disp2.call(_filterUsersData$disp)) === null || _filterUsersData$disp3 === void 0 ? void 0 : (_filterUsersData$disp4 = _filterUsersData$disp3.includes) === null || _filterUsersData$disp4 === void 0 ? void 0 : _filterUsersData$disp4.call(_filterUsersData$disp3, searchUser.toLowerCase());
    });
  };
  var handleChange = function handleChange(e) {
    setIsManualDatePickerOpen(!isManualDatePickerOpen);
    setManualStartDate(e);
  };
  var handleStartChange = function handleStartChange(e) {
    setTaskStartSelectedDate(e);
  };
  var time = Math.round(Number(estimatedTime) / 3600);
  var handleKey = function handleKey(data) {
    if (data == "setting") {
      setIsCheck(function (prev) {
        return prev === true ? false : true;
      });
      var t = userDetails === null || userDetails === void 0 ? void 0 : userDetails.map(function (user) {
        return user.userId;
      });
      setPublicActive(t);
    } else if (data == "private") {
      setIsPriorityCheck(function (prev) {
        return prev === true ? false : true;
      });
    }
  };

  //console.log({taskLabelStatus,taskStatus})
  return /*#__PURE__*/React.createElement(Modal, {
    show: true,
    onHide: handleClose,
    className: "project-task-edit-modals-root"
  }, /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      taskName: taskName !== null && taskName !== void 0 ? taskName : "",
      // status: "active",
      status: taskStatus !== null && taskStatus !== void 0 ? taskStatus : "active",
      // users: existUserIds ? existUserIds : [],
      projectId: projectId,
      organisationId: organisationId,
      taskTime: Number(time) == 0 ? "" : time,
      priority: priority,
      taskDescription: description
    }
    // validationSchema={MembersSchema}
    ,
    onSubmit: handleSubmit
  }, function (_ref16) {
    var _userWithSearch, _userWithSearch2;
    var setFieldValue = _ref16.setFieldValue,
      values = _ref16.values;
    return /*#__PURE__*/React.createElement(FormikForm, null, /*#__PURE__*/React.createElement(Modal.Header, {
      closeButton: true
    }, /*#__PURE__*/React.createElement(Modal.Title, {
      className: "project-task-edit-modals-root-title"
    }, "Edit Task Details")), /*#__PURE__*/React.createElement(Modal.Body, {
      className: "project-details-task-card-edit-task-body"
    }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12
    }, /*#__PURE__*/React.createElement(Field, {
      name: "taskName"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
        className: "project-details-edit-task-label-name"
      }, "Task Name ", /*#__PURE__*/React.createElement("sup", {
        className: "project-task-modals-edit-task-label-name-star"
      }, "*")), meta.error && meta.touched ? /*#__PURE__*/React.createElement(Form.Label, {
        className: "error"
      }, meta.error) : null, /*#__PURE__*/React.createElement(Form.Control, _extends({
        type: "text",
        placeholder: "e.g. Research and Analysis",
        className: "project-details-edit-task-label-input"
      }, field)));
    }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12
    }, /*#__PURE__*/React.createElement(Field, {
      name: "taskDescription"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
        className: "project-details-edit-task-label-name"
      }, "Task Description"), meta.error && meta.touched ? /*#__PURE__*/React.createElement(Form.Label, {
        className: "error"
      }, meta.error) : null, /*#__PURE__*/React.createElement("textarea", _extends({
        className: "text-area"
      }, field, fieldProps)));
    }))), taskLabelStatus != "Over Worked" && taskProgress != "ongoing" ? /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12
    }, /*#__PURE__*/React.createElement(Field, {
      name: "status"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
        className: "project-details-edit-task-label-name"
      }, " Task Status"), meta.error && meta.touched ? /*#__PURE__*/React.createElement(Form.Label, {
        className: "error"
      }, meta.error) : null, /*#__PURE__*/React.createElement(Form.Control, _extends({
        as: "select",
        placeholder: "Select a status",
        className: "project-details-edit-task-label-input"
      }, field), (!allowEmployeesToMarkTheirTasksAsCompleted && role == "Member" ? taskStatusWithOutCompletedList : taskLabelStatus == "In progress" || taskLabelStatus == "In Progress" ? taskStatusProgressList : taskLabelStatus == "Upcoming" ? taskStatusToDoList : taskLabelStatus == "On due" ? taskStatusCompletedList : taskStatusCompletedList).map(function (taskStatuss) {
        return /*#__PURE__*/React.createElement("option", {
          key: taskStatuss.value,
          value: taskStatuss.value
        }, taskStatuss.label);
      })));
    }))) : null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement("div", {
      className: "task-date-whole-div-data"
    }, /*#__PURE__*/React.createElement(Field, {
      name: "taskTime"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
        className: "manage-teams-edit-task-label-name"
      }, "Estimated Time (Optional)"), meta.error && meta.touched ? /*#__PURE__*/React.createElement(Form.Label, {
        className: "error"
      }, meta.error) : null, /*#__PURE__*/React.createElement("div", {
        className: "my-tasks-add-new-project-option-div"
      }, /*#__PURE__*/React.createElement(Form.Control, _extends({
        type: "number",
        min: "0",
        placeholder: "e.g. 10",
        className: "task-add-placeholder"
      }, field)), /*#__PURE__*/React.createElement("span", {
        className: "task-add-new-project-hours-text"
      }, "Hours")));
    }), /*#__PURE__*/React.createElement("div", {
      className: "task-due-date"
    }, /*#__PURE__*/React.createElement(Form.Label, {
      className: "manage-teams-edit-task-label-name"
    }, "Due Date (Optional)"), /*#__PURE__*/React.createElement(DatePicker, {
      id: "task-due-date",
      dateFormat: "dd/MM/yyyy",
      selected: manualStartDate,
      onChange: handleChange,
      isClearable: true,
      className: "task-details-due-date-date-picker",
      placeholderText: "No due date selected",
      autoComplete: "off"
      // open={isManualDatePickerOpen}
      // inline
    })))), /*#__PURE__*/React.createElement("div", {
      className: "task-priority-edit-whole-div-data"
    }, /*#__PURE__*/React.createElement("div", {
      className: "task-edit-add-modal-priority-div"
    }, /*#__PURE__*/React.createElement(Field, {
      name: "priority"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(FormGroup, {
        className: "task-section-edit-task-label-input"
      }, /*#__PURE__*/React.createElement(Form.Label, {
        className: "manage-teams-edit-task-label-name"
      }, "Priority"), meta.error && meta.touched ? /*#__PURE__*/React.createElement(Form.Label, {
        className: "error"
      }, meta.error) : null, /*#__PURE__*/React.createElement(Form.Control, _extends({
        as: "select",
        defaultValue: "",
        required: true
      }, field), /*#__PURE__*/React.createElement("option", {
        value: null
      }, "None"), taskPriority.map(function (task) {
        return /*#__PURE__*/React.createElement("option", {
          value: task.value
        }, task.label);
      })));
    }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12
    }, /*#__PURE__*/React.createElement(Accordion, {
      className: "task-modal-accordion-whole",
      defaultActiveKey: !isCheck ? null : "0"
    }, /*#__PURE__*/React.createElement("div", {
      onClick: function onClick() {
        return handleKey("setting");
      }
    }, /*#__PURE__*/React.createElement(Accordion.Toggle, {
      as: Button,
      variant: "link",
      eventKey: "0",
      className: "task-modal-content-header-team-name-acc"
    }, /*#__PURE__*/React.createElement("span", {
      className: "project-detail-tasks-modal-content-header-setting"
    }, /*#__PURE__*/React.createElement(HiLockClosed, {
      className: "project-tasks-modal-content-header-setting-icon"
    }), " Assign this task to all members in the project"), /*#__PURE__*/React.createElement("div", {
      className: "tasks-rule-uparrow toggle-switch"
    }, /*#__PURE__*/React.createElement("label", {
      "for": "chkTest"
    }, /*#__PURE__*/React.createElement("span", {
      className: classNames("toggle-track", {
        "toggle-track-nav-right-div": !isCheck
      })
    }))))), /*#__PURE__*/React.createElement(Accordion.Collapse, {
      eventKey: "0"
    }, /*#__PURE__*/React.createElement("div", {
      className: "tasks-modal-content-person-name"
    }, /*#__PURE__*/React.createElement("div", {
      className: "tasks-modal-content-person-name-header"
    }, /*#__PURE__*/React.createElement("div", {
      className: "task-edit-modal-content-person-name-header-section"
    }, /*#__PURE__*/React.createElement("div", {
      className: "tasks-modal-content-person-name-header-section-label"
    }), /*#__PURE__*/React.createElement("div", {
      className: "my-projects-modal-content-person-name-header-section-content"
    }, /*#__PURE__*/React.createElement("div", {
      className: "my-projects-modal-searchbox-wrapper"
    }, /*#__PURE__*/React.createElement(SearchBar, {
      value: searchUser,
      onChange: setSearchUser,
      placeholder: "Search employee name"
    })), (userActive === null || userActive === void 0 ? void 0 : userActive.length) == (userIds === null || userIds === void 0 ? void 0 : userIds.length) ? /*#__PURE__*/React.createElement("p", {
      className: "projects-tasks-modal-content-person-name-header-button",
      onClick: function onClick() {
        if (role == "Member") {
          setUserActive(adminUserIds);
        } else {
          setUserActive([]);
        }
        setUserSelected(false);
      }
    }, "Unselect All") : /*#__PURE__*/React.createElement("p", {
      //variant="outline-secondary"
      className: "projects-tasks-modal-content-person-name-header-button",
      onClick: function onClick() {
        setUserActive(userIds);
        setUserSelected(true);
      }
    }, "Select All")))), /*#__PURE__*/React.createElement("div", {
      className: "project-details-tasks-modal-content-person-name-listing"
    }, usersLoading ? /*#__PURE__*/React.createElement(Loader, null) : userDetails && (_userWithSearch = userWithSearch(userDetails)) !== null && _userWithSearch !== void 0 && _userWithSearch.length ? (_userWithSearch2 = userWithSearch(userDetails)) === null || _userWithSearch2 === void 0 ? void 0 : _userWithSearch2.map(function (user, index) {
      var teamFirstName = user.displayName.match(/\b(\w)/g);
      var teamNameIcon = teamFirstName.join("");
      return /*#__PURE__*/React.createElement("div", {
        className: "my-projects-modal-content-person-name-listing-card-content",
        key: index
      }, /*#__PURE__*/React.createElement("div", {
        className: "tasks-modal-content-person-name-listing-card-content-person",
        onClick: function onClick() {
          if (role != "Member" || role == "Member" && !adminUserIds.includes(user.userId)) {
            setUserSelected(true);
            setUserActive(function (prev) {
              return prev.includes(user.userId) ? prev.filter(function (a) {
                return a !== user.userId;
              }) : [].concat(_toConsumableArray(prev), [user.userId]);
            });
          }
        }
      }, user.profileUrl ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "task-card-avatar-profile"
      }, /*#__PURE__*/React.createElement("img", {
        alt: "Workfolio",
        src: user === null || user === void 0 ? void 0 : user.profileUrl,
        className: "task-card-avatar-profile-img"
      }))) : /*#__PURE__*/React.createElement("div", {
        className: "tasks-modal-content-person-name-listing-card-content-person-icon"
      }, user.displayName.charAt(0).toUpperCase()), /*#__PURE__*/React.createElement("div", {
        className: "my-projects-modal-content-header-team-name"
      }, user.displayName)), /*#__PURE__*/React.createElement("div", {
        className: "my-projects-modal-content-team-name"
      }, /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        id: user.userId,
        name: "myRadioGroup",
        className: "create-project-team-selection-control-checkbox",
        checked: userActive.includes(user.userId),
        disabled: role == "Member" && adminUserIds.includes(user.userId),
        onChange: function onChange() {
          setUserSelected(true);
          setUserActive(function (prev) {
            return prev.includes(user.userId) ? prev.filter(function (a) {
              return a !== user.userId;
            }) : [].concat(_toConsumableArray(prev), [user.userId]);
          });
        }
      })));
    }) : /*#__PURE__*/React.createElement("div", {
      className: "text-muted text-center"
    }, "No member found for \"".concat(searchUser, "\""))))))))), /*#__PURE__*/React.createElement(Modal.Footer, {
      className: "project-details-task-card-save-button-div"
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "primary",
      className: "project-details-task-card-save-button",
      type: "submit",
      disabled: editTaskDetailsLoading
    }, editTaskDetailsLoading ? "Loading" : "Save Changes")));
  }));
};
export var DeleteTaskModal = function DeleteTaskModal(props) {
  var showTaskDeleteModal = props.showTaskDeleteModal,
    handleTaskDeleteClose = props.handleTaskDeleteClose,
    organisationId = props.organisationId,
    projectId = props.projectId,
    userId = props.userId,
    history = props.history,
    teamId = props.teamId,
    startDate = props.startDate,
    endDate = props.endDate,
    TASK_LIMIT = props.TASK_LIMIT,
    timezone = props.timezone,
    activeTab = props.activeTab,
    user = props.user,
    getEmployeeDetails = props.getEmployeeDetails,
    projectSearch = props.projectSearch,
    filterPriority = props.filterPriority,
    view = props.view;
  if (showTaskDeleteModal === false) {
    return null;
  }
  var taskId = showTaskDeleteModal.taskId,
    taskProgress = showTaskDeleteModal.taskProgress,
    taskProgressUser = showTaskDeleteModal.taskProgressUser,
    type = showTaskDeleteModal.type,
    taskStatus = showTaskDeleteModal.taskStatus;
  var _React$useState189 = React.useState(false),
    _React$useState190 = _slicedToArray(_React$useState189, 2),
    deleteStatus = _React$useState190[0],
    setDeleteStatus = _React$useState190[1];
  var _useMutation7 = useMutation(DELETE_TASK_MUTATION),
    _useMutation8 = _slicedToArray(_useMutation7, 2),
    deleteTask = _useMutation8[0],
    deleteTaskLoading = _useMutation8[1].loading;
  var _React$useContext5 = React.useContext(FilterContext),
    role = _React$useContext5.role;
  var handleDeleteProject = React.useCallback(function () {
    return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
      var response;
      return _regeneratorRuntime().wrap(function _callee10$(_context10) {
        while (1) switch (_context10.prev = _context10.next) {
          case 0:
            if (!deleteTaskLoading) {
              _context10.next = 2;
              break;
            }
            return _context10.abrupt("return");
          case 2:
            _context10.next = 4;
            return deleteTask({
              variables: {
                taskId: taskId,
                organisationId: organisationId,
                projectId: projectId,
                userId: userId
              },
              awaitRefetchQueries: true,
              refetchQueries: [{
                query: PROJECT_TASKS_QUERY,
                variables: {
                  projectId: projectId,
                  organisationId: organisationId,
                  teamId: teamId,
                  startDate: startDate,
                  endDate: endDate,
                  taskStatus: null,
                  search: projectSearch,
                  limit: TASK_LIMIT,
                  offset: 0,
                  timezone: timezone,
                  role: role,
                  url: user === null || user === void 0 ? void 0 : user.uniqueUrl,
                  filterPriority: filterPriority
                }
              }, {
                query: PROJECT_DETAILS_SUMMARY_QUERY,
                variables: {
                  projectId: projectId,
                  organisationId: organisationId,
                  teamId: teamId,
                  startDate: moment(startDate).format("YYYY-MM-DD"),
                  endDate: moment(endDate !== null && endDate !== void 0 ? endDate : startDate).format("YYYY-MM-DD"),
                  timezone: timezone,
                  role: role,
                  userUrl: user === null || user === void 0 ? void 0 : user.uniqueUrl
                }
              }, {
                query: TASK_COUNT_QUERY,
                variables: {
                  organisationId: organisationId,
                  teamId: teamId,
                  userId: role == "Member" ? user === null || user === void 0 ? void 0 : user.userId : null,
                  projectId: [projectId],
                  taskId: null,
                  role: role
                }
              }, {
                query: PROJECTS_LISTING_QUERY,
                variables: {
                  organisationId: organisationId,
                  teamId: teamId,
                  from: props !== null && props !== void 0 && props.from ? "desktop" : null,
                  role: role
                }
              }, {
                query: PROJECTS_LISTING_FOR_FILTER_QUERY,
                variables: {
                  organisationId: organisationId,
                  teamId: teamId,
                  from: props !== null && props !== void 0 && props.from ? "desktop" : null,
                  role: role
                }
              }, {
                query: PROJECT_DETAILS_SUMMARY_QUERY,
                variables: {
                  projectId: projectId,
                  organisationId: organisationId,
                  teamId: teamId,
                  startDate: moment(startDate).format("YYYY-MM-DD"),
                  endDate: moment(endDate).format("YYYY-MM-DD"),
                  timezone: timezone,
                  role: role,
                  userUrl: user === null || user === void 0 ? void 0 : user.uniqueUrl
                }
              }, {
                query: GET_FILTER_TASK_TRACKER_DETAILS_QUERY,
                variables: {
                  organisationId: organisationId,
                  teamId: teamId,
                  userId: null,
                  projectId: [projectId],
                  taskId: null,
                  limit: LIMIT,
                  offset: 0,
                  //filterType: activeTab,
                  filterType: view == "listView" ? activeTab : taskStatus == "To Do" ? "upcomingTasks" : taskStatus == "In Progress" ? "inProgressTasks" : taskStatus == "completed" ? "completed" : taskStatus == "hold" ? "hold" : "onDue",
                  timezone: timezone,
                  role: role,
                  search: projectSearch
                }
              }]
            });
          case 4:
            response = _context10.sent;
            if (!response || !response.data || !response.data.deleteTask) {
              toast.success("Error, Try again");
            } else {
              handleTaskDeleteClose();
              toast.success("Task deleted successfully!");
              setDeleteStatus(true);
              getEmployeeDetails();
            }
          case 6:
          case "end":
            return _context10.stop();
        }
      }, _callee10);
    }));
  }, [deleteTask, deleteTaskLoading]);
  return /*#__PURE__*/React.createElement(Modal, {
    show: showTaskDeleteModal,
    onHide: handleTaskDeleteClose
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    className: "project-details-task-card-delete-header",
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "project-details-task-card-delete-title"
  }, "Delete Task")), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "project-details-task-card-delete-body"
  }, taskProgress == "ongoing" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "project-details-task-card-delete-body-name"
  }, taskProgressUser, " "), /*#__PURE__*/React.createElement("span", {
    className: "project-details-task-card-delete-body-text"
  }, "is currently working on this task, so you can't delete this task until he/she clocks out from this task.")) : "Do you want to delete this task?"), /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    className: "project-details-task-card-delete-cancel-button",
    onClick: handleTaskDeleteClose
  }, "Cancel"), taskProgress != "ongoing" ? /*#__PURE__*/React.createElement(Button, {
    variant: "danger",
    className: "project-details-task-card-delete-button",
    onClick: handleDeleteProject(),
    disabled: deleteTaskLoading
  }, deleteTaskLoading ? "Loading" : deleteStatus === true ? "Deleted" : "Yes, Delete") : null));
};
export var ImportTaskModal = function ImportTaskModal(props) {
  var importTaskShow = props.importTaskShow,
    setImportButton = props.setImportButton,
    handleImportTaskClose = props.handleImportTaskClose,
    organisationId = props.organisationId,
    teamId = props.teamId,
    startDate = props.startDate,
    endDate = props.endDate,
    timeZone = props.timeZone,
    pageType = props.pageType,
    projectId = props.projectId,
    projectSearch = props.projectSearch,
    filterPriority = props.filterPriority;
  if (importTaskShow == null) {
    return null;
  }
  var _React$useContext6 = React.useContext(FilterContext),
    organisationSettings = _React$useContext6.organisationSettings,
    role = _React$useContext6.role;
  var _React$useState191 = React.useState([]),
    _React$useState192 = _slicedToArray(_React$useState191, 2),
    movies = _React$useState192[0],
    setMovies = _React$useState192[1];
  var _React$useState193 = React.useState([]),
    _React$useState194 = _slicedToArray(_React$useState193, 2),
    taskName = _React$useState194[0],
    setTaskName = _React$useState194[1];
  var _React$useState195 = React.useState(""),
    _React$useState196 = _slicedToArray(_React$useState195, 2),
    fileName = _React$useState196[0],
    setfileName = _React$useState196[1];
  var _React$useState197 = React.useState(""),
    _React$useState198 = _slicedToArray(_React$useState197, 2),
    errorMsg = _React$useState198[0],
    setErrorMsg = _React$useState198[1];
  var _React$useContext7 = React.useContext(UserContext),
    user = _React$useContext7.user;
  React.useEffect(function () {
    if (movies.length) {
      var taskArray = [];
      movies.map(function (item) {
        if (item !== null && item !== void 0 && item.TaskName) {
          return taskArray.push(item === null || item === void 0 ? void 0 : item.TaskName);
        }
        return;
      });
      if (taskArray.length) {
        setErrorMsg("");
      } else {
        setErrorMsg("all");
      }
      setTaskName(taskArray);
    }
  }, [movies]);
  var _useMutation9 = useMutation(ADD_TASK_DETAILS_MUTATION),
    _useMutation10 = _slicedToArray(_useMutation9, 2),
    addTaskDetails = _useMutation10[0],
    addTaskDetailsLoading = _useMutation10[1].loading;
  var handleSubmit = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
    var variables, _response$data2, response, serverMessage;
    return _regeneratorRuntime().wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          if (!(taskName.length == 0)) {
            _context11.next = 3;
            break;
          }
          if (fileName == "") {
            setErrorMsg("no file name");
          } else {
            setErrorMsg("all");
          }
          return _context11.abrupt("return");
        case 3:
          variables = {
            taskName: taskName,
            projectId: importTaskShow,
            organisationId: organisationId,
            taskTime: null,
            userId: [user.userId],
            dueDate: null,
            timeZone: timeZone,
            priority: null,
            startDate: null
          };
          _context11.prev = 4;
          _context11.next = 7;
          return addTaskDetails({
            variables: variables,
            awaitRefetchQueries: true,
            refetchQueries: [{
              query: PROJECT_LISTING_QUERY,
              variables: {
                organisationId: organisationId,
                url: user === null || user === void 0 ? void 0 : user.uniqueUrl,
                role: role
              }
            }, {
              query: PROJECTS_LISTING_QUERY,
              variables: {
                organisationId: organisationId,
                teamId: teamId,
                from: props !== null && props !== void 0 && props.from ? "desktop" : null,
                role: role
              }
            }, {
              query: PROJECTS_LISTING_FOR_FILTER_QUERY,
              variables: {
                organisationId: organisationId,
                teamId: teamId,
                from: props !== null && props !== void 0 && props.from ? "desktop" : null,
                role: role
              }
            }, {
              query: PROJECT_TASKS_QUERY,
              variables: {
                projectId: projectId,
                organisationId: organisationId,
                teamId: teamId,
                startDate: startDate,
                endDate: endDate,
                taskStatus: null,
                search: projectSearch,
                limit: 25,
                offset: 0,
                timezone: timeZone,
                role: role,
                url: user === null || user === void 0 ? void 0 : user.uniqueUrl,
                filterPriority: filterPriority
              }
            }, {
              query: PROJECT_DETAILS_SUMMARY_QUERY,
              variables: {
                projectId: projectId,
                organisationId: organisationId,
                teamId: teamId,
                startDate: moment(startDate).format("YYYY-MM-DD"),
                endDate: moment(endDate !== null && endDate !== void 0 ? endDate : startDate).format("YYYY-MM-DD"),
                timezone: timeZone,
                role: role,
                userUrl: user === null || user === void 0 ? void 0 : user.uniqueUrl
              }
            }, {
              query: TASK_COUNT_QUERY,
              variables: {
                organisationId: organisationId,
                teamId: teamId,
                userId: role == "Member" ? user === null || user === void 0 ? void 0 : user.userId : null,
                projectId: [projectId],
                taskId: null,
                role: role
              }
            }, {
              query: GET_FILTER_TASK_TRACKER_DETAILS_QUERY,
              variables: {
                organisationId: organisationId,
                teamId: teamId,
                userId: role == "Member" ? user === null || user === void 0 ? void 0 : user.userId : null,
                projectId: [projectId],
                taskId: null,
                limit: 25,
                offset: 0,
                filterType: "upcomingTasks",
                timezone: timeZone,
                role: role,
                search: projectSearch
              }
            }]
          });
        case 7:
          response = _context11.sent;
          if (response && response !== null && response !== void 0 && (_response$data2 = response.data) !== null && _response$data2 !== void 0 && _response$data2.addTaskDetails.length) {
            toast.success("Task imported successfully!");
            handleImportTaskClose();
          } else {
            toast.error("Error ");
          }
          _context11.next = 15;
          break;
        case 11:
          _context11.prev = 11;
          _context11.t0 = _context11["catch"](4);
          // The import runs through checkTaskCreationCount on the server (10 tasks
          // per minute, per user). That is not a duplicate-name problem, so showing
          // "Task already exists" for it sends people off to rename a task that was
          // never the issue. Apostrophes are normalised because the server message
          // uses a curly one.
          serverMessage = (_context11.t0.message || "").replace(/\u2019/g, "'");
          if (serverMessage.includes("requests per minute")) {
            setErrorMsg("You’ve reached the limit of 10 requests per minute. Please try again in a minute.");
          } else {
            setErrorMsg("Task already exists");
          }
        case 15:
        case "end":
          return _context11.stop();
      }
    }, _callee11, null, [[4, 11]]);
  })), [addTaskDetails, addTaskDetailsLoading, taskName]);
  var handleImport = function handleImport(event) {
    var files = event.target.files;
    if (files.length) {
      var file = files[0];
      setfileName(file.name);
      var reader = new FileReader();
      reader.onload = function (event) {
        var wb = read(event.target.result);
        var sheets = wb.SheetNames;
        if (sheets.length) {
          var rows = utils.sheet_to_json(wb.Sheets[sheets[0]]);
          setMovies(rows);
        }
      };
      reader.readAsArrayBuffer(file);
    }
  };
  var getExportData = /*#__PURE__*/function () {
    var _ref19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
      var wb, ws, buf, fileName;
      return _regeneratorRuntime().wrap(function _callee12$(_context12) {
        while (1) switch (_context12.prev = _context12.next) {
          case 0:
            wb = new Excel.Workbook();
            ws = wb.addWorksheet();
            ws.columns = [{
              header: "TaskName",
              key: "taskName",
              width: 30,
              style: {
                alignment: {
                  vertical: "middle",
                  horizontal: "left"
                }
              }
            }];
            ws.addRow({
              taskName: "Research and Analytics"
            });
            ws.addRow({
              taskName: "UI Design"
            });
            ws.addRow({
              taskName: "UI Development"
            });
            ws.addRow({
              taskName: "Backend Development"
            });
            ws.addRow({
              taskName: "Integration"
            });
            ws.addRow({
              taskName: "Testing"
            });
            ws.getCell("A1").font = {
              bold: true
            };
            _context12.next = 12;
            return wb.xlsx.writeBuffer();
          case 12:
            buf = _context12.sent;
            fileName = "workfolio-task-template.xlsx";
            saveAs(new Blob([buf]), fileName);
          case 15:
          case "end":
            return _context12.stop();
        }
      }, _callee12);
    }));
    return function getExportData() {
      return _ref19.apply(this, arguments);
    };
  }();
  //console.log({ taskName, movies });
  return /*#__PURE__*/React.createElement(Modal, {
    show: true,
    onHide: handleImportTaskClose,
    centered: true,
    className: "project-task-modals-root"
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "project-task-modals-root-title"
  }, "Task Import from File")), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "import-tsk-modal-alert-text"
  }, /*#__PURE__*/React.createElement("p", {
    className: "tasks-import-modal-p"
  }, "How to import task to a project?"), /*#__PURE__*/React.createElement("p", {
    className: "tasks-import-modal-p-export"
  }, "Download the excel template from", /*#__PURE__*/React.createElement("span", {
    className: "task-import-download-icon-btn",
    onClick: function onClick() {
      getExportData();
    }
  }, " ", "here"), " ", "and edit the template.")), /*#__PURE__*/React.createElement("p", {
    className: "tasks-import-modal-p-label"
  }, "Import the edited template here"), /*#__PURE__*/React.createElement("div", {
    className: "tasks-modal-content-person-name"
  }, /*#__PURE__*/React.createElement("div", {
    className: "custom-file project-details-import-task-modal"
  }, /*#__PURE__*/React.createElement("input", {
    type: "file",
    name: "file",
    className: "custom-file-input",
    id: "inputGroupFile",
    required: true,
    onChange: function onChange(e) {
      return handleImport(e);
    },
    accept: ".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
  }), /*#__PURE__*/React.createElement("label", {
    className: "custom-file-label",
    htmlFor: "inputGroupFile"
  }, fileName == "" ? "Choose file (.csv or .xlsx)" : fileName)), errorMsg == "all" ? /*#__PURE__*/React.createElement("div", {
    className: "import-tasks-modal-error"
  }, "Pls check the uploaded file, it's not matching with the given template") : errorMsg == "Task already exists" ? /*#__PURE__*/React.createElement("div", {
    className: "import-tasks-modal-error"
  }, " Task already exists ") : errorMsg == "no file name" ? /*#__PURE__*/React.createElement("div", {
    className: "import-tasks-modal-error"
  }, " Please select a file ") : errorMsg !== "" ?
  /*#__PURE__*/
  // Server messages are shown as they arrive, so a new one does not
  // need a sentinel of its own added to this chain.
  React.createElement("div", {
    className: "import-tasks-modal-error"
  }, " ", errorMsg, " ") : null, /*#__PURE__*/React.createElement("div", {
    className: "project-task-list-modal-save-button"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    className: "project-task-modals-save-button",
    onClick: function onClick() {
      handleSubmit();
    },
    disabled: addTaskDetailsLoading,
    type: "submit"
  }, addTaskDetailsLoading ? "Loading..." : "Import Task"))))));
};
export var UndoCompleteConfirmation = function UndoCompleteConfirmation(props) {
  var showUndocompletedModal = props.showUndocompletedModal,
    handleUndoCompletedClose = props.handleUndoCompletedClose,
    undoCompletedTask = props.undoCompletedTask,
    setUndoCompletedTask = props.setUndoCompletedTask,
    undoCompletedTaskList = props.undoCompletedTaskList,
    setUndoCompletedTaskList = props.setUndoCompletedTaskList,
    organisationId = props.organisationId,
    startDate = props.startDate,
    endDate = props.endDate,
    timezone = props.timezone,
    user = props.user,
    projectSearch = props.projectSearch,
    filterPriority = props.filterPriority,
    activeTab = props.activeTab,
    view = props.view;
  if (showUndocompletedModal === null) {
    return null;
  }
  var projectId = showUndocompletedModal.projectId,
    taskId = showUndocompletedModal.taskId,
    taskStatus = showUndocompletedModal.taskStatus;
  var _React$useContext8 = React.useContext(FilterContext),
    teamId = _React$useContext8.teamId,
    role = _React$useContext8.role;
  var _useMutation11 = useMutation(UPDATE_TASK_STATUS_MUTATION),
    _useMutation12 = _slicedToArray(_useMutation11, 2),
    updateTaskStatus = _useMutation12[0],
    updating = _useMutation12[1].loading;
  function handleUpdateTaskStatus(_x4, _x5) {
    return _handleUpdateTaskStatus.apply(this, arguments);
  }
  function _handleUpdateTaskStatus() {
    _handleUpdateTaskStatus = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13(taskId, projectId) {
      var _response$data3, response;
      return _regeneratorRuntime().wrap(function _callee13$(_context13) {
        while (1) switch (_context13.prev = _context13.next) {
          case 0:
            if (!updating) {
              _context13.next = 2;
              break;
            }
            return _context13.abrupt("return");
          case 2:
            _context13.prev = 2;
            _context13.next = 5;
            return updateTaskStatus({
              variables: {
                projectId: projectId,
                taskId: taskId,
                taskStatus: "",
                organisationId: organisationId
              },
              awaitRefetchQueries: true,
              refetchQueries: [{
                query: PROJECT_TASKS_QUERY,
                variables: {
                  projectId: projectId,
                  organisationId: organisationId,
                  teamId: teamId,
                  startDate: startDate,
                  endDate: endDate,
                  taskStatus: null,
                  search: projectSearch,
                  limit: TASK_LIMIT,
                  offset: 0,
                  timezone: timezone,
                  role: role,
                  url: user === null || user === void 0 ? void 0 : user.uniqueUrl,
                  filterPriority: filterPriority
                }
              }, {
                query: GET_FILTER_TASK_TRACKER_DETAILS_QUERY,
                variables: {
                  organisationId: organisationId,
                  teamId: teamId,
                  userId: null,
                  projectId: [projectId],
                  taskId: null,
                  limit: LIMIT,
                  offset: 0,
                  filterType: "upcomingTasks",
                  timezone: timezone,
                  role: role,
                  search: projectSearch
                }
              }, {
                query: GET_FILTER_TASK_TRACKER_DETAILS_QUERY,
                variables: {
                  organisationId: organisationId,
                  teamId: teamId,
                  userId: null,
                  projectId: [projectId],
                  taskId: null,
                  limit: LIMIT,
                  offset: 0,
                  filterType: "inProgressTasks",
                  timezone: timezone,
                  role: role,
                  search: projectSearch
                }
              }, {
                query: GET_FILTER_TASK_TRACKER_DETAILS_QUERY,
                variables: {
                  organisationId: organisationId,
                  teamId: teamId,
                  userId: null,
                  projectId: [projectId],
                  taskId: null,
                  limit: LIMIT,
                  offset: 0,
                  filterType: "completed",
                  timezone: timezone,
                  role: role,
                  search: projectSearch
                }
              }, {
                query: GET_FILTER_TASK_TRACKER_DETAILS_QUERY,
                variables: {
                  organisationId: organisationId,
                  teamId: teamId,
                  userId: null,
                  projectId: [projectId],
                  taskId: null,
                  limit: LIMIT,
                  offset: 0,
                  filterType: "onDue",
                  timezone: timezone,
                  role: role,
                  search: projectSearch
                }
              }, {
                query: GET_FILTER_TASK_TRACKER_DETAILS_QUERY,
                variables: {
                  organisationId: organisationId,
                  teamId: teamId,
                  userId: null,
                  projectId: [projectId],
                  taskId: null,
                  limit: LIMIT,
                  offset: 0,
                  filterType: "hold",
                  timezone: timezone,
                  role: role,
                  search: projectSearch
                }
              }, {
                query: TASK_COUNT_QUERY,
                variables: {
                  organisationId: organisationId,
                  teamId: teamId,
                  userId: role == "Member" ? user === null || user === void 0 ? void 0 : user.userId : null,
                  projectId: [projectId],
                  taskId: null,
                  role: role
                }
              }, {
                query: PROJECT_DETAILS_SUMMARY_QUERY,
                variables: {
                  projectId: projectId,
                  organisationId: organisationId,
                  teamId: teamId,
                  startDate: moment(startDate).format("YYYY-MM-DD"),
                  endDate: moment(endDate !== null && endDate !== void 0 ? endDate : startDate).format("YYYY-MM-DD"),
                  timezone: timezone,
                  role: role,
                  userUrl: user === null || user === void 0 ? void 0 : user.uniqueUrl
                }
              }]
            });
          case 5:
            response = _context13.sent;
            setUndoCompletedTask(null);
            if (response && (response === null || response === void 0 ? void 0 : (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.updateTaskStatus) == true) {
              setUndoCompletedTaskList(function (prev) {
                if (prev == null) {
                  return [taskId];
                }
                return [].concat(_toConsumableArray(prev), [taskId]);
              });
              toast.success("Task status updated successfully!");
              handleUndoCompletedClose();
            } else {
              toast.error("Error Occured, try again");
            }
            _context13.next = 13;
            break;
          case 10:
            _context13.prev = 10;
            _context13.t0 = _context13["catch"](2);
            toast.error("Error Occured, try again");
          case 13:
          case "end":
            return _context13.stop();
        }
      }, _callee13, null, [[2, 10]]);
    }));
    return _handleUpdateTaskStatus.apply(this, arguments);
  }
  return /*#__PURE__*/React.createElement(Modal, {
    show: showUndocompletedModal,
    onHide: handleUndoCompletedClose
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    className: "project-details-task-card-delete-header",
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "project-details-task-card-delete-title"
  }, "Undo Completion")), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "project-details-task-card-delete-body"
  }, "Do you want to remove the completion status from this task?", " "), /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    className: "project-details-task-card-delete-cancel-button",
    onClick: handleUndoCompletedClose
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    variant: "success",
    className: "project-details-task-card-delete-button",
    onClick: function onClick() {
      return handleUpdateTaskStatus(taskId, projectId);
    }
  }, updating ? "Loading..." : "Undo completion")));
};
export var CompletedConfirmationProject = function CompletedConfirmationProject(props) {
  var showcompletedModal = props.showcompletedModal,
    handleCompletedClose = props.handleCompletedClose,
    completedTask = props.completedTask,
    setCompletedTask = props.setCompletedTask,
    completedTaskList = props.completedTaskList,
    setCompletedTaskList = props.setCompletedTaskList,
    organisationId = props.organisationId,
    startDate = props.startDate,
    endDate = props.endDate,
    timezone = props.timezone,
    role = props.role,
    user = props.user,
    projectSearch = props.projectSearch,
    filterPriority = props.filterPriority,
    activeTab = props.activeTab,
    view = props.view;
  if (showcompletedModal === null) {
    return null;
  }
  var projectId = showcompletedModal.projectId,
    taskId = showcompletedModal.taskId,
    taskProgress = showcompletedModal.taskProgress,
    taskProgressUser = showcompletedModal.taskProgressUser,
    taskStatus = showcompletedModal.taskStatus;
  var _React$useContext9 = React.useContext(FilterContext),
    teamId = _React$useContext9.teamId;
  var _useMutation13 = useMutation(UPDATE_TASK_STATUS_MUTATION),
    _useMutation14 = _slicedToArray(_useMutation13, 2),
    updateTaskStatus = _useMutation14[0],
    updating = _useMutation14[1].loading;
  function handleUpdateTaskStatus(_x6, _x7) {
    return _handleUpdateTaskStatus2.apply(this, arguments);
  }
  function _handleUpdateTaskStatus2() {
    _handleUpdateTaskStatus2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14(taskId, projectId) {
      var _response$data4, response;
      return _regeneratorRuntime().wrap(function _callee14$(_context14) {
        while (1) switch (_context14.prev = _context14.next) {
          case 0:
            if (!updating) {
              _context14.next = 2;
              break;
            }
            return _context14.abrupt("return");
          case 2:
            _context14.prev = 2;
            _context14.next = 5;
            return updateTaskStatus({
              variables: {
                projectId: projectId,
                taskId: taskId,
                taskStatus: "completed",
                organisationId: organisationId
              },
              awaitRefetchQueries: true,
              refetchQueries: [{
                query: PROJECT_TASKS_QUERY,
                variables: {
                  projectId: projectId,
                  organisationId: organisationId,
                  teamId: teamId,
                  startDate: startDate,
                  endDate: endDate,
                  taskStatus: null,
                  search: projectSearch,
                  limit: TASK_LIMIT,
                  offset: 0,
                  timezone: timezone,
                  role: role,
                  url: user === null || user === void 0 ? void 0 : user.uniqueUrl,
                  filterPriority: filterPriority
                }
              }, {
                query: GET_FILTER_TASK_TRACKER_DETAILS_QUERY,
                variables: {
                  organisationId: organisationId,
                  teamId: teamId,
                  userId: null,
                  projectId: [projectId],
                  taskId: null,
                  limit: LIMIT,
                  offset: 0,
                  filterType: view == "listView" ? activeTab : taskStatus == "To Do" ? "upcomingTasks" : taskStatus == "In Progress" ? "inProgressTasks" : taskStatus == "completed" ? "completed" : taskStatus == "hold" ? "hold" : "onDue",
                  timezone: timezone,
                  role: role,
                  search: projectSearch
                }
              }, {
                query: GET_FILTER_TASK_TRACKER_DETAILS_QUERY,
                variables: {
                  organisationId: organisationId,
                  teamId: teamId,
                  userId: null,
                  projectId: [projectId],
                  taskId: null,
                  limit: LIMIT,
                  offset: 0,
                  filterType: "completed",
                  timezone: timezone,
                  role: role,
                  search: projectSearch
                }
              }, {
                query: TASK_COUNT_QUERY,
                variables: {
                  organisationId: organisationId,
                  teamId: teamId,
                  userId: role == "Member" ? user === null || user === void 0 ? void 0 : user.userId : null,
                  projectId: [projectId],
                  taskId: null,
                  role: role
                }
              }, {
                query: PROJECT_DETAILS_SUMMARY_QUERY,
                variables: {
                  projectId: projectId,
                  organisationId: organisationId,
                  teamId: teamId,
                  startDate: moment(startDate).format("YYYY-MM-DD"),
                  endDate: moment(endDate !== null && endDate !== void 0 ? endDate : startDate).format("YYYY-MM-DD"),
                  timezone: timezone,
                  role: role,
                  userUrl: user === null || user === void 0 ? void 0 : user.uniqueUrl
                }
              }]
            });
          case 5:
            response = _context14.sent;
            setCompletedTask(null);
            if (response && (response === null || response === void 0 ? void 0 : (_response$data4 = response.data) === null || _response$data4 === void 0 ? void 0 : _response$data4.updateTaskStatus) == true) {
              setCompletedTaskList(function (prev) {
                if (prev == null) {
                  return [taskId];
                }
                return [].concat(_toConsumableArray(prev), [taskId]);
              });
              toast.success("Task status updated successfully!");
              handleCompletedClose();
            } else {
              toast.error("Error Occured, try again");
            }
            _context14.next = 13;
            break;
          case 10:
            _context14.prev = 10;
            _context14.t0 = _context14["catch"](2);
            toast.error("Error Occured, try again");
          case 13:
          case "end":
            return _context14.stop();
        }
      }, _callee14, null, [[2, 10]]);
    }));
    return _handleUpdateTaskStatus2.apply(this, arguments);
  }
  return /*#__PURE__*/React.createElement(Modal, {
    show: showcompletedModal,
    onHide: handleCompletedClose
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    className: "project-details-task-card-delete-header",
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "project-details-task-card-delete-title"
  }, taskProgress != "ongoing" ? "Task Completion" : "Task is under progress")), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "project-details-task-card-delete-body"
  }, taskProgress == "ongoing" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "project-details-task-card-delete-body-name"
  }, taskProgressUser, " "), /*#__PURE__*/React.createElement("span", {
    className: "project-details-task-card-delete-body-text"
  }, "is currently working on this task, so you can't mark it as completed until he/she clocks out from this task.")) : "Do you want to mark as completed this task?", " "), /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    className: "project-details-task-card-delete-cancel-button",
    onClick: handleCompletedClose
  }, "Cancel"), taskProgress != "ongoing" ? /*#__PURE__*/React.createElement(Button, {
    variant: "success",
    className: "project-details-task-card-delete-button",
    onClick: function onClick() {
      return handleUpdateTaskStatus(taskId, projectId);
    },
    disabled: updating
  }, updating ? "Loading..." : "Mark as completed") : null));
};
export var HoldConfirmationProject = function HoldConfirmationProject(props) {
  var showHoldModal = props.showHoldModal,
    handleHoldClose = props.handleHoldClose,
    holdTask = props.holdTask,
    setHoldTask = props.setHoldTask,
    holdTaskList = props.holdTaskList,
    setHoldTaskList = props.setHoldTaskList,
    organisationId = props.organisationId,
    startDate = props.startDate,
    endDate = props.endDate,
    timezone = props.timezone,
    role = props.role,
    user = props.user,
    projectSearch = props.projectSearch,
    filterPriority = props.filterPriority,
    activeTab = props.activeTab,
    view = props.view;
  if (showHoldModal === null) {
    return null;
  }
  var projectId = showHoldModal.projectId,
    taskId = showHoldModal.taskId,
    taskProgress = showHoldModal.taskProgress,
    taskProgressUser = showHoldModal.taskProgressUser,
    taskStatus = showHoldModal.taskStatus;
  var _React$useContext10 = React.useContext(FilterContext),
    teamId = _React$useContext10.teamId;
  var _useMutation15 = useMutation(UPDATE_TASK_STATUS_MUTATION),
    _useMutation16 = _slicedToArray(_useMutation15, 2),
    updateTaskStatus = _useMutation16[0],
    updating = _useMutation16[1].loading;
  function handleUpdateTaskStatus(_x8, _x9) {
    return _handleUpdateTaskStatus3.apply(this, arguments);
  }
  function _handleUpdateTaskStatus3() {
    _handleUpdateTaskStatus3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15(taskId, projectId) {
      var _response$data5, response;
      return _regeneratorRuntime().wrap(function _callee15$(_context15) {
        while (1) switch (_context15.prev = _context15.next) {
          case 0:
            if (!updating) {
              _context15.next = 2;
              break;
            }
            return _context15.abrupt("return");
          case 2:
            _context15.prev = 2;
            _context15.next = 5;
            return updateTaskStatus({
              variables: {
                projectId: projectId,
                taskId: taskId,
                taskStatus: "hold",
                organisationId: organisationId
              },
              awaitRefetchQueries: true,
              refetchQueries: [{
                query: PROJECT_TASKS_QUERY,
                variables: {
                  projectId: projectId,
                  organisationId: organisationId,
                  teamId: teamId,
                  startDate: startDate,
                  endDate: endDate,
                  taskStatus: null,
                  search: projectSearch,
                  limit: TASK_LIMIT,
                  offset: 0,
                  timezone: timezone,
                  role: role,
                  url: user === null || user === void 0 ? void 0 : user.uniqueUrl,
                  filterPriority: filterPriority
                }
              }, {
                query: GET_FILTER_TASK_TRACKER_DETAILS_QUERY,
                variables: {
                  organisationId: organisationId,
                  teamId: teamId,
                  userId: null,
                  projectId: [projectId],
                  taskId: null,
                  limit: LIMIT,
                  offset: 0,
                  filterType: view == "listView" ? activeTab : taskStatus == "To Do" ? "upcomingTasks" : taskStatus == "In Progress" ? "inProgressTasks" : taskStatus == "completed" ? "completed" : taskStatus == "hold" ? "hold" : "onDue",
                  timezone: timezone,
                  role: role,
                  search: projectSearch
                }
              }, {
                query: GET_FILTER_TASK_TRACKER_DETAILS_QUERY,
                variables: {
                  organisationId: organisationId,
                  teamId: teamId,
                  userId: null,
                  projectId: [projectId],
                  taskId: null,
                  limit: LIMIT,
                  offset: 0,
                  filterType: "hold",
                  timezone: timezone,
                  role: role,
                  search: projectSearch
                }
              }, {
                query: TASK_COUNT_QUERY,
                variables: {
                  organisationId: organisationId,
                  teamId: teamId,
                  userId: role == "Member" ? user === null || user === void 0 ? void 0 : user.userId : null,
                  projectId: [projectId],
                  taskId: null,
                  role: role
                }
              }, {
                query: PROJECT_DETAILS_SUMMARY_QUERY,
                variables: {
                  projectId: projectId,
                  organisationId: organisationId,
                  teamId: teamId,
                  startDate: moment(startDate).format("YYYY-MM-DD"),
                  endDate: moment(endDate !== null && endDate !== void 0 ? endDate : startDate).format("YYYY-MM-DD"),
                  timezone: timezone,
                  role: role,
                  userUrl: user === null || user === void 0 ? void 0 : user.uniqueUrl
                }
              }]
            });
          case 5:
            response = _context15.sent;
            setHoldTask(null);
            if (response && (response === null || response === void 0 ? void 0 : (_response$data5 = response.data) === null || _response$data5 === void 0 ? void 0 : _response$data5.updateTaskStatus) == true) {
              setHoldTaskList(function (prev) {
                if (prev == null) {
                  return [taskId];
                }
                return [].concat(_toConsumableArray(prev), [taskId]);
              });
              toast.success("Task status updated successfully!");
              handleHoldClose();
            } else {
              toast.error("Error Occured, try again");
            }
            _context15.next = 13;
            break;
          case 10:
            _context15.prev = 10;
            _context15.t0 = _context15["catch"](2);
            toast.error("Error Occured, try again");
          case 13:
          case "end":
            return _context15.stop();
        }
      }, _callee15, null, [[2, 10]]);
    }));
    return _handleUpdateTaskStatus3.apply(this, arguments);
  }
  return /*#__PURE__*/React.createElement(Modal, {
    show: showHoldModal,
    onHide: handleHoldClose
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    className: "project-details-task-card-delete-header",
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "project-details-task-card-delete-title"
  }, "Task Hold")), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "project-details-task-card-delete-body"
  }, "Do you want to mark as hold this task?"), /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    className: "project-details-task-card-delete-cancel-button",
    onClick: handleHoldClose
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    variant: "success",
    className: "project-details-task-card-delete-button",
    onClick: function onClick() {
      return handleUpdateTaskStatus(taskId, projectId);
    },
    disabled: updating
  }, updating ? "Loading..." : "Mark as hold")));
};
export var QuickEditMemberModal = function QuickEditMemberModal(props) {
  var _userWithSearch3, _userWithSearch4;
  var isQuickEditModal = props.isQuickEditModal,
    setIsQuickEditModal = props.setIsQuickEditModal,
    quickHandleMemberClose = props.quickHandleMemberClose,
    projectId = props.projectId,
    organisationId = props.organisationId,
    timezone = props.timezone,
    taskActive = props.taskActive,
    setIsQuickEditMemberModal = props.setIsQuickEditMemberModal,
    isQuickEditMemberModal = props.isQuickEditMemberModal,
    teamId = props.teamId,
    startDate = props.startDate,
    endDate = props.endDate,
    toDoTaskActive = props.toDoTaskActive,
    inProgessTaskActive = props.inProgessTaskActive,
    overDueTaskActive = props.overDueTaskActive,
    completedTaskActive = props.completedTaskActive,
    holdTaskActive = props.holdTaskActive,
    quickEditType = props.quickEditType,
    setQuickEditType = props.setQuickEditType,
    activeTab = props.activeTab,
    projectSearch = props.projectSearch,
    filterPriority = props.filterPriority;
  if (isQuickEditMemberModal == null) {
    return null;
  }
  var _React$useContext11 = React.useContext(FilterContext),
    role = _React$useContext11.role;
  var _React$useState199 = React.useState([]),
    _React$useState200 = _slicedToArray(_React$useState199, 2),
    userActive = _React$useState200[0],
    setUserActive = _React$useState200[1];
  var _React$useState201 = React.useState(""),
    _React$useState202 = _slicedToArray(_React$useState201, 2),
    searchUser = _React$useState202[0],
    setSearchUser = _React$useState202[1];
  var _React$useState203 = React.useState(true),
    _React$useState204 = _slicedToArray(_React$useState203, 2),
    isUserSelected = _React$useState204[0],
    setUserSelected = _React$useState204[1];
  var _React$useState205 = React.useState(false),
    _React$useState206 = _slicedToArray(_React$useState205, 2),
    istaskDesErr = _React$useState206[0],
    setIstaskDesErr = _React$useState206[1];
  var _React$useState207 = React.useState(true),
    _React$useState208 = _slicedToArray(_React$useState207, 2),
    isCheck = _React$useState208[0],
    setIsCheck = _React$useState208[1];
  var _React$useState209 = React.useState(userIds),
    _React$useState210 = _slicedToArray(_React$useState209, 2),
    publicActive = _React$useState210[0],
    setPublicActive = _React$useState210[1];
  var _React$useContext12 = React.useContext(UserContext),
    user = _React$useContext12.user;
  var _useQuery16 = useQuery(TASK_USERS_QUERY, {
      variables: {
        organisationId: organisationId,
        projectId: projectId
      },
      skip: !organisationId
    }),
    usersData = _useQuery16.data,
    usersError = _useQuery16.error,
    usersLoading = _useQuery16.loading,
    usersRefetch = _useQuery16.refetch;
  var userDetails = !usersLoading && !usersError ? usersData === null || usersData === void 0 ? void 0 : usersData.getTaskUserDetails : null;
  var userIds = userDetails === null || userDetails === void 0 ? void 0 : userDetails.map(function (user) {
    return user.userId;
  });
  var _useMutation17 = useMutation(QUICK_EDIT_TASK_MEMBER_MUTATION),
    _useMutation18 = _slicedToArray(_useMutation17, 2),
    quickEditTaskMembers = _useMutation18[0],
    addUserTaskDetailsLoading = _useMutation18[1].loading;
  var handleUserSubmitButton = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
    var variables, _response$data6, response;
    return _regeneratorRuntime().wrap(function _callee16$(_context16) {
      while (1) switch (_context16.prev = _context16.next) {
        case 0:
          variables = {
            projectId: projectId,
            organisationId: organisationId,
            taskId: quickEditType == "upcomingTasks" ? toDoTaskActive : quickEditType == "inProgressTasks" ? inProgessTaskActive : quickEditType == "onDue" ? overDueTaskActive : quickEditType == "completed" ? completedTaskActive : quickEditType == "hold" ? holdTaskActive : taskActive,
            userId: userActive,
            timezone: timezone,
            taskVisibility: !isCheck ? "public" : "private"
          };
          _context16.prev = 1;
          _context16.next = 4;
          return quickEditTaskMembers({
            variables: variables,
            awaitRefetchQueries: true,
            refetchQueries: [{
              query: PROJECT_LISTING_QUERY,
              variables: {
                organisationId: organisationId,
                url: user === null || user === void 0 ? void 0 : user.uniqueUrl,
                role: role
              }
            }, {
              query: PROJECTS_LISTING_QUERY,
              variables: {
                organisationId: organisationId,
                teamId: teamId,
                from: props !== null && props !== void 0 && props.from ? "desktop" : null,
                role: role
              }
            }, {
              query: PROJECTS_LISTING_FOR_FILTER_QUERY,
              variables: {
                organisationId: organisationId,
                teamId: teamId,
                from: props !== null && props !== void 0 && props.from ? "desktop" : null,
                role: role
              }
            }, {
              query: PROJECT_TASKS_QUERY,
              variables: {
                projectId: projectId,
                organisationId: organisationId,
                teamId: teamId,
                startDate: startDate,
                endDate: endDate,
                taskStatus: null,
                search: projectSearch,
                limit: TASK_LIMIT,
                offset: 0,
                timezone: timezone,
                role: role,
                url: user === null || user === void 0 ? void 0 : user.uniqueUrl,
                filterPriority: filterPriority
              }
            }, {
              query: PROJECT_DETAILS_SUMMARY_QUERY,
              variables: {
                projectId: projectId,
                organisationId: organisationId,
                teamId: teamId,
                startDate: moment(startDate).format("YYYY-MM-DD"),
                endDate: moment(endDate !== null && endDate !== void 0 ? endDate : startDate).format("YYYY-MM-DD"),
                timezone: timezone,
                role: role,
                userUrl: user === null || user === void 0 ? void 0 : user.uniqueUrl
              }
            }, {
              query: TASK_COUNT_QUERY,
              variables: {
                organisationId: organisationId,
                teamId: teamId,
                userId: null,
                projectId: [projectId],
                taskId: null,
                role: role
              }
            }, {
              query: GET_FILTER_TASK_TRACKER_DETAILS_QUERY,
              variables: {
                organisationId: organisationId,
                teamId: teamId,
                userId: null,
                projectId: [projectId],
                taskId: null,
                limit: LIMIT,
                offset: 0,
                filterType: activeTab,
                timezone: timezone,
                role: role,
                search: projectSearch
              }
            }]
          });
        case 4:
          response = _context16.sent;
          if (response && (response === null || response === void 0 ? void 0 : (_response$data6 = response.data) === null || _response$data6 === void 0 ? void 0 : _response$data6.quickEditTaskMembers) == true) {
            toast.success("Task updated successfully!");
            quickHandleMemberClose();
          } else {
            setIstaskDesErr(true);
          }
          _context16.next = 12;
          break;
        case 8:
          _context16.prev = 8;
          _context16.t0 = _context16["catch"](1);
          console.log("error", _context16.t0);
          setIstaskDesErr(true);
        case 12:
        case "end":
          return _context16.stop();
      }
    }, _callee16, null, [[1, 8]]);
  })), [quickEditTaskMembers, addUserTaskDetailsLoading, userActive, taskActive, isCheck]);
  var userWithSearch = function userWithSearch(userData) {
    if (!searchUser) {
      return userData;
    }
    return userData.filter(function (filterUsersData) {
      var _filterUsersData$disp5, _filterUsersData$disp6, _filterUsersData$disp7, _filterUsersData$disp8;
      return filterUsersData === null || filterUsersData === void 0 ? void 0 : (_filterUsersData$disp5 = filterUsersData.displayName) === null || _filterUsersData$disp5 === void 0 ? void 0 : (_filterUsersData$disp6 = _filterUsersData$disp5.toLowerCase) === null || _filterUsersData$disp6 === void 0 ? void 0 : (_filterUsersData$disp7 = _filterUsersData$disp6.call(_filterUsersData$disp5)) === null || _filterUsersData$disp7 === void 0 ? void 0 : (_filterUsersData$disp8 = _filterUsersData$disp7.includes) === null || _filterUsersData$disp8 === void 0 ? void 0 : _filterUsersData$disp8.call(_filterUsersData$disp7, searchUser.toLowerCase());
    });
  };
  var handleKey = function handleKey(data) {
    if (data == "setting") {
      setIsCheck(function (prev) {
        return prev === true ? false : true;
      });
      var t = userDetails === null || userDetails === void 0 ? void 0 : userDetails.map(function (user) {
        return user.userId;
      });
      setPublicActive(t);
    }
  };
  return /*#__PURE__*/React.createElement(Modal, {
    show: true,
    onHide: quickHandleMemberClose,
    centered: true,
    className: "project-task-modals-root"
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "project-task-modals-root-title"
  }, "Edit Task Members")), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: 12,
    md: 12
  }, /*#__PURE__*/React.createElement(Accordion, {
    className: "task-modal-accordion-whole",
    defaultActiveKey: !isCheck ? null : "0"
  }, /*#__PURE__*/React.createElement("div", {
    onClick: function onClick() {
      return handleKey("setting");
    }
  }, /*#__PURE__*/React.createElement(Accordion.Toggle, {
    as: Button,
    variant: "link",
    eventKey: "0",
    className: "task-modal-content-header-team-name-acc"
  }, /*#__PURE__*/React.createElement("span", {
    className: "project-detail-tasks-modal-content-header-setting"
  }, /*#__PURE__*/React.createElement(HiLockClosed, {
    className: "project-tasks-modal-content-header-setting-icon"
  }), " Assign this task to all members in the project"), /*#__PURE__*/React.createElement("div", {
    className: "tasks-rule-uparrow toggle-switch"
  }, /*#__PURE__*/React.createElement("label", {
    "for": "chkTest"
  }, /*#__PURE__*/React.createElement("span", {
    className: classNames("toggle-track", {
      "toggle-track-nav-right-div": !isCheck
    })
  }))))), /*#__PURE__*/React.createElement(Accordion.Collapse, {
    eventKey: "0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tasks-modal-content-person-name"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tasks-modal-content-person-name-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-edit-modal-content-person-name-header-section"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tasks-modal-content-person-name-header-section-label"
  }), /*#__PURE__*/React.createElement("div", {
    className: "my-projects-modal-content-person-name-header-section-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "my-projects-modal-searchbox-wrapper"
  }, /*#__PURE__*/React.createElement(SearchBar, {
    value: searchUser,
    onChange: setSearchUser,
    placeholder: "Search employee name"
  })), (userActive === null || userActive === void 0 ? void 0 : userActive.length) == (userIds === null || userIds === void 0 ? void 0 : userIds.length) ? /*#__PURE__*/React.createElement("p", {
    className: "projects-tasks-modal-content-person-name-header-button",
    onClick: function onClick() {
      setUserActive([]);
      setUserSelected(false);
    }
  }, "Unselect All") : /*#__PURE__*/React.createElement("p", {
    //variant="outline-secondary"
    className: "projects-tasks-modal-content-person-name-header-button",
    onClick: function onClick() {
      setUserActive(userIds);
      setUserSelected(true);
    }
  }, "Select All")))), /*#__PURE__*/React.createElement("div", {
    className: "project-details-tasks-modal-content-person-name-listing"
  }, usersLoading ? /*#__PURE__*/React.createElement(Loader, null) : userDetails && (_userWithSearch3 = userWithSearch(userDetails)) !== null && _userWithSearch3 !== void 0 && _userWithSearch3.length ? (_userWithSearch4 = userWithSearch(userDetails)) === null || _userWithSearch4 === void 0 ? void 0 : _userWithSearch4.map(function (user, index) {
    var teamFirstName = user.displayName.match(/\b(\w)/g);
    var teamNameIcon = teamFirstName.join("");
    return /*#__PURE__*/React.createElement("div", {
      className: "my-projects-modal-content-person-name-listing-card-content",
      key: index
    }, /*#__PURE__*/React.createElement("div", {
      className: "tasks-modal-content-person-name-listing-card-content-person",
      onClick: function onClick() {
        setUserSelected(true);
        setUserActive(function (prev) {
          return prev.includes(user.userId) ? prev.filter(function (a) {
            return a !== user.userId;
          }) : [].concat(_toConsumableArray(prev), [user.userId]);
        });
      }
    }, user.profileUrl ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "task-card-avatar-profile"
    }, /*#__PURE__*/React.createElement("img", {
      alt: "Workfolio",
      src: user === null || user === void 0 ? void 0 : user.profileUrl,
      className: "task-card-avatar-profile-img"
    }))) : /*#__PURE__*/React.createElement("div", {
      className: "tasks-modal-content-person-name-listing-card-content-person-icon"
    }, user.displayName.charAt(0).toUpperCase()), /*#__PURE__*/React.createElement("div", {
      className: "my-projects-modal-content-header-team-name"
    }, user.displayName)), /*#__PURE__*/React.createElement("div", {
      className: "my-projects-modal-content-team-name"
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      id: user.userId,
      name: "myRadioGroup",
      className: "create-project-team-selection-control-checkbox",
      checked: userActive.includes(user.userId),
      onChange: function onChange() {
        setUserSelected(true);
        setUserActive(function (prev) {
          return prev.includes(user.userId) ? prev.filter(function (a) {
            return a !== user.userId;
          }) : [].concat(_toConsumableArray(prev), [user.userId]);
        });
      }
    })));
  }) : /*#__PURE__*/React.createElement("div", {
    className: "text-muted text-center"
  }, "No member found for \"".concat(searchUser, "\"")))))))), /*#__PURE__*/React.createElement("div", {
    className: "project-task-list-modal-save-button"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    className: "project-task-modals-save-button",
    onClick: function onClick() {
      handleUserSubmitButton();
    },
    disabled: addUserTaskDetailsLoading
  }, addUserTaskDetailsLoading ? "Loading..." : "Save Changes")))));
};
export var QuickEditModal = function QuickEditModal(props) {
  var isQuickEditModal = props.isQuickEditModal,
    setIsQuickEditModal = props.setIsQuickEditModal,
    quickHandleClose = props.quickHandleClose,
    projectId = props.projectId,
    organisationId = props.organisationId,
    timezone = props.timezone,
    taskActive = props.taskActive,
    teamId = props.teamId,
    startDate = props.startDate,
    endDate = props.endDate,
    toDoTaskActive = props.toDoTaskActive,
    inProgessTaskActive = props.inProgessTaskActive,
    overDueTaskActive = props.overDueTaskActive,
    completedTaskActive = props.completedTaskActive,
    holdTaskActive = props.holdTaskActive,
    quickEditType = props.quickEditType,
    setQuickEditType = props.setQuickEditType,
    activeTab = props.activeTab,
    setTaskActive = props.setTaskActive,
    setToDoTaskActive = props.setToDoTaskActive,
    setInProgessTaskActive = props.setInProgessTaskActive,
    setOverDueTaskActive = props.setOverDueTaskActive,
    setCompletedTaskActive = props.setCompletedTaskActive,
    setHoldTaskActive = props.setHoldTaskActive,
    projectSearch = props.projectSearch,
    filterPriority = props.filterPriority;
  if (isQuickEditModal == null) {
    return null;
  }
  var _React$useContext13 = React.useContext(FilterContext),
    role = _React$useContext13.role;
  var _React$useState211 = React.useState(null),
    _React$useState212 = _slicedToArray(_React$useState211, 2),
    manualStartDate = _React$useState212[0],
    setManualStartDate = _React$useState212[1];
  var _React$useState213 = React.useState(false),
    _React$useState214 = _slicedToArray(_React$useState213, 2),
    isManualDatePickerOpen = _React$useState214[0],
    setIsManualDatePickerOpen = _React$useState214[1];
  var _React$useContext14 = React.useContext(UserContext),
    user = _React$useContext14.user;
  var _useMutation19 = useMutation(QUICK_EDIT_TASK_ESTIMATION_MUTATION),
    _useMutation20 = _slicedToArray(_useMutation19, 2),
    quickEditTaskEstimationTime = _useMutation20[0],
    addTaskEstimationLoading = _useMutation20[1].loading;
  var _useMutation21 = useMutation(QUICK_EDIT_TASK_DUE_DATE_MUTATION),
    _useMutation22 = _slicedToArray(_useMutation21, 2),
    quickEditTaskDueDate = _useMutation22[0],
    addTaskDueDateLoading = _useMutation22[1].loading;
  var _useMutation23 = useMutation(QUICK_EDIT_TASK_PRIORITY_MUTATION),
    _useMutation24 = _slicedToArray(_useMutation23, 2),
    quickEditTaskPriority = _useMutation24[0],
    addTaskPriorityLoading = _useMutation24[1].loading;
  var _useMutation25 = useMutation(QUICK_EDIT_TASK_STATUS_MUTATION),
    _useMutation26 = _slicedToArray(_useMutation25, 2),
    quickEditTaskStatus = _useMutation26[0],
    addTaskStatusLoading = _useMutation26[1].loading;
  var _useMutation27 = useMutation(QUICK_DELETE_TASK_MUTATION),
    _useMutation28 = _slicedToArray(_useMutation27, 2),
    quickDeleteTask = _useMutation28[0],
    addTaskDeleteLoading = _useMutation28[1].loading;
  var handleEstimationSubmit = React.useCallback( /*#__PURE__*/function () {
    var _ref21 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee17(values, actions) {
      var response;
      return _regeneratorRuntime().wrap(function _callee17$(_context17) {
        while (1) switch (_context17.prev = _context17.next) {
          case 0:
            if (!addTaskEstimationLoading) {
              _context17.next = 2;
              break;
            }
            return _context17.abrupt("return");
          case 2:
            _context17.prev = 2;
            _context17.next = 5;
            return quickEditTaskEstimationTime({
              variables: {
                projectId: projectId,
                organisationId: organisationId,
                taskId: quickEditType == "upcomingTasks" ? toDoTaskActive : quickEditType == "inProgressTasks" ? inProgessTaskActive : quickEditType == "onDue" ? overDueTaskActive : quickEditType == "completed" ? completedTaskActive : quickEditType == "hold" ? holdTaskActive : taskActive,
                taskTime: values.taskTime === null ? null : Number(values.taskTime) * 60 * 60,
                timezone: timezone
              },
              refetchQueries: [{
                query: PROJECT_LISTING_QUERY,
                variables: {
                  organisationId: organisationId,
                  url: user === null || user === void 0 ? void 0 : user.uniqueUrl,
                  role: role
                }
              }, {
                query: PROJECTS_LISTING_QUERY,
                variables: {
                  organisationId: organisationId,
                  teamId: teamId,
                  from: props !== null && props !== void 0 && props.from ? "desktop" : null,
                  role: role
                }
              }, {
                query: PROJECTS_LISTING_FOR_FILTER_QUERY,
                variables: {
                  organisationId: organisationId,
                  teamId: teamId,
                  from: props !== null && props !== void 0 && props.from ? "desktop" : null,
                  role: role
                }
              }, {
                query: PROJECT_TASKS_QUERY,
                variables: {
                  projectId: projectId,
                  organisationId: organisationId,
                  teamId: teamId,
                  startDate: startDate,
                  endDate: endDate,
                  taskStatus: null,
                  search: projectSearch,
                  limit: TASK_LIMIT,
                  offset: 0,
                  timezone: timezone,
                  role: role,
                  url: user === null || user === void 0 ? void 0 : user.uniqueUrl,
                  filterPriority: filterPriority
                }
              }, {
                query: PROJECT_DETAILS_SUMMARY_QUERY,
                variables: {
                  projectId: projectId,
                  organisationId: organisationId,
                  teamId: teamId,
                  startDate: moment(startDate).format("YYYY-MM-DD"),
                  endDate: moment(endDate !== null && endDate !== void 0 ? endDate : startDate).format("YYYY-MM-DD"),
                  timezone: timezone,
                  role: role,
                  userUrl: user === null || user === void 0 ? void 0 : user.uniqueUrl
                }
              }, {
                query: TASK_COUNT_QUERY,
                variables: {
                  organisationId: organisationId,
                  teamId: teamId,
                  userId: null,
                  projectId: [projectId],
                  taskId: null,
                  role: role
                }
              }, {
                query: GET_FILTER_TASK_TRACKER_DETAILS_QUERY,
                variables: {
                  organisationId: organisationId,
                  teamId: teamId,
                  userId: null,
                  projectId: [projectId],
                  taskId: null,
                  limit: LIMIT,
                  offset: 0,
                  filterType: activeTab,
                  timezone: timezone,
                  role: role
                }
              }],
              awaitRefetchQueries: true
            });
          case 5:
            response = _context17.sent;
            if (!(!response || !response.data)) {
              _context17.next = 10;
              break;
            }
            throw new Error("error");
          case 10:
            quickHandleClose();
            toast.success("Task estimated hours updated successfully!");
          case 12:
            _context17.next = 17;
            break;
          case 14:
            _context17.prev = 14;
            _context17.t0 = _context17["catch"](2);
            console.log("error", _context17.t0);
          case 17:
          case "end":
            return _context17.stop();
        }
      }, _callee17, null, [[2, 14]]);
    }));
    return function (_x10, _x11) {
      return _ref21.apply(this, arguments);
    };
  }(), [quickEditTaskEstimationTime, addTaskEstimationLoading]);
  var handleDueDateSubmit = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee18() {
    var response;
    return _regeneratorRuntime().wrap(function _callee18$(_context18) {
      while (1) switch (_context18.prev = _context18.next) {
        case 0:
          _context18.prev = 0;
          _context18.next = 3;
          return quickEditTaskDueDate({
            variables: {
              projectId: projectId,
              organisationId: organisationId,
              taskId: quickEditType == "upcomingTasks" ? toDoTaskActive : quickEditType == "inProgressTasks" ? inProgessTaskActive : quickEditType == "onDue" ? overDueTaskActive : quickEditType == "completed" ? completedTaskActive : quickEditType == "hold" ? holdTaskActive : taskActive,
              dueDate: manualStartDate,
              timezone: timezone
            },
            refetchQueries: [{
              query: PROJECT_LISTING_QUERY,
              variables: {
                organisationId: organisationId,
                url: user === null || user === void 0 ? void 0 : user.uniqueUrl,
                role: role
              }
            }, {
              query: PROJECTS_LISTING_QUERY,
              variables: {
                organisationId: organisationId,
                teamId: teamId,
                from: props !== null && props !== void 0 && props.from ? "desktop" : null,
                role: role
              }
            }, {
              query: PROJECTS_LISTING_FOR_FILTER_QUERY,
              variables: {
                organisationId: organisationId,
                teamId: teamId,
                from: props !== null && props !== void 0 && props.from ? "desktop" : null,
                role: role
              }
            }, {
              query: PROJECT_TASKS_QUERY,
              variables: {
                projectId: projectId,
                organisationId: organisationId,
                teamId: teamId,
                startDate: startDate,
                endDate: endDate,
                taskStatus: null,
                search: projectSearch,
                limit: TASK_LIMIT,
                offset: 0,
                timezone: timezone,
                role: role,
                url: user === null || user === void 0 ? void 0 : user.uniqueUrl,
                filterPriority: filterPriority
              }
            }, {
              query: PROJECT_DETAILS_SUMMARY_QUERY,
              variables: {
                projectId: projectId,
                organisationId: organisationId,
                teamId: teamId,
                startDate: moment(startDate).format("YYYY-MM-DD"),
                endDate: moment(endDate !== null && endDate !== void 0 ? endDate : startDate).format("YYYY-MM-DD"),
                timezone: timezone,
                role: role,
                userUrl: user === null || user === void 0 ? void 0 : user.uniqueUrl
              }
            }, {
              query: TASK_COUNT_QUERY,
              variables: {
                organisationId: organisationId,
                teamId: teamId,
                userId: null,
                projectId: [projectId],
                taskId: null,
                role: role
              }
            }, {
              query: GET_FILTER_TASK_TRACKER_DETAILS_QUERY,
              variables: {
                organisationId: organisationId,
                teamId: teamId,
                userId: null,
                projectId: [projectId],
                taskId: null,
                limit: LIMIT,
                offset: 0,
                filterType: activeTab,
                timezone: timezone,
                role: role,
                search: projectSearch
              }
            }],
            awaitRefetchQueries: true
          });
        case 3:
          response = _context18.sent;
          if (!(!response || !response.data)) {
            _context18.next = 8;
            break;
          }
          throw new Error("error");
        case 8:
          quickHandleClose();
          toast.success("Task due date updated successfully!");
        case 10:
          _context18.next = 15;
          break;
        case 12:
          _context18.prev = 12;
          _context18.t0 = _context18["catch"](0);
          console.log("error", _context18.t0);
        case 15:
        case "end":
          return _context18.stop();
      }
    }, _callee18, null, [[0, 12]]);
  })), [quickEditTaskDueDate, addTaskDueDateLoading, manualStartDate]);
  var handlePrioritySubmit = React.useCallback( /*#__PURE__*/function () {
    var _ref23 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee19(values, actions) {
      var response;
      return _regeneratorRuntime().wrap(function _callee19$(_context19) {
        while (1) switch (_context19.prev = _context19.next) {
          case 0:
            if (!addTaskPriorityLoading) {
              _context19.next = 2;
              break;
            }
            return _context19.abrupt("return");
          case 2:
            _context19.prev = 2;
            _context19.next = 5;
            return quickEditTaskPriority({
              variables: {
                projectId: projectId,
                organisationId: organisationId,
                taskId: quickEditType == "upcomingTasks" ? toDoTaskActive : quickEditType == "inProgressTasks" ? inProgessTaskActive : quickEditType == "onDue" ? overDueTaskActive : quickEditType == "completed" ? completedTaskActive : quickEditType == "hold" ? holdTaskActive : taskActive,
                priority: values.priority,
                timezone: timezone
              },
              refetchQueries: [{
                query: PROJECT_LISTING_QUERY,
                variables: {
                  organisationId: organisationId,
                  url: user === null || user === void 0 ? void 0 : user.uniqueUrl,
                  role: role
                }
              }, {
                query: PROJECTS_LISTING_QUERY,
                variables: {
                  organisationId: organisationId,
                  teamId: teamId,
                  from: props !== null && props !== void 0 && props.from ? "desktop" : null,
                  role: role
                }
              }, {
                query: PROJECTS_LISTING_FOR_FILTER_QUERY,
                variables: {
                  organisationId: organisationId,
                  teamId: teamId,
                  from: props !== null && props !== void 0 && props.from ? "desktop" : null,
                  role: role
                }
              }, {
                query: PROJECT_TASKS_QUERY,
                variables: {
                  projectId: projectId,
                  organisationId: organisationId,
                  teamId: teamId,
                  startDate: startDate,
                  endDate: endDate,
                  taskStatus: null,
                  search: projectSearch,
                  limit: TASK_LIMIT,
                  offset: 0,
                  timezone: timezone,
                  role: role,
                  url: user === null || user === void 0 ? void 0 : user.uniqueUrl,
                  filterPriority: filterPriority
                }
              }, {
                query: PROJECT_DETAILS_SUMMARY_QUERY,
                variables: {
                  projectId: projectId,
                  organisationId: organisationId,
                  teamId: teamId,
                  startDate: moment(startDate).format("YYYY-MM-DD"),
                  endDate: moment(endDate !== null && endDate !== void 0 ? endDate : startDate).format("YYYY-MM-DD"),
                  timezone: timezone,
                  role: role,
                  userUrl: user === null || user === void 0 ? void 0 : user.uniqueUrl
                }
              }, {
                query: TASK_COUNT_QUERY,
                variables: {
                  organisationId: organisationId,
                  teamId: teamId,
                  userId: null,
                  projectId: [projectId],
                  taskId: null,
                  role: role
                }
              }, {
                query: GET_FILTER_TASK_TRACKER_DETAILS_QUERY,
                variables: {
                  organisationId: organisationId,
                  teamId: teamId,
                  userId: null,
                  projectId: [projectId],
                  taskId: null,
                  limit: LIMIT,
                  offset: 0,
                  filterType: activeTab,
                  timezone: timezone,
                  role: role,
                  search: projectSearch
                }
              }],
              awaitRefetchQueries: true
            });
          case 5:
            response = _context19.sent;
            if (!(!response || !response.data)) {
              _context19.next = 10;
              break;
            }
            throw new Error("error");
          case 10:
            quickHandleClose();
            toast.success("Task priority updated successfully!");
          case 12:
            _context19.next = 17;
            break;
          case 14:
            _context19.prev = 14;
            _context19.t0 = _context19["catch"](2);
            console.log("error", _context19.t0);
          case 17:
          case "end":
            return _context19.stop();
        }
      }, _callee19, null, [[2, 14]]);
    }));
    return function (_x12, _x13) {
      return _ref23.apply(this, arguments);
    };
  }(), [quickEditTaskPriority, addTaskPriorityLoading]);
  var handleStatusSubmit = React.useCallback( /*#__PURE__*/function () {
    var _ref24 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee20(values, actions) {
      var response;
      return _regeneratorRuntime().wrap(function _callee20$(_context20) {
        while (1) switch (_context20.prev = _context20.next) {
          case 0:
            if (!addTaskStatusLoading) {
              _context20.next = 2;
              break;
            }
            return _context20.abrupt("return");
          case 2:
            _context20.prev = 2;
            _context20.next = 5;
            return quickEditTaskStatus({
              variables: {
                projectId: projectId,
                organisationId: organisationId,
                taskId: quickEditType == "upcomingTasks" ? toDoTaskActive : quickEditType == "inProgressTasks" ? inProgessTaskActive : quickEditType == "onDue" ? overDueTaskActive : quickEditType == "completed" ? completedTaskActive : quickEditType == "hold" ? holdTaskActive : taskActive,
                status: values.status,
                timezone: timezone
              },
              refetchQueries: [{
                query: PROJECT_LISTING_QUERY,
                variables: {
                  organisationId: organisationId,
                  url: user === null || user === void 0 ? void 0 : user.uniqueUrl,
                  role: role
                }
              }, {
                query: PROJECTS_LISTING_QUERY,
                variables: {
                  organisationId: organisationId,
                  teamId: teamId,
                  from: props !== null && props !== void 0 && props.from ? "desktop" : null,
                  role: role
                }
              }, {
                query: PROJECTS_LISTING_FOR_FILTER_QUERY,
                variables: {
                  organisationId: organisationId,
                  teamId: teamId,
                  from: props !== null && props !== void 0 && props.from ? "desktop" : null,
                  role: role
                }
              }, {
                query: PROJECT_TASKS_QUERY,
                variables: {
                  projectId: projectId,
                  organisationId: organisationId,
                  teamId: teamId,
                  startDate: startDate,
                  endDate: endDate,
                  taskStatus: null,
                  search: projectSearch,
                  limit: TASK_LIMIT,
                  offset: 0,
                  timezone: timezone,
                  role: role,
                  url: user === null || user === void 0 ? void 0 : user.uniqueUrl,
                  filterPriority: filterPriority
                }
              }, {
                query: PROJECT_DETAILS_SUMMARY_QUERY,
                variables: {
                  projectId: projectId,
                  organisationId: organisationId,
                  teamId: teamId,
                  startDate: moment(startDate).format("YYYY-MM-DD"),
                  endDate: moment(endDate !== null && endDate !== void 0 ? endDate : startDate).format("YYYY-MM-DD"),
                  timezone: timezone,
                  role: role,
                  userUrl: user === null || user === void 0 ? void 0 : user.uniqueUrl
                }
              }, {
                query: TASK_COUNT_QUERY,
                variables: {
                  organisationId: organisationId,
                  teamId: teamId,
                  userId: null,
                  projectId: [projectId],
                  taskId: null,
                  role: role
                }
              }, {
                query: GET_FILTER_TASK_TRACKER_DETAILS_QUERY,
                variables: {
                  organisationId: organisationId,
                  teamId: teamId,
                  userId: null,
                  projectId: [projectId],
                  taskId: null,
                  limit: LIMIT,
                  offset: 0,
                  filterType: activeTab,
                  timezone: timezone,
                  role: role,
                  search: projectSearch
                }
              }],
              awaitRefetchQueries: true
            });
          case 5:
            response = _context20.sent;
            if (!(!response || !response.data)) {
              _context20.next = 10;
              break;
            }
            throw new Error("error");
          case 10:
            quickHandleClose();
            toast.success("Task status updated successfully!");
          case 12:
            _context20.next = 17;
            break;
          case 14:
            _context20.prev = 14;
            _context20.t0 = _context20["catch"](2);
            console.log("error", _context20.t0);
          case 17:
          case "end":
            return _context20.stop();
        }
      }, _callee20, null, [[2, 14]]);
    }));
    return function (_x14, _x15) {
      return _ref24.apply(this, arguments);
    };
  }(), [quickEditTaskStatus, addTaskStatusLoading]);
  var handleDeleteSubmit = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee21() {
    var response;
    return _regeneratorRuntime().wrap(function _callee21$(_context21) {
      while (1) switch (_context21.prev = _context21.next) {
        case 0:
          _context21.prev = 0;
          _context21.next = 3;
          return quickDeleteTask({
            variables: {
              projectId: projectId,
              organisationId: organisationId,
              taskId: quickEditType == "upcomingTasks" ? toDoTaskActive : quickEditType == "inProgressTasks" ? inProgessTaskActive : quickEditType == "onDue" ? overDueTaskActive : quickEditType == "completed" ? completedTaskActive : quickEditType == "hold" ? holdTaskActive : taskActive
            },
            refetchQueries: [{
              query: PROJECT_LISTING_QUERY,
              variables: {
                organisationId: organisationId,
                url: user === null || user === void 0 ? void 0 : user.uniqueUrl,
                role: role
              }
            }, {
              query: PROJECTS_LISTING_QUERY,
              variables: {
                organisationId: organisationId,
                teamId: teamId,
                from: props !== null && props !== void 0 && props.from ? "desktop" : null,
                role: role
              }
            }, {
              query: PROJECTS_LISTING_FOR_FILTER_QUERY,
              variables: {
                organisationId: organisationId,
                teamId: teamId,
                from: props !== null && props !== void 0 && props.from ? "desktop" : null,
                role: role
              }
            }, {
              query: PROJECT_TASKS_QUERY,
              variables: {
                projectId: projectId,
                organisationId: organisationId,
                teamId: teamId,
                startDate: startDate,
                endDate: endDate,
                taskStatus: null,
                search: projectSearch,
                limit: TASK_LIMIT,
                offset: 0,
                timezone: timezone,
                role: role,
                url: user === null || user === void 0 ? void 0 : user.uniqueUrl,
                filterPriority: filterPriority
              }
            }, {
              query: PROJECT_DETAILS_SUMMARY_QUERY,
              variables: {
                projectId: projectId,
                organisationId: organisationId,
                teamId: teamId,
                startDate: moment(startDate).format("YYYY-MM-DD"),
                endDate: moment(endDate !== null && endDate !== void 0 ? endDate : startDate).format("YYYY-MM-DD"),
                timezone: timezone,
                role: role,
                userUrl: user === null || user === void 0 ? void 0 : user.uniqueUrl
              }
            }, {
              query: TASK_COUNT_QUERY,
              variables: {
                organisationId: organisationId,
                teamId: teamId,
                userId: null,
                projectId: [projectId],
                taskId: null,
                role: role
              }
            }, {
              query: GET_FILTER_TASK_TRACKER_DETAILS_QUERY,
              variables: {
                organisationId: organisationId,
                teamId: teamId,
                userId: null,
                projectId: [projectId],
                taskId: null,
                limit: LIMIT,
                offset: 0,
                filterType: activeTab,
                timezone: timezone,
                role: role,
                search: projectSearch
              }
            }],
            awaitRefetchQueries: true
          });
        case 3:
          response = _context21.sent;
          if (!(!response || !response.data)) {
            _context21.next = 8;
            break;
          }
          throw new Error("error");
        case 8:
          quickHandleClose();
          toast.success("Task deleted successfully!");
          if (quickEditType == "upcomingTasks") {
            setToDoTaskActive([]);
          } else if (quickEditType == "inProgressTasks") {
            setInProgessTaskActive([]);
          } else if (quickEditType == "onDue") {
            setOverDueTaskActive([]);
          } else if (quickEditType == "completed") {
            setCompletedTaskActive([]);
          } else if (quickEditType == "hold") {
            setHoldTaskActive([]);
          } else {
            setTaskActive([]);
          }
        case 11:
          _context21.next = 16;
          break;
        case 13:
          _context21.prev = 13;
          _context21.t0 = _context21["catch"](0);
          console.log("error", _context21.t0);
        case 16:
        case "end":
          return _context21.stop();
      }
    }, _callee21, null, [[0, 13]]);
  })), [quickDeleteTask, addTaskDeleteLoading]);
  var handleChange = function handleChange(e) {
    setIsManualDatePickerOpen(!isManualDatePickerOpen);
    setManualStartDate(e);
  };
  return /*#__PURE__*/React.createElement(Modal, {
    show: true,
    onHide: quickHandleClose,
    centered: true,
    className: "project-task-modals-root"
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "project-task-modals-root-title"
  }, isQuickEditModal == "editEstimation" ? "Edit Estimated Hours" : isQuickEditModal == "editDueDate" ? "Edit Due Date" : isQuickEditModal == "editPriority" ? " Edit Task Priority" : isQuickEditModal == "editStatus" ? "Edit Task Status" : isQuickEditModal == "quickDelete" ? "Delete Task" : null)), /*#__PURE__*/React.createElement(Modal.Body, null, isQuickEditModal == "editEstimation" ? /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      taskTime: ""
    },
    validationSchema: QuickEidtEstimationSchema,
    onSubmit: handleEstimationSubmit
  }, function (_ref26) {
    var setFieldValue = _ref26.setFieldValue,
      errors = _ref26.errors;
    return /*#__PURE__*/React.createElement(FormikForm, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12,
      className: "tasks-modal-cols"
    }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, /*#__PURE__*/React.createElement("div", {
      className: ""
    }, /*#__PURE__*/React.createElement("div", {
      className: ""
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Field, {
      name: "taskTime"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(FormGroup, {
        className: ""
      }, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "project-task-modals-edit-task-label-name"
      }, "Estimated Hours"), meta.error && meta.touched ? /*#__PURE__*/React.createElement(ControlLabel, {
        className: "error"
      }, meta.error) : null, /*#__PURE__*/React.createElement("div", {
        className: "quick-edit-time-div"
      }, /*#__PURE__*/React.createElement(FormControl, _extends({
        type: "number",
        min: "0",
        placeholder: "e.g. 10",
        className: "task-add-placeholder"
      }, field)), /*#__PURE__*/React.createElement("span", {
        className: "project-task-modal-add-new-project-hours-text"
      }, "Hours")));
    })))))), /*#__PURE__*/React.createElement(Row, {
      className: ""
    }, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12,
      className: "projects-create-col"
    }, /*#__PURE__*/React.createElement("div", {
      className: "quick-edit-time-div-modal-save-button "
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "primary"
      //className="project-task-modals-save-button"
      ,
      type: "submit",
      disabled: addTaskEstimationLoading
    }, addTaskEstimationLoading ? "Loading..." : "Save Changes"), " "), errors.formError ? /*#__PURE__*/React.createElement("div", {
      className: "form-error my-projects-modal-form-error"
    }, errors.formError) : null)))));
  }) : isQuickEditModal == "editDueDate" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ControlLabel, {
    className: "project-task-modals-edit-task-label-name"
  }, "Due Date"), /*#__PURE__*/React.createElement("div", {
    className: "quick-project-task-due-date"
  }, /*#__PURE__*/React.createElement(DatePicker, {
    id: "task-due-date",
    dateFormat: "dd/MM/yyyy",
    selected: manualStartDate,
    onChange: handleChange,
    isClearable: true,
    className: "quick-task-details-due-date-date-picker",
    placeholderText: "Select due date",
    autoComplete: "off"
    // open={isManualDatePickerOpen}
    //inline
  })), /*#__PURE__*/React.createElement("div", {
    className: "quick-edit-time-div-modal-save-button "
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    onClick: function onClick() {
      handleDueDateSubmit();
    },
    disabled: addTaskDueDateLoading
  }, addTaskDueDateLoading ? "Loading..." : "Save Changes"))) : isQuickEditModal == "editPriority" ? /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      priority: ""
    },
    onSubmit: handlePrioritySubmit
  }, function (_ref27) {
    var setFieldValue = _ref27.setFieldValue,
      errors = _ref27.errors;
    return /*#__PURE__*/React.createElement(FormikForm, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12,
      className: "tasks-modal-cols"
    }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, /*#__PURE__*/React.createElement("div", {
      className: ""
    }, /*#__PURE__*/React.createElement(Field, {
      name: "priority"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(FormGroup, {
        className: "quick-project-task-section-whole-input-div"
      }, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "project-task-modals-edit-task-label-name"
      }, "Priority"), meta.error && meta.touched ? /*#__PURE__*/React.createElement(ControlLabel, {
        className: "error"
      }, meta.error) : null, /*#__PURE__*/React.createElement(FormControl, _extends({
        as: "select",
        defaultValue: "",
        required: true
      }, field), /*#__PURE__*/React.createElement("option", {
        value: null
      }, "None"), taskPriority.map(function (task) {
        return /*#__PURE__*/React.createElement("option", {
          value: task.value
        }, task.label);
      })));
    })))), /*#__PURE__*/React.createElement(Row, {
      className: ""
    }, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12,
      className: "projects-create-col"
    }, /*#__PURE__*/React.createElement("div", {
      className: "quick-edit-time-div-modal-save-button "
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "primary"
      //className="project-task-modals-save-button"
      ,
      type: "submit",
      disabled: addTaskPriorityLoading
    }, addTaskPriorityLoading ? "Loading..." : "Save Changes"), " "), errors.formError ? /*#__PURE__*/React.createElement("div", {
      className: "form-error my-projects-modal-form-error"
    }, errors.formError) : null)))));
  }) : isQuickEditModal == "editStatus" ? /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      status: ""
    },
    onSubmit: handleStatusSubmit
  }, function (_ref28) {
    var setFieldValue = _ref28.setFieldValue,
      errors = _ref28.errors;
    return /*#__PURE__*/React.createElement(FormikForm, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12,
      className: "tasks-modal-cols"
    }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, /*#__PURE__*/React.createElement("div", {
      className: "project-task-modals-root-body"
    }, /*#__PURE__*/React.createElement(Field, {
      name: "status"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
        className: "project-details-edit-task-label-name"
      }, " Task Status"), meta.error && meta.touched ? /*#__PURE__*/React.createElement(Form.Label, {
        className: "error"
      }, meta.error) : null, /*#__PURE__*/React.createElement(Form.Control, _extends({
        as: "select",
        placeholder: "Select a status",
        className: "project-details-edit-task-label-input"
      }, field), taskStatusToDoList.map(function (taskStatus) {
        return /*#__PURE__*/React.createElement("option", {
          key: taskStatus.value,
          value: taskStatus.value
        }, taskStatus.label);
      })));
    }), /*#__PURE__*/React.createElement("p", {
      className: "project-task-modals-root-body-p"
    }, " ", "Email notifications will not be sent when using the Quick Edit option.")))), /*#__PURE__*/React.createElement(Row, {
      className: ""
    }, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12,
      className: "projects-create-col"
    }, /*#__PURE__*/React.createElement("div", {
      className: "quick-edit-time-div-modal-save-button "
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "primary"
      //className="project-task-modals-save-button"
      ,
      type: "submit",
      disabled: addTaskStatusLoading
    }, addTaskStatusLoading ? "Loading..." : "Save Changes"), " "), errors.formError ? /*#__PURE__*/React.createElement("div", {
      className: "form-error my-projects-modal-form-error"
    }, errors.formError) : null)))));
  }) : isQuickEditModal == "quickDelete" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
    className: "quick-delete-text"
  }, "You have selected", " ", quickEditType == "upcomingTasks" ? toDoTaskActive.length : quickEditType == "inProgressTasks" ? inProgessTaskActive.length : quickEditType == "onDue" ? overDueTaskActive.length : quickEditType == "completed" ? completedTaskActive.length : quickEditType == "hold" ? holdTaskActive.length : taskActive.length, " ", "task(s). Are you sure to delete those task(s)?", " ")), /*#__PURE__*/React.createElement("div", {
    className: "quick-edit-time-div-modal-save-button "
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "danger",
    onClick: function onClick() {
      handleDeleteSubmit();
    },
    disabled: addTaskDeleteLoading
  }, addTaskDeleteLoading ? "Loading..." : "Delete Task"))) : null));
};
var QuickEditTaskButtons = function QuickEditTaskButtons(props) {
  var taskActive = props.taskActive,
    setIsQuickEditModal = props.setIsQuickEditModal,
    setIsQuickEditMemberModal = props.setIsQuickEditMemberModal,
    quickEditWorkingStatus = props.quickEditWorkingStatus,
    quickEditType = props.quickEditType,
    isQuickEditSelect = props.isQuickEditSelect,
    setIsQuickEditSelect = props.setIsQuickEditSelect,
    setTaskActive = props.setTaskActive,
    projectTasks = props.projectTasks,
    isQuickEditToDoSelect = props.isQuickEditToDoSelect,
    setIsQuickEditToDoSelect = props.setIsQuickEditToDoSelect,
    isQuickEditInProgressSelect = props.isQuickEditInProgressSelect,
    setIsQuickEditInProgressSelect = props.setIsQuickEditInProgressSelect,
    isQuickEditDueSelect = props.isQuickEditDueSelect,
    setIsQuickEditDueSelect = props.setIsQuickEditDueSelect,
    isQuickEditCompletedSelect = props.isQuickEditCompletedSelect,
    setIsQuickEditCompletedSelect = props.setIsQuickEditCompletedSelect,
    isQuickEditHoldSelect = props.isQuickEditHoldSelect,
    setIsQuickEditHoldSelect = props.setIsQuickEditHoldSelect,
    setToDoTaskActive = props.setToDoTaskActive,
    setInProgessTaskActive = props.setInProgessTaskActive,
    setOverDueTaskActive = props.setOverDueTaskActive,
    setCompletedTaskActive = props.setCompletedTaskActive,
    setHoldTaskActive = props.setHoldTaskActive,
    setQuickEditWorkingStatus = props.setQuickEditWorkingStatus,
    setQuickEditToDoWorkingStatus = props.setQuickEditToDoWorkingStatus,
    setQuickEditInProgressWorkingStatus = props.setQuickEditInProgressWorkingStatus,
    setQuickEditDueWorkingStatus = props.setQuickEditDueWorkingStatus,
    setQuickEditCompletedWorkingStatus = props.setQuickEditCompletedWorkingStatus,
    setQuickEditHoldWorkingStatus = props.setQuickEditHoldWorkingStatus,
    allowEmployeesToManageTheirTasks = props.allowEmployeesToManageTheirTasks,
    role = props.role;
  React.useEffect(function () {
    if (quickEditType == "taskList") {
      if (isQuickEditSelect == "unSelect") {
        setTaskActive([]);
        setIsQuickEditSelect("select");
      } else if (isQuickEditSelect == "allSelect") {
        var taskIds = [];
        var workingIds = [];
        for (var i = 0; i < projectTasks.length; i++) {
          if (projectTasks[i].taskType != "automatic") {
            taskIds.push(projectTasks[i].taskId);
          }
          if (projectTasks[i].taskProgress == "ongoing") {
            workingIds.push(projectTasks[i].taskId);
          }
        }
        setQuickEditWorkingStatus(workingIds);
        setTaskActive(taskIds);
      } else {
        setIsQuickEditSelect("select");
      }
    }
    if (quickEditType == "upcomingTasks") {
      if (isQuickEditToDoSelect == "unSelect") {
        setToDoTaskActive([]);
        setIsQuickEditToDoSelect("select");
      } else if (isQuickEditToDoSelect == "allSelect") {
        var _taskIds = [];
        var _workingIds = [];
        for (var i = 0; i < projectTasks.length; i++) {
          if (projectTasks[i].taskType != "automatic") {
            _taskIds.push(projectTasks[i].taskId);
          }
          if (projectTasks[i].taskProgress == "ongoing") {
            _workingIds.push(projectTasks[i].taskId);
          }
        }
        setQuickEditToDoWorkingStatus(_workingIds);
        setToDoTaskActive(_taskIds);
      } else {
        setIsQuickEditToDoSelect("select");
      }
    }
    if (quickEditType == "inProgressTasks") {
      if (isQuickEditInProgressSelect == "unSelect") {
        setInProgessTaskActive([]);
        setIsQuickEditInProgressSelect("select");
      } else if (isQuickEditInProgressSelect == "allSelect") {
        var _taskIds2 = [];
        var _workingIds2 = [];
        for (var i = 0; i < projectTasks.length; i++) {
          if (projectTasks[i].taskType != "automatic") {
            _taskIds2.push(projectTasks[i].taskId);
          }
          if (projectTasks[i].taskProgress == "ongoing") {
            _workingIds2.push(projectTasks[i].taskId);
          }
        }
        setQuickEditInProgressWorkingStatus(_workingIds2);
        setInProgessTaskActive(_taskIds2);
      } else {
        setIsQuickEditInProgressSelect("select");
      }
    }
    if (quickEditType == "onDue") {
      if (isQuickEditDueSelect == "unSelect") {
        setOverDueTaskActive([]);
        setIsQuickEditDueSelect("select");
      } else if (isQuickEditDueSelect == "allSelect") {
        var _taskIds3 = [];
        var _workingIds3 = [];
        for (var i = 0; i < projectTasks.length; i++) {
          if (projectTasks[i].taskType != "automatic") {
            _taskIds3.push(projectTasks[i].taskId);
          }
          if (projectTasks[i].taskProgress == "ongoing") {
            _workingIds3.push(projectTasks[i].taskId);
          }
        }
        setQuickEditDueWorkingStatus(_workingIds3);
        setOverDueTaskActive(_taskIds3);
      } else {
        setIsQuickEditDueSelect("select");
      }
    }
    if (quickEditType == "completed") {
      if (isQuickEditCompletedSelect == "unSelect") {
        setCompletedTaskActive([]);
        setIsQuickEditCompletedSelect("select");
      } else if (isQuickEditCompletedSelect == "allSelect") {
        var _taskIds4 = [];
        var _workingIds4 = [];
        for (var i = 0; i < projectTasks.length; i++) {
          if (projectTasks[i].taskType != "automatic") {
            _taskIds4.push(projectTasks[i].taskId);
          }
          if (projectTasks[i].taskProgress == "ongoing") {
            _workingIds4.push(projectTasks[i].taskId);
          }
        }
        setQuickEditCompletedWorkingStatus(_workingIds4);
        setCompletedTaskActive(_taskIds4);
      } else {
        setIsQuickEditCompletedSelect("select");
      }
    }
    if (quickEditType == "hold") {
      if (isQuickEditHoldSelect == "unSelect") {
        setHoldTaskActive([]);
        setIsQuickEditHoldSelect("select");
      } else if (isQuickEditHoldSelect == "allSelect") {
        var _taskIds5 = [];
        var _workingIds5 = [];
        for (var i = 0; i < projectTasks.length; i++) {
          if (projectTasks[i].taskType != "automatic") {
            _taskIds5.push(projectTasks[i].taskId);
          }
          if (projectTasks[i].taskProgress == "ongoing") {
            _workingIds5.push(projectTasks[i].taskId);
          }
        }
        setQuickEditHoldWorkingStatus(_workingIds5);
        setHoldTaskActive(_taskIds5);
      } else {
        setIsQuickEditHoldSelect("select");
      }
    }
  }, [isQuickEditSelect, isQuickEditToDoSelect, isQuickEditInProgressSelect, isQuickEditDueSelect, isQuickEditCompletedSelect, isQuickEditHoldSelect]);
  return /*#__PURE__*/React.createElement("div", {
    className: "quick-edit-task-buttons-root"
  }, /*#__PURE__*/React.createElement("div", {
    className: "quick-edit-project-details-input-div quick-edit-check-box-root"
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    id: quickEditType,
    name: "myRadioGroup",
    className: "create-project-team-selection-control-checkbox",
    checked: quickEditType == "taskList" ? isQuickEditSelect : quickEditType == "upcomingTasks" ? isQuickEditToDoSelect : quickEditType == "inProgressTasks" ? isQuickEditInProgressSelect : quickEditType == "onDue" ? isQuickEditDueSelect : quickEditType == "completed" ? isQuickEditCompletedSelect : quickEditType == "hold" ? isQuickEditHoldSelect : null,
    onChange: function onChange() {
      if (quickEditType == "taskList") {
        setIsQuickEditSelect(isQuickEditSelect == "select" ? "allSelect" : "unSelect");
      } else if (quickEditType == "upcomingTasks") {
        setIsQuickEditToDoSelect(isQuickEditToDoSelect == "select" ? "allSelect" : "unSelect");
      } else if (quickEditType == "inProgressTasks") {
        setIsQuickEditInProgressSelect(isQuickEditInProgressSelect == "select" ? "allSelect" : "unSelect");
      } else if (quickEditType == "onDue") {
        setIsQuickEditDueSelect(isQuickEditDueSelect == "select" ? "allSelect" : "unSelect");
      } else if (quickEditType == "completed") {
        setIsQuickEditCompletedSelect(isQuickEditCompletedSelect == "select" ? "allSelect" : "unSelect");
      } else if (quickEditType == "hold") {
        setIsQuickEditHoldSelect(isQuickEditHoldSelect == "select" ? "allSelect" : "unSelect");
      }
    }
  })), /*#__PURE__*/React.createElement("span", {
    className: "quick-edit-task-buttons-root-count"
  }, taskActive.length), quickEditWorkingStatus.length ? /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-start"
    }, "Someone is working on the one of the selected tasks, please unselect that task to edit the status.")
  }, /*#__PURE__*/React.createElement("div", {
    className: "quick-edit-task-buttons-root-specify-button quick-edit-tooltip-button"
  }, "Edit Status")) : /*#__PURE__*/React.createElement(Button, {
    variant: " ",
    className: "rounded-pill px-3 quick-edit-task-buttons-root-specify-button ",
    size: "sm",
    onClick: function onClick() {
      setIsQuickEditModal("editStatus");
    }
  }, "Edit Status"), /*#__PURE__*/React.createElement(Button, {
    variant: " ",
    className: "rounded-pill px-3 quick-edit-task-buttons-root-specify-button ",
    size: "sm",
    onClick: function onClick() {
      setIsQuickEditModal("editEstimation");
    }
  }, "Edit Estimation"), /*#__PURE__*/React.createElement(Button, {
    variant: " ",
    className: "rounded-pill px-3 quick-edit-task-buttons-root-specify-button ",
    size: "sm",
    onClick: function onClick() {
      setIsQuickEditModal("editDueDate");
    }
  }, "Edit DueDate"), /*#__PURE__*/React.createElement(Button, {
    variant: " ",
    className: "rounded-pill px-3 quick-edit-task-buttons-root-specify-button ",
    size: "sm",
    onClick: function onClick() {
      setIsQuickEditModal("editPriority");
    }
  }, "Edit Priority"), /*#__PURE__*/React.createElement(Button, {
    variant: " ",
    className: "rounded-pill px-3 quick-edit-task-buttons-root-specify-button ",
    size: "sm",
    onClick: function onClick() {
      setIsQuickEditMemberModal("editMember");
    }
  }, "Edit Members"), quickEditWorkingStatus.length ? /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-start"
    }, "Someone is working on the one of the selected tasks, please unselect that task to delete.")
  }, /*#__PURE__*/React.createElement("div", {
    className: "quick-edit-task-buttons-root-specify-button quick-edit-tooltip-button"
  }, "Delete")) : /*#__PURE__*/React.createElement(Button, {
    variant: " ",
    className: "rounded-pill px-3 quick-edit-task-buttons-root-specify-button ",
    size: "sm",
    onClick: function onClick() {
      setIsQuickEditModal("quickDelete");
    }
  }, "Delete"));
};
export var SetRateModal = function SetRateModal(_ref29) {
  var _data$rateSummaryDeta;
  var showRateModal = _ref29.showRateModal,
    handleRateClose = _ref29.handleRateClose,
    currenciesData = _ref29.currenciesData;
  // Always call hooks — never conditionally
  var _React$useContext15 = React.useContext(FilterContext),
    role = _React$useContext15.role;
  var projectId = (showRateModal === null || showRateModal === void 0 ? void 0 : showRateModal.projectId) || "";
  var organisationId = (showRateModal === null || showRateModal === void 0 ? void 0 : showRateModal.organisationId) || "";

  // Always call query, use skip to prevent running when not needed
  var _useQuery17 = useQuery(RATE_DETAILS_SUMMARY_QUERY, {
      variables: {
        organisationId: organisationId,
        projectId: projectId
      },
      skip: !organisationId || !projectId
    }),
    data = _useQuery17.data,
    loading = _useQuery17.loading,
    error = _useQuery17.error;

  // Always call mutation
  var _useMutation29 = useMutation(SET_RATE_MUTATION),
    _useMutation30 = _slicedToArray(_useMutation29, 2),
    setRateDetails = _useMutation30[0],
    setRateDetailsLoading = _useMutation30[1].loading;

  // Don’t return early — just conditionally render content later
  var membersList = (_data$rateSummaryDeta = data === null || data === void 0 ? void 0 : data.rateSummaryDetails) !== null && _data$rateSummaryDeta !== void 0 ? _data$rateSummaryDeta : [];
  var validationSchema = Yup.object().shape({
    members: Yup.array().of(Yup.object().shape({
      billableRate: Yup.number().typeError("Rate must be a number").min(0, "Rate cannot be negative").required("Rate is required")
    }))
  });
  var handleSetRateSubmit = React.useCallback( /*#__PURE__*/function () {
    var _ref30 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee22(values, actions) {
      var _response$data7, originalMembers, changedMembers, response;
      return _regeneratorRuntime().wrap(function _callee22$(_context22) {
        while (1) switch (_context22.prev = _context22.next) {
          case 0:
            _context22.prev = 0;
            if (!setRateDetailsLoading) {
              _context22.next = 3;
              break;
            }
            return _context22.abrupt("return");
          case 3:
            // Get original list from the query (current DB data)
            originalMembers = (data === null || data === void 0 ? void 0 : data.rateSummaryDetails) || []; // Compare and find only changed members
            changedMembers = values.members.filter(function (m) {
              var original = originalMembers.find(function (o) {
                return o.userId === m.userId;
              });
              return !original || Number(original.billableRate) !== Number(m.billableRate);
            }); // If nothing changed, skip API call
            if (!(changedMembers.length === 0)) {
              _context22.next = 10;
              break;
            }
            toast.info("No changes detected.");
            actions.setSubmitting(false);
            handleRateClose();
            return _context22.abrupt("return");
          case 10:
            _context22.next = 12;
            return setRateDetails({
              variables: {
                projectId: projectId,
                organisationId: organisationId,
                members: changedMembers.map(function (m) {
                  return {
                    userId: m.userId,
                    billableRate: Number(m.billableRate) || 0
                  };
                })
              },
              refetchQueries: [{
                query: RATE_DETAILS_SUMMARY_QUERY,
                variables: {
                  projectId: projectId,
                  organisationId: organisationId
                }
              }],
              awaitRefetchQueries: true
            });
          case 12:
            response = _context22.sent;
            if (response !== null && response !== void 0 && (_response$data7 = response.data) !== null && _response$data7 !== void 0 && _response$data7.setRateDetails) {
              _context22.next = 15;
              break;
            }
            throw new Error("Failed to save rates");
          case 15:
            toast.success("Hourly rates updated successfully!");
            handleRateClose();
            _context22.next = 23;
            break;
          case 19:
            _context22.prev = 19;
            _context22.t0 = _context22["catch"](0);
            console.error(" Error saving rates:", _context22.t0);
            toast.error("Failed to update rates. Please try again.");
          case 23:
            _context22.prev = 23;
            actions.setSubmitting(false);
            return _context22.finish(23);
          case 26:
          case "end":
            return _context22.stop();
        }
      }, _callee22, null, [[0, 19, 23, 26]]);
    }));
    return function (_x16, _x17) {
      return _ref30.apply(this, arguments);
    };
  }(), [setRateDetails, setRateDetailsLoading, projectId, organisationId, handleRateClose, data === null || data === void 0 ? void 0 : data.rateSummaryDetails]);

  // Render only when modal is open
  if (!showRateModal) return null;

  // Then show loader/error/content
  if (loading) return /*#__PURE__*/React.createElement(Loader, null);
  if (error) return /*#__PURE__*/React.createElement("div", {
    className: "common-err-refresh-text"
  }, "Something went wrong, please refresh the page.");
  return /*#__PURE__*/React.createElement(Modal, {
    show: !!showRateModal,
    onHide: handleRateClose,
    size: "md",
    centered: true,
    className: "my-projects-modal-root"
  }, /*#__PURE__*/React.createElement(Formik, {
    enableReinitialize: true,
    initialValues: {
      members: membersList.map(function (u) {
        var _u$billableRate;
        return {
          userId: u.userId,
          displayName: u.displayName,
          profileUrl: u.profileUrl,
          billableRate: (_u$billableRate = u.billableRate) !== null && _u$billableRate !== void 0 ? _u$billableRate : 0
        };
      })
    },
    validationSchema: validationSchema,
    onSubmit: handleSetRateSubmit
  }, function (_ref31) {
    var values = _ref31.values,
      setFieldValue = _ref31.setFieldValue;
    return /*#__PURE__*/React.createElement(FormikForm, null, /*#__PURE__*/React.createElement(Modal.Header, {
      className: "my-projects-modal-header",
      closeButton: true
    }, /*#__PURE__*/React.createElement(Modal.Title, {
      className: "my-projects-modal-title-set-rate"
    }, "Set Hourly Rates", /*#__PURE__*/React.createElement("div", {
      className: "my-projects-modal-title-p-div-set-rate"
    }, "Configure hourly rates for each team member to track project spending."))), /*#__PURE__*/React.createElement(Modal.Body, {
      className: "project-details-task-card-delete-body"
    }, values.members.map(function (member, index) {
      var _member$displayName, _member$displayName$t;
      return /*#__PURE__*/React.createElement("div", {
        key: member.userId,
        className: "set-hourly-rates-member-row"
      }, member.profileUrl ? /*#__PURE__*/React.createElement("div", {
        className: "set-hourly-rates-member-info"
      }, /*#__PURE__*/React.createElement("img", {
        alt: "profile",
        src: member.profileUrl,
        className: "team-card-avatar-profile-img"
      })) : /*#__PURE__*/React.createElement("div", {
        className: "set-hourly-rates-member-info"
      }, (_member$displayName = member.displayName) === null || _member$displayName === void 0 ? void 0 : (_member$displayName$t = _member$displayName.trim()) === null || _member$displayName$t === void 0 ? void 0 : _member$displayName$t.charAt(0)), /*#__PURE__*/React.createElement("div", {
        className: "set-hourly-rates-member-info-name"
      }, /*#__PURE__*/React.createElement("div", {
        className: "set-hourly-rates-name"
      }, member.displayName)), /*#__PURE__*/React.createElement("div", {
        className: "set-hourly-rates-input"
      }, /*#__PURE__*/React.createElement("span", {
        className: "currency-symbol"
      }, currenciesData == "EUR" ? "€" : currenciesData == "GBP" ? "£" : currenciesData == "INR" ? "₹" : currenciesData == "BRL" ? "R$" : currenciesData == "ZAR" ? "R " : currenciesData == "SEK" ? "kr " : currenciesData == "NGN" ? "₦" : currenciesData == "PHP" ? "₱" : currenciesData == "MYR" ? "RM " : currenciesData == "SGD" ? "S$" : currenciesData == "LKR" ? "Rs " : "$"), /*#__PURE__*/React.createElement(Field, {
        name: "members[".concat(index, "].billableRate")
      }, function (_ref32) {
        var _field$value;
        var field = _ref32.field,
          meta = _ref32.meta;
        return /*#__PURE__*/React.createElement(FormGroup, {
          className: "set-hourly-rates-input-form"
        }, /*#__PURE__*/React.createElement(FormControl, _extends({}, field, {
          type: "number",
          min: "0",
          className: "set-hourly-rates-input-field",
          value: (_field$value = field.value) !== null && _field$value !== void 0 ? _field$value : "",
          onChange: function onChange(e) {
            return setFieldValue("members[".concat(index, "].billableRate"), e.target.value === "" ? "" : Number(e.target.value));
          }
        })), meta.touched && meta.error && /*#__PURE__*/React.createElement("div", {
          className: "error-text"
        }, meta.error));
      }), /*#__PURE__*/React.createElement("span", {
        className: "per-hour-text"
      }, "/hr")));
    })), /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement(Button, {
      variant: "outline-secondary",
      onClick: handleRateClose
    }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
      variant: "primary",
      type: "submit",
      disabled: setRateDetailsLoading
    }, setRateDetailsLoading ? "Saving..." : "Save Rates")));
  }));
};
var ProjectDetailsWrapper = function ProjectDetailsWrapper(props) {
  var _props$match2;
  // if (props?.from === "desktop") {
  //   return <ProjectDetails from={props?.from} url={props.url} />;
  // } else {
  var _props$match$params2 = props === null || props === void 0 ? void 0 : (_props$match2 = props.match) === null || _props$match2 === void 0 ? void 0 : _props$match2.params,
    url = _props$match$params2.url;
  //   return (
  //     <ProjectSideMenu disableTeamView history={props.history} match={props.match}>
  //       {(user) => {
  return /*#__PURE__*/React.createElement(ProjectDetails, _extends({
    url: url
  }, props));
  //       }}
  //     </ProjectSideMenu>
  //   );
  // }
};
export default ProjectDetailsWrapper;